
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bzBXX", function(module, exports) {
"use strict";
var $86d069d837ee3a27$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $86d069d837ee3a27$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $86d069d837ee3a27$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return (parcelRequire("a8w1Q")).createApp;
    }
});

$86d069d837ee3a27$var$__exportStar((parcelRequire("j1eoF")), module.exports);

$86d069d837ee3a27$var$__exportStar((parcelRequire("a8w1Q")), module.exports);

});
parcelRegister("a8w1Q", function(module, exports) {
"use strict";
var $76137f00f239e3a9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $76137f00f239e3a9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $76137f00f239e3a9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});


$76137f00f239e3a9$var$__exportStar((parcelRequire("daVWq")), module.exports);

$76137f00f239e3a9$var$__exportStar((parcelRequire("6JdjS")), module.exports);
module.exports.default = (parcelRequire("6JdjS")).createClientApp;

});
parcelRegister("6JdjS", function(module, exports) {
"use strict";
var $4e61470797d8bf1e$var$__assign = module.exports && module.exports.__assign || function() {
    $4e61470797d8bf1e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4e61470797d8bf1e$var$__assign.apply(this, arguments);
};
var $4e61470797d8bf1e$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $4e61470797d8bf1e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createApp = module.exports.createAppWrapper = module.exports.createClientApp = module.exports.WINDOW_UNDEFINED_MESSAGE = void 0;

var $jrseT = parcelRequire("jrseT");

var $5hZgj = parcelRequire("5hZgj");

var $1maiX = parcelRequire("1maiX");

var $j1eoF = parcelRequire("j1eoF");

var $h5eU1 = parcelRequire("h5eU1");

var $hJArC = parcelRequire("hJArC");

var $1Ono8 = parcelRequire("1Ono8");

var $7LSs8 = parcelRequire("7LSs8");

var $lgJh4 = parcelRequire("lgJh4");

var $aWaAl = parcelRequire("aWaAl");

var $daVWq = parcelRequire("daVWq");

var $4e61470797d8bf1e$var$Hooks_1 = $4e61470797d8bf1e$var$__importDefault((parcelRequire("jEstl")));
module.exports.WINDOW_UNDEFINED_MESSAGE = 'window is not defined. Running an app outside a browser is not supported';
function $4e61470797d8bf1e$var$redirectHandler(hostFrame, config) {
    var apiKey = config.apiKey, host = config.host, _a = config.forceRedirect, forceRedirect = _a === void 0 ? !$hJArC.isDevelopmentClient : _a;
    var location = $aWaAl.getLocation();
    if ($hJArC.isUnframed || !location || !apiKey || !host || !forceRedirect || !$aWaAl.shouldRedirect(hostFrame)) return false;
    var url = "https://" + host + "/apps/" + apiKey + location.pathname + (location.search || '');
    $aWaAl.redirect(url);
    return true;
}
var $4e61470797d8bf1e$var$actionWrapper = function(next) {
    return function(action) {
        return next($4e61470797d8bf1e$var$__assign($4e61470797d8bf1e$var$__assign({}, action), {
            version: $jrseT.getVersion(),
            clientInterface: {
                name: $jrseT.getPackageName(),
                version: $jrseT.getVersion()
            }
        }));
    };
};
var $4e61470797d8bf1e$var$actionWrappingMiddleware = function(hooks) {
    hooks.set($daVWq.LifecycleHook.DispatchAction, $4e61470797d8bf1e$var$actionWrapper);
};
function $4e61470797d8bf1e$var$appSetUp(app) {
    app.subscribe($5hZgj.Action.APP, $lgJh4.handleAppPrint);
    app.dispatch($1Ono8.initialize());
    try {
        $7LSs8.initializeWebVitals(app);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('App-Bridge failed to initialize web-vitals', err);
    }
}
/**
 * @internal
 */ var $4e61470797d8bf1e$var$createClientApp = function(transport, middlewares) {
    if (middlewares === void 0) middlewares = [];
    var getStateListeners = [];
    var transportListener = $j1eoF.createTransportListener();
    var handler = function(event) {
        var message = event.data;
        var type = message.type, payload = message.payload;
        switch(type){
            case 'getState':
                var resolvers = getStateListeners.splice(0);
                resolvers.forEach(function(resolver) {
                    return resolver(payload);
                });
                break;
            case 'dispatch':
                transportListener.handleMessage(payload);
                var hasCallback = transportListener.handleActionDispatch(payload);
                if (hasCallback) return;
                // Throw an error if there are no subscriptions to this error
                var errorType = $jrseT.findMatchInEnum($1maiX.Action, payload.type);
                if (errorType) $1maiX.throwError(errorType, payload);
                break;
            default:
        }
    };
    transport.subscribe(handler);
    return function(config) {
        var decodedConfig = $4e61470797d8bf1e$var$validateAndDecodeConfig(config);
        var isRedirecting = $4e61470797d8bf1e$var$redirectHandler(transport.hostFrame, decodedConfig);
        if (isRedirecting) return $h5eU1.mockAppBridge;
        var dispatcher = $4e61470797d8bf1e$var$createDispatcher(transport, decodedConfig);
        var subscribe = transportListener.createSubscribeHandler(dispatcher);
        // It is possible to initialize an app multiple times
        // Therefore we need to clear subscriptions to be safe
        dispatcher($daVWq.MessageType.Unsubscribe);
        function dispatch(action) {
            dispatcher($daVWq.MessageType.Dispatch, action);
            return action;
        }
        var hostOrigin = new URL("https://" + decodedConfig.host).origin;
        var hooks = new $4e61470797d8bf1e$var$Hooks_1.default();
        var app = {
            hostOrigin: hostOrigin,
            localOrigin: transport.localOrigin,
            hooks: hooks,
            dispatch: function(action) {
                if (!app.hooks) return dispatch(action);
                return app.hooks.run($daVWq.LifecycleHook.DispatchAction, dispatch, app, action);
            },
            featuresAvailable: function() {
                var features = [];
                for(var _i = 0; _i < arguments.length; _i++)features[_i] = arguments[_i];
                var firstItem = features[0];
                var parsedFeatures = Array.isArray(firstItem) ? $4e61470797d8bf1e$var$__spreadArray([], firstItem) : features;
                return app.getState('features').then(function(state) {
                    if (parsedFeatures.length) return parsedFeatures.reduce(function(acc, feature) {
                        if (Object.keys(state).includes(feature)) acc[feature] = state[feature];
                        return acc;
                    }, {});
                    return state;
                });
            },
            getState: function(query) {
                if (query && typeof query !== 'string') return Promise.resolve(undefined);
                return new Promise(function(resolve) {
                    getStateListeners.push(resolve);
                    dispatcher($daVWq.MessageType.GetState);
                }).then(function(state) {
                    var newState = state;
                    if (query) for(var _i = 0, _a = query.split('.'); _i < _a.length; _i++){
                        var key = _a[_i];
                        if (newState == null || typeof newState !== 'object' || Array.isArray(newState) || !Object.keys(newState).includes(key)) return undefined;
                        newState = newState[key];
                    }
                    return newState;
                });
            },
            subscribe: subscribe,
            error: function(listener, id) {
                var unsubscribeCb = [];
                $jrseT.forEachInEnum($1maiX.Action, function(eventNameSpace) {
                    unsubscribeCb.push(subscribe(eventNameSpace, listener, id));
                });
                return function() {
                    unsubscribeCb.forEach(function(unsubscribe) {
                        return unsubscribe();
                    });
                };
            }
        };
        for(var _i = 0, middlewares_1 = middlewares; _i < middlewares_1.length; _i++){
            var middleware = middlewares_1[_i];
            middleware(hooks, app);
        }
        $4e61470797d8bf1e$var$appSetUp(app);
        return app;
    };
};
module.exports.createClientApp = $4e61470797d8bf1e$var$createClientApp;
/**
 * @internal
 */ function $4e61470797d8bf1e$var$validateAndDecodeConfig(config) {
    var _a;
    if (!config.host) throw $1maiX.fromAction('host must be provided', $1maiX.AppActionType.INVALID_CONFIG);
    if (!config.apiKey) throw $1maiX.fromAction('apiKey must be provided', $1maiX.AppActionType.INVALID_CONFIG);
    try {
        var host = atob((_a = config.host) === null || _a === void 0 ? void 0 : _a.replace(/_/g, '/').replace(/-/g, '+'));
        return $4e61470797d8bf1e$var$__assign($4e61470797d8bf1e$var$__assign({}, config), {
            host: host
        });
    } catch (_b) {
        var message = "not a valid host, please use the value provided by Shopify";
        throw $1maiX.fromAction(message, $1maiX.AppActionType.INVALID_CONFIG);
    }
}
/**
 * @public
 */ function $4e61470797d8bf1e$var$createAppWrapper(frame, localOrigin, middleware) {
    if (middleware === void 0) middleware = [];
    if (!frame) throw $1maiX.fromAction(module.exports.WINDOW_UNDEFINED_MESSAGE, $1maiX.AppActionType.WINDOW_UNDEFINED);
    var location = $aWaAl.getLocation();
    var origin = localOrigin || location && location.origin;
    if (!origin) throw $1maiX.fromAction('local origin cannot be blank', $1maiX.AppActionType.MISSING_LOCAL_ORIGIN);
    var transport = $j1eoF.fromWindow(frame, origin);
    var appCreator = module.exports.createClientApp(transport, $4e61470797d8bf1e$var$__spreadArray([
        $4e61470797d8bf1e$var$actionWrappingMiddleware
    ], middleware));
    return appCreator;
}
module.exports.createAppWrapper = $4e61470797d8bf1e$var$createAppWrapper;
/**
 * Creates your application instance.
 * @param config - `apiKey` and `host` are both required.
 * @remarks
 * You will need to store `host` during the authentication process and then retrieve it for the code to work properly. To learn more about this process, see {@link https://help.shopify.com/api/embedded-apps/shop-origin | Getting and storing the shop origin}.
 * @public
 */ function $4e61470797d8bf1e$var$createApp(config) {
    var currentWindow = $aWaAl.getWindow();
    if (!currentWindow || !currentWindow.top) return $h5eU1.serverAppBridge;
    return $4e61470797d8bf1e$var$createAppWrapper(currentWindow.top)(config);
}
module.exports.createApp = $4e61470797d8bf1e$var$createApp;
function $4e61470797d8bf1e$var$createDispatcher(transport, config) {
    return function(type, payload) {
        transport.dispatch({
            payload: payload,
            source: config,
            type: type
        });
    };
}
/**
 * {@inheritdocs createApp}
 * @public
 */ module.exports.default = $4e61470797d8bf1e$var$createApp;

});
parcelRegister("jrseT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPackageName = module.exports.getVersion = module.exports.getMergedProps = module.exports.updateActionFromPayload = module.exports.isValidOptionalString = module.exports.isValidOptionalNumber = module.exports.NonSnakeCaseGroup = module.exports.getEventNameSpace = module.exports.forEachInEnum = module.exports.findMatchInEnum = module.exports.actionWrapper = void 0;

var $ditiI = parcelRequire("ditiI");
Object.defineProperty(module.exports, "actionWrapper", {
    enumerable: true,
    get: function() {
        return $ditiI.actionWrapper;
    }
});
Object.defineProperty(module.exports, "findMatchInEnum", {
    enumerable: true,
    get: function() {
        return $ditiI.findMatchInEnum;
    }
});
Object.defineProperty(module.exports, "forEachInEnum", {
    enumerable: true,
    get: function() {
        return $ditiI.forEachInEnum;
    }
});
Object.defineProperty(module.exports, "getEventNameSpace", {
    enumerable: true,
    get: function() {
        return $ditiI.getEventNameSpace;
    }
});
Object.defineProperty(module.exports, "NonSnakeCaseGroup", {
    enumerable: true,
    get: function() {
        return $ditiI.NonSnakeCaseGroup;
    }
});
Object.defineProperty(module.exports, "isValidOptionalNumber", {
    enumerable: true,
    get: function() {
        return $ditiI.isValidOptionalNumber;
    }
});
Object.defineProperty(module.exports, "isValidOptionalString", {
    enumerable: true,
    get: function() {
        return $ditiI.isValidOptionalString;
    }
});
Object.defineProperty(module.exports, "updateActionFromPayload", {
    enumerable: true,
    get: function() {
        return $ditiI.updateActionFromPayload;
    }
});
Object.defineProperty(module.exports, "getMergedProps", {
    enumerable: true,
    get: function() {
        return $ditiI.getMergedProps;
    }
});

var $lf7w5 = parcelRequire("lf7w5");
function $e27671a3d3402588$var$getVersion() {
    return $lf7w5.version;
}
module.exports.getVersion = $e27671a3d3402588$var$getVersion;
function $e27671a3d3402588$var$getPackageName() {
    return $lf7w5.name;
}
module.exports.getPackageName = $e27671a3d3402588$var$getPackageName;

});
parcelRegister("ditiI", function(module, exports) {
"use strict";
var $9ae3af55554d0b39$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.updateActionFromPayload = module.exports.isValidOptionalString = module.exports.isValidOptionalNumber = module.exports.forEachInEnum = module.exports.getMergedProps = module.exports.findMatchInEnum = module.exports.getEventNameSpace = module.exports.NonSnakeCaseGroup = module.exports.actionWrapper = void 0;

var $9ae3af55554d0b39$var$merge_1 = $9ae3af55554d0b39$var$__importDefault((parcelRequire("ljdBF")));

var $jlQNT = parcelRequire("jlQNT");

var $f8QDr = parcelRequire("f8QDr");
function $9ae3af55554d0b39$var$actionWrapper(action) {
    return action;
}
module.exports.actionWrapper = $9ae3af55554d0b39$var$actionWrapper;
module.exports.NonSnakeCaseGroup = [
    $f8QDr.Group.AuthCode,
    $f8QDr.Group.Button,
    $f8QDr.Group.ButtonGroup,
    $f8QDr.Group.Cart,
    $f8QDr.Group.Error,
    $f8QDr.Group.Features,
    $f8QDr.Group.Fullscreen,
    $f8QDr.Group.Link,
    $f8QDr.Group.Loading,
    $f8QDr.Group.Menu,
    $f8QDr.Group.Modal,
    $f8QDr.Group.Navigation,
    $f8QDr.Group.Pos,
    $f8QDr.Group.Print,
    $f8QDr.Group.ResourcePicker,
    $f8QDr.Group.Scanner,
    $f8QDr.Group.SessionToken,
    $f8QDr.Group.Share,
    $f8QDr.Group.TitleBar,
    $f8QDr.Group.Toast,
    $f8QDr.Group.unstable_Picker
];
function $9ae3af55554d0b39$var$camelCaseToSnakeCase(value) {
    return value.replace(/([A-Z])/g, function(matcher, _val, index) {
        return "" + (index === 0 ? '' : '_') + matcher[0].toLowerCase();
    });
}
/**
 * Maps the group name to its event name
 * @internal
 * @remarks - This method is necessary for the new pattern of using snake case
 * which makes it more readable and easier to reconstruct the group from an event name.
 * Example: `ContextualSaveBar` becomes `CONTEXTUAL_SAVE_BAR`
 * */ function $9ae3af55554d0b39$var$groupToEventNameSpace(group) {
    if (module.exports.NonSnakeCaseGroup.includes(group)) return group.toUpperCase();
    return $9ae3af55554d0b39$var$camelCaseToSnakeCase(group).toUpperCase();
}
/**
 * Returns full event name with prefix, group, subgroups and type formatted with separators
 * @internal
 * */ function $9ae3af55554d0b39$var$getEventNameSpace(group, eventName, component) {
    if (eventName.startsWith("" + $jlQNT.PREFIX + $jlQNT.SEPARATOR)) return eventName;
    var eventNameSpace = $9ae3af55554d0b39$var$groupToEventNameSpace(group);
    if (component) {
        var subgroups_1 = component.subgroups, type = component.type;
        if (subgroups_1 && subgroups_1.length > 0) {
            eventNameSpace += eventNameSpace.length > 0 ? $jlQNT.SEPARATOR : '';
            subgroups_1.forEach(function(subgroup, index) {
                eventNameSpace += "" + subgroup.toUpperCase() + (index < subgroups_1.length - 1 ? $jlQNT.SEPARATOR : '');
            });
        }
        if (type !== group && type) eventNameSpace += "" + (eventNameSpace.length > 0 ? $jlQNT.SEPARATOR : '') + type.toUpperCase();
    }
    if (eventNameSpace) eventNameSpace += "" + (eventNameSpace.length > 0 ? $jlQNT.SEPARATOR : '') + eventName.toUpperCase();
    return "" + $jlQNT.PREFIX + $jlQNT.SEPARATOR + eventNameSpace;
}
module.exports.getEventNameSpace = $9ae3af55554d0b39$var$getEventNameSpace;
function $9ae3af55554d0b39$var$findMatchInEnum(types, lookup) {
    var match = Object.keys(types).find(function(key) {
        return lookup === types[key];
    });
    return match ? types[match] : undefined;
}
module.exports.findMatchInEnum = $9ae3af55554d0b39$var$findMatchInEnum;
function $9ae3af55554d0b39$var$getMergedProps(props, newProps) {
    var merged = $9ae3af55554d0b39$var$merge_1.default(props, newProps);
    if (!merged) {
        // tslint:disable-next-line:prefer-object-spread
        var cloned = Object.assign(props, newProps);
        return cloned;
    }
    return merged;
}
module.exports.getMergedProps = $9ae3af55554d0b39$var$getMergedProps;
function $9ae3af55554d0b39$var$forEachInEnum(types, callback) {
    Object.keys(types).forEach(function(key) {
        callback(types[key]);
    });
}
module.exports.forEachInEnum = $9ae3af55554d0b39$var$forEachInEnum;
function $9ae3af55554d0b39$var$isValidOptionalNumber(value) {
    return value === null || value === undefined || typeof value === 'number';
}
module.exports.isValidOptionalNumber = $9ae3af55554d0b39$var$isValidOptionalNumber;
function $9ae3af55554d0b39$var$isValidOptionalString(value) {
    return value === null || value === undefined || typeof value === 'string';
}
module.exports.isValidOptionalString = $9ae3af55554d0b39$var$isValidOptionalString;
function $9ae3af55554d0b39$var$updateActionFromPayload(action, newProps) {
    var id = action.id;
    if (id === newProps.id) {
        // Merge new properties
        Object.assign(action, $9ae3af55554d0b39$var$getMergedProps(action, newProps));
        return true;
    }
    return false;
}
module.exports.updateActionFromPayload = $9ae3af55554d0b39$var$updateActionFromPayload;

});
parcelRegister("ljdBF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Returns a deeply merged object with properties from the 2 provided objects
 * @remarks - Only deeply merge objects. The second argument overrides the
 * first if it is provided as `null`, `undefined` or an array.
 * @public
 * */ function $f835ed468b374667$var$mergeProps(obj, newObj) {
    if (newObj == null) return newObj;
    // If setting to a different prototype or a non-object or non-array, don't merge any props
    if (typeof obj === 'undefined' || !Object.prototype.isPrototypeOf.call(Object.getPrototypeOf(obj), newObj) || newObj.constructor.name !== 'Object' && newObj.constructor.name !== 'Array') return newObj;
    var clone = {};
    Object.keys(newObj).forEach(function(key) {
        var exists = Object.prototype.hasOwnProperty.call(obj, key);
        if (!exists) clone[key] = newObj[key];
        else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) clone[key] = $f835ed468b374667$var$mergeProps(obj[key], newObj[key]);
        else clone[key] = newObj[key];
    });
    // Copy old props that are not present in new object only if this is a simple object
    Object.keys(obj).forEach(function(key) {
        var exists = Object.prototype.hasOwnProperty.call(newObj, key);
        if (!exists) clone[key] = obj[key];
    });
    // Set prototype of cloned object to match original
    Object.setPrototypeOf(clone, Object.getPrototypeOf(obj));
    return clone;
}
module.exports.default = $f835ed468b374667$var$mergeProps;

});

parcelRegister("jlQNT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SEPARATOR = module.exports.PREFIX = void 0;
module.exports.PREFIX = 'APP';
module.exports.SEPARATOR = '::';

});

parcelRegister("f8QDr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComponentType = module.exports.Group = void 0;
/**
 * Various action groups.
 * @public
 */ var $b0606e970ac35bc0$var$Group;
(function(Group) {
    Group["AuthCode"] = "AuthCode";
    Group["Button"] = "Button";
    Group["ButtonGroup"] = "ButtonGroup";
    Group["Cart"] = "Cart";
    Group["Client"] = "Client";
    Group["ContextualSaveBar"] = "ContextualSaveBar";
    Group["Error"] = "Error";
    Group["Features"] = "Features";
    Group["FeedbackModal"] = "FeedbackModal";
    Group["Fullscreen"] = "Fullscreen";
    Group["LeaveConfirmation"] = "LeaveConfirmation";
    Group["Link"] = "Link";
    Group["Loading"] = "Loading";
    Group["Menu"] = "Menu";
    Group["Modal"] = "Modal";
    Group["Navigation"] = "Navigation";
    Group["Performance"] = "Performance";
    Group["Pos"] = "Pos";
    Group["Print"] = "Print";
    Group["ResourcePicker"] = "Resource_Picker";
    /**
     * @unstable This API may be updated without warning in the future
     */ Group["unstable_Picker"] = "unstable_Picker";
    Group["Scanner"] = "Scanner";
    Group["SessionToken"] = "SessionToken";
    Group["Share"] = "Share";
    Group["TitleBar"] = "TitleBar";
    Group["Toast"] = "Toast";
    Group["MarketingExternalActivityTopBar"] = "MarketingExternalActivityTopBar";
    Group["WebVitals"] = "WebVitals";
})($b0606e970ac35bc0$var$Group = module.exports.Group || (module.exports.Group = {}));
/**
 * @internal
 */ var $b0606e970ac35bc0$var$ComponentType;
(function(ComponentType) {
    ComponentType["Button"] = "Button";
    ComponentType["ButtonGroup"] = "ButtonGroup";
})($b0606e970ac35bc0$var$ComponentType = module.exports.ComponentType || (module.exports.ComponentType = {}));

});


parcelRegister("lf7w5", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@shopify/app-bridge\",\"version\":\"3.7.10\",\"types\":\"index.d.ts\",\"main\":\"index.js\",\"unpkg\":\"umd/index.js\",\"jsdelivr\":\"umd/index.js\",\"files\":[\"/actions/\",\"/client/\",\"/umd/\",\"/utilities/\",\"/util/\",\"/validate/\",\"/development.d.ts\",\"/development.js\",\"/index.d.ts\",\"/index.js\",\"/MessageTransport.d.ts\",\"/MessageTransport.js\",\"/production.d.ts\",\"/production.js\"],\"private\":false,\"publishConfig\":{\"access\":\"public\",\"@shopify:registry\":\"https://registry.npmjs.org\"},\"repository\":\"git@github.com:Shopify/app-bridge.git\",\"homepage\":\"https://shopify.dev/docs/api/app-bridge/previous-versions/app-bridge-from-npm/app-setup\",\"author\":\"Shopify Inc.\",\"license\":\"MIT\",\"scripts\":{\"build\":\"yarn build:tsc && yarn build:npm && yarn build:umd\",\"build:tsc\":\"NODE_ENV=production tsc\",\"build:umd\":\"NODE_ENV=production webpack -p\",\"build:npm\":\"shx cp -r ./npm/index.js ./index.js\",\"check\":\"tsc\",\"clean\":\"yarn clean:tsc && yarn clean:npm && yarn clean:umd\",\"clean:tsc\":\"NODE_ENV=production tsc --build --clean\",\"clean:umd\":\"rm -rf ./umd\",\"clean:npm\":\"rm -rf ./index.js\",\"pack\":\"yarn pack\",\"size\":\"size-limit\"},\"sideEffects\":false,\"size-limit\":[{\"limit\":\"10.5 KB\",\"path\":\"production.js\"}],\"dependencies\":{\"@shopify/app-bridge-core\":\"1.1.1\",\"base64url\":\"^3.0.1\",\"web-vitals\":\"^3.0.1\"},\"devDependencies\":{\"@types/node\":\"^10.12.5\",\"shx\":\"^0.3.3\"}}");

});


parcelRegister("5hZgj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.app = module.exports.Action = void 0;

var $1CIwX = parcelRequire("1CIwX");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $1CIwX.Action;
    }
});
Object.defineProperty(module.exports, "app", {
    enumerable: true,
    get: function() {
        return $1CIwX.app;
    }
});

});
parcelRegister("1CIwX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.app = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $f8QDr = parcelRequire("f8QDr");
var $12ebe1e5ce8ec856$var$Action;
(function(Action) {
    Action["APP"] = "APP::PRINT::APP";
})($12ebe1e5ce8ec856$var$Action = module.exports.Action || (module.exports.Action = {}));
function $12ebe1e5ce8ec856$var$app() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Print,
        type: $12ebe1e5ce8ec856$var$Action.APP
    });
}
module.exports.app = $12ebe1e5ce8ec856$var$app;

});


parcelRegister("1maiX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.networkAction = module.exports.persistenceAction = module.exports.unsupportedOperationAction = module.exports.unexpectedAction = module.exports.invalidAction = module.exports.invalidActionType = module.exports.invalidPayload = module.exports.Message = module.exports.fromAction = module.exports.Action = module.exports.permissionAction = module.exports.isErrorEventName = module.exports.throwError = module.exports.invalidOriginAction = module.exports.AppBridgeError = module.exports.AppActionType = void 0;

var $jsxab = parcelRequire("jsxab");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $jsxab.Action;
    }
});
Object.defineProperty(module.exports, "fromAction", {
    enumerable: true,
    get: function() {
        return $jsxab.fromAction;
    }
});

var $jrseT = parcelRequire("jrseT");

var $hrrN9 = parcelRequire("hrrN9");

var $jsxab = parcelRequire("jsxab");
Object.defineProperty(module.exports, "AppActionType", {
    enumerable: true,
    get: function() {
        return $jsxab.AppActionType;
    }
});
Object.defineProperty(module.exports, "AppBridgeError", {
    enumerable: true,
    get: function() {
        return $jsxab.AppBridgeError;
    }
});
Object.defineProperty(module.exports, "invalidOriginAction", {
    enumerable: true,
    get: function() {
        return $jsxab.invalidOriginAction;
    }
});
Object.defineProperty(module.exports, "throwError", {
    enumerable: true,
    get: function() {
        return $jsxab.throwError;
    }
});
Object.defineProperty(module.exports, "isErrorEventName", {
    enumerable: true,
    get: function() {
        return $jsxab.isErrorEventName;
    }
});
Object.defineProperty(module.exports, "permissionAction", {
    enumerable: true,
    get: function() {
        return $jsxab.permissionAction;
    }
});
function $0fcfd6cef7725919$var$errorActionWrapperWithId(type, action, message) {
    var castPayload = action.payload;
    return $jrseT.actionWrapper({
        type: type,
        group: $hrrN9.Group.Error,
        payload: {
            action: action,
            message: message,
            type: type,
            id: castPayload && castPayload.id ? castPayload.id : undefined
        }
    });
}
var $0fcfd6cef7725919$var$Message;
(function(Message) {
    Message["MISSING_PAYLOAD"] = "Missing payload";
    Message["INVALID_PAYLOAD_ID"] = "Id in payload is missing or invalid";
})($0fcfd6cef7725919$var$Message = module.exports.Message || (module.exports.Message = {}));
function $0fcfd6cef7725919$var$invalidPayload(action, message) {
    return $0fcfd6cef7725919$var$errorActionWrapperWithId($jsxab.Action.INVALID_PAYLOAD, action, message || "The action's payload is missing required properties or has invalid properties");
}
module.exports.invalidPayload = $0fcfd6cef7725919$var$invalidPayload;
function $0fcfd6cef7725919$var$invalidActionType(action, message) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.Error,
        payload: {
            action: action,
            message: message || 'The action type is invalid or unsupported',
            type: $jsxab.Action.INVALID_ACTION_TYPE
        },
        type: $jsxab.Action.INVALID_ACTION_TYPE
    });
}
module.exports.invalidActionType = $0fcfd6cef7725919$var$invalidActionType;
function $0fcfd6cef7725919$var$invalidAction(action, message) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.Error,
        payload: {
            action: action,
            message: message || "The action's has missing/invalid values for `group`, `type` or `version`",
            type: $jsxab.Action.INVALID_ACTION
        },
        type: $jsxab.Action.INVALID_ACTION
    });
}
module.exports.invalidAction = $0fcfd6cef7725919$var$invalidAction;
function $0fcfd6cef7725919$var$unexpectedAction(action, message) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.Error,
        payload: {
            action: action,
            message: message || 'Action cannot be called at this time',
            type: $jsxab.Action.UNEXPECTED_ACTION
        },
        type: $jsxab.Action.UNEXPECTED_ACTION
    });
}
module.exports.unexpectedAction = $0fcfd6cef7725919$var$unexpectedAction;
function $0fcfd6cef7725919$var$unsupportedOperationAction(action, message) {
    return $0fcfd6cef7725919$var$errorActionWrapperWithId($jsxab.Action.UNSUPPORTED_OPERATION, action, message || 'The action type is unsupported');
}
module.exports.unsupportedOperationAction = $0fcfd6cef7725919$var$unsupportedOperationAction;
function $0fcfd6cef7725919$var$persistenceAction(action, message) {
    return $0fcfd6cef7725919$var$errorActionWrapperWithId($jsxab.Action.PERSISTENCE, action, message || 'Action cannot be persisted on server');
}
module.exports.persistenceAction = $0fcfd6cef7725919$var$persistenceAction;
function $0fcfd6cef7725919$var$networkAction(action, message) {
    return $0fcfd6cef7725919$var$errorActionWrapperWithId($jsxab.Action.NETWORK, action, message || 'Network error');
}
module.exports.networkAction = $0fcfd6cef7725919$var$networkAction;

});
parcelRegister("jsxab", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.permissionAction = module.exports.isErrorEventName = module.exports.throwError = module.exports.invalidOriginAction = module.exports.fromAction = module.exports.AppBridgeError = module.exports.AppActionType = module.exports.Action = void 0;

var $f8QDr = parcelRequire("f8QDr");

var $ditiI = parcelRequire("ditiI");
// Errors triggered in response to an action
var $e2aa5b6630d22c20$var$Action;
(function(Action) {
    Action["INVALID_ACTION"] = "APP::ERROR::INVALID_ACTION";
    Action["INVALID_ACTION_TYPE"] = "APP::ERROR::INVALID_ACTION_TYPE";
    Action["INVALID_PAYLOAD"] = "APP::ERROR::INVALID_PAYLOAD";
    Action["INVALID_OPTIONS"] = "APP::ERROR::INVALID_OPTIONS";
    Action["UNEXPECTED_ACTION"] = "APP::ERROR::UNEXPECTED_ACTION";
    Action["PERSISTENCE"] = "APP::ERROR::PERSISTENCE";
    Action["UNSUPPORTED_OPERATION"] = "APP::ERROR::UNSUPPORTED_OPERATION";
    Action["NETWORK"] = "APP::ERROR::NETWORK";
    Action["PERMISSION"] = "APP::ERROR::PERMISSION";
    Action["FAILED_AUTHENTICATION"] = "APP::ERROR::FAILED_AUTHENTICATION";
    Action["INVALID_ORIGIN"] = "APP::ERROR::INVALID_ORIGIN";
})($e2aa5b6630d22c20$var$Action = module.exports.Action || (module.exports.Action = {}));
// Errors thrown in response to app setup
var $e2aa5b6630d22c20$var$AppActionType;
(function(AppActionType) {
    AppActionType["INVALID_CONFIG"] = "APP::ERROR::INVALID_CONFIG";
    AppActionType["MISSING_CONFIG"] = "APP::APP_ERROR::MISSING_CONFIG";
    AppActionType["MISSING_APP_BRIDGE_MIDDLEWARE"] = "APP::APP_ERROR::MISSING_APP_BRIDGE_MIDDLEWARE";
    AppActionType["WINDOW_UNDEFINED"] = "APP::APP_ERROR::WINDOW_UNDEFINED";
    AppActionType["REDUX_REINSTANTIATED"] = "APP::APP_ERROR::REDUX_REINSTANTIATED";
    AppActionType["MISSING_LOCAL_ORIGIN"] = "APP::APP_ERROR::MISSING_LOCAL_ORIGIN";
    AppActionType["MISSING_HOST_PROVIDER"] = "APP::APP_ERROR::MISSING_HOST_PROVIDER";
    AppActionType["MISSING_ROUTER_CONTEXT"] = "APP::APP_ERROR::MISSING_ROUTER_CONTEXT";
    AppActionType["MISSING_HISTORY_BLOCK"] = "APP::APP_ERROR::MISSING_HISTORY_BLOCK";
})($e2aa5b6630d22c20$var$AppActionType = module.exports.AppActionType || (module.exports.AppActionType = {}));
var $e2aa5b6630d22c20$var$AppBridgeError = /** @class */ function() {
    function AppBridgeError(message) {
        this.name = 'AppBridgeError';
        this.message = message;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    return AppBridgeError;
}();
module.exports.AppBridgeError = $e2aa5b6630d22c20$var$AppBridgeError;
$e2aa5b6630d22c20$var$AppBridgeError.prototype = Object.create(Error.prototype);
function $e2aa5b6630d22c20$var$fromAction(message, type, action) {
    var errorMessage = message ? type + ": " + message : type;
    var error = new $e2aa5b6630d22c20$var$AppBridgeError(errorMessage);
    error.action = action;
    error.type = type;
    return error;
}
module.exports.fromAction = $e2aa5b6630d22c20$var$fromAction;
function $e2aa5b6630d22c20$var$invalidOriginAction(message) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Error,
        payload: {
            message: message,
            type: $e2aa5b6630d22c20$var$Action.INVALID_ORIGIN
        },
        type: $e2aa5b6630d22c20$var$Action.INVALID_ORIGIN
    });
}
module.exports.invalidOriginAction = $e2aa5b6630d22c20$var$invalidOriginAction;
function $e2aa5b6630d22c20$var$throwError() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var type = args[0];
    var message;
    var action;
    if (typeof args[1] === 'string') message = args[1];
    else {
        action = args[1];
        message = args[2] || '';
    }
    throw $e2aa5b6630d22c20$var$fromAction(message, type, action);
}
module.exports.throwError = $e2aa5b6630d22c20$var$throwError;
function $e2aa5b6630d22c20$var$isErrorEventName(eventName) {
    var match = $ditiI.findMatchInEnum($e2aa5b6630d22c20$var$Action, eventName);
    return typeof match === 'string';
}
module.exports.isErrorEventName = $e2aa5b6630d22c20$var$isErrorEventName;
function $e2aa5b6630d22c20$var$errorActionWrapperWithId(type, action, message) {
    var castPayload = action.payload;
    return $ditiI.actionWrapper({
        type: type,
        group: $f8QDr.Group.Error,
        payload: {
            action: action,
            message: message,
            type: type,
            id: castPayload && castPayload.id ? castPayload.id : undefined
        }
    });
}
function $e2aa5b6630d22c20$var$permissionAction(action, message) {
    return $e2aa5b6630d22c20$var$errorActionWrapperWithId($e2aa5b6630d22c20$var$Action.PERMISSION, action, message || 'Action is not permitted');
}
module.exports.permissionAction = $e2aa5b6630d22c20$var$permissionAction;

});

parcelRegister("hrrN9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComponentType = module.exports.Group = void 0;

var $f8QDr = parcelRequire("f8QDr");
Object.defineProperty(module.exports, "Group", {
    enumerable: true,
    get: function() {
        return $f8QDr.Group;
    }
});
Object.defineProperty(module.exports, "ComponentType", {
    enumerable: true,
    get: function() {
        return $f8QDr.ComponentType;
    }
});

});


parcelRegister("j1eoF", function(module, exports) {
"use strict";
var $dd89473c9675c6fc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dd89473c9675c6fc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dd89473c9675c6fc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dd89473c9675c6fc$var$__exportStar((parcelRequire("bfEXx")), module.exports);

});
parcelRegister("bfEXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTransportListener = module.exports.fromWindow = module.exports.fromFrame = module.exports.Context = void 0;

var $jsxab = parcelRequire("jsxab");

var $7XU50 = parcelRequire("7XU50");

var $lsjyd = parcelRequire("lsjyd");

var $7IW4H = parcelRequire("7IW4H");

var $aLfEi = parcelRequire("aLfEi");
var $8310de16144c92c0$var$Context;
(function(Context) {
    Context["Modal"] = "Modal";
    Context["Main"] = "Main";
})($8310de16144c92c0$var$Context = module.exports.Context || (module.exports.Context = {}));
/**
 * Create a MessageTransport from a Frame.
 * @remarks
 * Used on the host-side to create a postMessage MessageTransport.
 * @beta
 */ function $8310de16144c92c0$var$fromFrame(frame, localOrigin, context) {
    var handlers = [];
    var host = frame.host, frameWindow = frame.window;
    if (!host) throw $jsxab.fromAction('App frame is undefined', $jsxab.AppActionType.WINDOW_UNDEFINED);
    if ($aLfEi.isUnframed && window.MobileWebView) Object.assign(window.MobileWebView, {
        postMessageToIframe: function(message, origin) {
            frameWindow === null || frameWindow === void 0 || frameWindow.postMessage(message, origin);
            if ($8310de16144c92c0$var$isDispatchAction(message)) host.postMessage(JSON.stringify(message.payload), location.origin);
        },
        updateIframeUrl: function(newUrl) {
            var currentWindowLocation = window.location;
            var frameWindowLocation = (frame.window || {}).location;
            try {
                var newUrlOrigin = new URL(newUrl).origin;
                if (newUrlOrigin === localOrigin && frameWindowLocation) frameWindowLocation.replace(newUrl);
                else currentWindowLocation.href = newUrl;
            } catch (_) {
            // Noop
            }
        }
    });
    host.addEventListener('message', function(event) {
        if (event.source === host || !$7XU50.isAppMessage(event)) return;
        if (event.origin !== localOrigin) {
            var errorMessage = "Message origin '" + event.origin + "' does not match app origin '" + localOrigin + "'.";
            var payload = $jsxab.invalidOriginAction(errorMessage);
            var message = {
                type: 'dispatch',
                payload: payload
            };
            frameWindow === null || frameWindow === void 0 || frameWindow.postMessage(message, event.origin);
            return;
        }
        if ($aLfEi.isUnframed && window.MobileWebView) {
            var payload = JSON.stringify({
                id: 'unframed://fromClient',
                origin: localOrigin,
                data: event.data
            });
            window.MobileWebView.postMessage(payload);
            return;
        }
        for(var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++){
            var handler = handlers_1[_i];
            handler(event);
        }
    });
    return {
        context: context,
        localOrigin: localOrigin,
        frameWindow: frameWindow,
        hostFrame: host,
        dispatch: function(message) {
            frameWindow === null || frameWindow === void 0 || frameWindow.postMessage(message, localOrigin);
        },
        subscribe: function(handler) {
            return $7IW4H.addAndRemoveFromCollection(handlers, handler);
        }
    };
}
module.exports.fromFrame = $8310de16144c92c0$var$fromFrame;
/**
 * Create a MessageTransport from a parent window.
 * @remarks
 * Used on the client-side to create a postMessage MessageTransport.
 * @internalremarks
 * In unframed mode, message should be dispatched via MobileWebView.postMessage instead of postMessage.
 * @beta
 */ function $8310de16144c92c0$var$fromWindow(contentWindow, localOrigin) {
    var handlers = [];
    window.addEventListener('message', function(event) {
        if (window === contentWindow && !$aLfEi.isUnframed || event.source !== contentWindow || !($7XU50.isAppBridgeAction(event.data.payload) || $7XU50.isAppMessage(event))) return;
        for(var _i = 0, handlers_2 = handlers; _i < handlers_2.length; _i++){
            var handler = handlers_2[_i];
            handler(event);
        }
    });
    return {
        localOrigin: localOrigin,
        hostFrame: contentWindow,
        dispatch: function(message) {
            var _a;
            if (!((_a = message.source) === null || _a === void 0 ? void 0 : _a.host)) return;
            if ($aLfEi.isUnframed && window && window.MobileWebView) {
                var payload = JSON.stringify({
                    id: 'unframed://fromClient',
                    origin: localOrigin,
                    data: message
                });
                window.MobileWebView.postMessage(payload);
                return;
            }
            var messageOrigin = new URL("https://" + message.source.host).origin;
            contentWindow.postMessage(message, messageOrigin);
        },
        subscribe: function(handler) {
            return $7IW4H.addAndRemoveFromCollection(handlers, handler);
        }
    };
}
module.exports.fromWindow = $8310de16144c92c0$var$fromWindow;
function $8310de16144c92c0$var$createTransportListener() {
    var listeners = [];
    var actionListeners = {};
    function createSubscribeHandler(dispatcher) {
        function subscribe() {
            if (arguments.length < 2) // eslint-disable-next-line prefer-rest-params
            return $7IW4H.addAndRemoveFromCollection(listeners, {
                callback: arguments[0]
            });
            // eslint-disable-next-line prefer-rest-params
            var _a = Array.from(arguments), type = _a[0], callback = _a[1], id = _a[2];
            var actionCallback = {
                callback: callback,
                id: id
            };
            var payload = {
                type: type,
                id: id
            };
            if (!Object.prototype.hasOwnProperty.call(actionListeners, type)) actionListeners[type] = [];
            if (dispatcher) dispatcher($lsjyd.MessageType.Subscribe, payload);
            return $7IW4H.addAndRemoveFromCollection(actionListeners[type], actionCallback, function() {
                if (dispatcher) dispatcher($lsjyd.MessageType.Unsubscribe, payload);
            });
        }
        return subscribe;
    }
    return {
        createSubscribeHandler: createSubscribeHandler,
        handleMessage: function(message) {
            listeners.forEach(function(listener) {
                return listener.callback(message);
            });
        },
        handleActionDispatch: function(_a) {
            var type = _a.type, payload = _a.payload;
            var hasCallback = false;
            if (Object.prototype.hasOwnProperty.call(actionListeners, type)) for(var _i = 0, _b = actionListeners[type]; _i < _b.length; _i++){
                var listener = _b[_i];
                var id = listener.id, callback = listener.callback;
                var matchId = payload && payload.id === id;
                if (matchId || !id) {
                    callback(payload);
                    hasCallback = true;
                }
            }
            return hasCallback;
        }
    };
}
module.exports.createTransportListener = $8310de16144c92c0$var$createTransportListener;
function $8310de16144c92c0$var$isDispatchAction(message) {
    return message !== null && typeof message === 'object' && !Array.isArray(message) && message.type === 'dispatch' && typeof message.payload === 'object';
}

});
parcelRegister("7XU50", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isPermitted = module.exports.getPermissionKey = module.exports.isPerformanceOrWebVitalsAction = module.exports.isAppMessage = module.exports.isAppBridgeAction = void 0;

var $lsjyd = parcelRequire("lsjyd");

var $jlQNT = parcelRequire("jlQNT");

var $ditiI = parcelRequire("ditiI");
/**
 * Predicate to determine if an action is an App Bridge action.
 * @public
 */ function $5cc98b5d24b4134c$var$isAppBridgeAction(action) {
    return action instanceof Object && Object.prototype.hasOwnProperty.call(action, 'type') && action.type.toString().startsWith($jlQNT.PREFIX);
}
module.exports.isAppBridgeAction = $5cc98b5d24b4134c$var$isAppBridgeAction;
/**
 * Predicate to determine if an event originated from an application.
 * @internal
 */ function $5cc98b5d24b4134c$var$isAppMessage(event) {
    if (typeof event !== 'object' || !event.data || typeof event.data !== 'object') return false;
    var data = event.data;
    return Object.prototype.hasOwnProperty.call(data, 'type') && $ditiI.findMatchInEnum($lsjyd.MessageType, data.type) !== undefined;
}
module.exports.isAppMessage = $5cc98b5d24b4134c$var$isAppMessage;
/**
 * Function used to determine if an action is in the Performance or WebVitals groups
 * @public
 */ function $5cc98b5d24b4134c$var$isPerformanceOrWebVitalsAction(_a) {
    var type = _a.type;
    return type.match(/^APP::(PERFORMANCE|WEB_VITALS)::/);
}
module.exports.isPerformanceOrWebVitalsAction = $5cc98b5d24b4134c$var$isPerformanceOrWebVitalsAction;
/**
 * Returns the action type without the prefix and group
 * @internal
 */ function $5cc98b5d24b4134c$var$getPermissionKey(type) {
    return type.replace(new RegExp("^" + $jlQNT.PREFIX + $jlQNT.SEPARATOR + "\\w+" + $jlQNT.SEPARATOR), '');
}
module.exports.getPermissionKey = $5cc98b5d24b4134c$var$getPermissionKey;
/**
 * Predicate to determine if an action is permitted
 * @internal
 */ function $5cc98b5d24b4134c$var$isPermitted(features, _a, permissionType) {
    var group = _a.group, type = _a.type;
    if (!group || !Object.prototype.hasOwnProperty.call(features, group)) return false;
    var feature = features[group];
    if (!feature) return false;
    var actionType = $5cc98b5d24b4134c$var$getPermissionKey(type);
    return feature[actionType] ? feature[actionType][permissionType] === true : false;
}
module.exports.isPermitted = $5cc98b5d24b4134c$var$isPermitted;

});
parcelRegister("lsjyd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LifecycleHook = module.exports.PermissionType = module.exports.MessageType = void 0;
/**
 * @internal
 */ var $f9eb60e0f2a8e77f$var$MessageType;
(function(MessageType) {
    MessageType["GetState"] = "getState";
    MessageType["Dispatch"] = "dispatch";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Unsubscribe"] = "unsubscribe";
})($f9eb60e0f2a8e77f$var$MessageType = module.exports.MessageType || (module.exports.MessageType = {}));
/**
 * @internal
 */ var $f9eb60e0f2a8e77f$var$PermissionType;
(function(PermissionType) {
    PermissionType["Dispatch"] = "Dispatch";
    PermissionType["Subscribe"] = "Subscribe";
})($f9eb60e0f2a8e77f$var$PermissionType = module.exports.PermissionType || (module.exports.PermissionType = {}));
/**
 *
 * There are two types of hooks: `LifecycleHook.DispatchAction` and `LifecycleHook.UpdateAction`.
 *
 * @remarks
 * `DispatchAction` hooks are run when an action is dispatched with the `.dispatch()` function:
 *
 * ```js
 * const toastNotice = Toast.create(app, {message: 'Product saved'});
 * toastNotice.dispatch(Toast.Action.SHOW);
 * ```
 *
 * `UpdateAction` hooks are run when an action is updated, using the `.set()` function:
 *
 * ```js
 * toastNotice.set({message: 'Product could not be saved', isError: true});
 * ```
 *
 * @public
 */ var $f9eb60e0f2a8e77f$var$LifecycleHook;
(function(LifecycleHook) {
    LifecycleHook["UpdateAction"] = "UpdateAction";
    LifecycleHook["DispatchAction"] = "DispatchAction";
})($f9eb60e0f2a8e77f$var$LifecycleHook = module.exports.LifecycleHook || (module.exports.LifecycleHook = {}));

});


parcelRegister("7IW4H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeFromCollection = module.exports.addAndRemoveFromCollection = void 0;
/**
 * Add an item to a collection, return a function that can then be used to
 * remove the item from the collection. Optionally accepting a callback that is
 * invoked when the item is removed from the collection.
 *
 * @internal
 */ function $59f9b0e8d3659a8f$var$addAndRemoveFromCollection(collection, item, then) {
    collection.push(item);
    return function() {
        return $59f9b0e8d3659a8f$var$removeFromCollection(collection, item, then);
    };
}
module.exports.addAndRemoveFromCollection = $59f9b0e8d3659a8f$var$addAndRemoveFromCollection;
/**
 * Remove the item from the collection. Optionally accepting a callback that is
 * invoked when the item is removed from the collection.
 *
 * @internal
 */ function $59f9b0e8d3659a8f$var$removeFromCollection(collection, item, then) {
    var idx = collection.findIndex(function(i) {
        return i === item;
    });
    if (idx >= 0) {
        collection.splice(idx, 1);
        if (then) then(item);
        return true;
    }
    return false;
}
module.exports.removeFromCollection = $59f9b0e8d3659a8f$var$removeFromCollection;

});

parcelRegister("aLfEi", function(module, exports) {
"use strict";
var $7d5a6ebdd532d8c4$var$_a, $7d5a6ebdd532d8c4$var$_b;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUnframed = module.exports.isClient = module.exports.isServer = void 0;
module.exports.isServer = typeof window === 'undefined';
module.exports.isClient = !module.exports.isServer;
// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
module.exports.isUnframed = module.exports.isClient && (($7d5a6ebdd532d8c4$var$_b = ($7d5a6ebdd532d8c4$var$_a = window.navigator) === null || $7d5a6ebdd532d8c4$var$_a === void 0 ? void 0 : $7d5a6ebdd532d8c4$var$_a.userAgent) === null || $7d5a6ebdd532d8c4$var$_b === void 0 ? void 0 : $7d5a6ebdd532d8c4$var$_b.indexOf('Unframed')) > 0;

});



parcelRegister("h5eU1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mockAppBridge = module.exports.serverAppBridge = void 0;

var $1maiX = parcelRequire("1maiX");
var $c6fe769ea1a3e0f3$var$noop = function() {};
var $c6fe769ea1a3e0f3$var$noopPromise = new Promise(function() {
// Noop
});
/**
 * @internal
 */ module.exports.serverAppBridge = {
    dispatch: function() {
        return {};
    },
    error: function() {
        return $c6fe769ea1a3e0f3$var$noop;
    },
    featuresAvailable: function() {
        return Promise.reject($1maiX.fromAction('Feature detection is only available on the client side.', $1maiX.AppActionType.WINDOW_UNDEFINED));
    },
    getState: function() {
        return Promise.reject($1maiX.fromAction('State is only available on the client side.', $1maiX.AppActionType.WINDOW_UNDEFINED));
    },
    localOrigin: '',
    hostOrigin: '',
    subscribe: function() {
        return $c6fe769ea1a3e0f3$var$noop;
    }
};
/**
 * @internal
 */ module.exports.mockAppBridge = {
    dispatch: function() {
        return {};
    },
    error: function() {
        return $c6fe769ea1a3e0f3$var$noop;
    },
    featuresAvailable: function() {
        return $c6fe769ea1a3e0f3$var$noopPromise;
    },
    getState: function() {
        return $c6fe769ea1a3e0f3$var$noopPromise;
    },
    localOrigin: '',
    hostOrigin: '',
    subscribe: function() {
        return $c6fe769ea1a3e0f3$var$noop;
    }
};

});

parcelRegister("hJArC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDevelopmentClient = module.exports.isProduction = module.exports.isDevelopment = module.exports.isUnframed = module.exports.isServer = module.exports.isClient = void 0;

var $aLfEi = parcelRequire("aLfEi");

var $aLfEi = parcelRequire("aLfEi");
Object.defineProperty(module.exports, "isClient", {
    enumerable: true,
    get: function() {
        return $aLfEi.isClient;
    }
});
Object.defineProperty(module.exports, "isServer", {
    enumerable: true,
    get: function() {
        return $aLfEi.isServer;
    }
});
Object.defineProperty(module.exports, "isUnframed", {
    enumerable: true,
    get: function() {
        return $aLfEi.isUnframed;
    }
});
module.exports.isDevelopment = typeof $hPtJY !== 'undefined' && $hPtJY.env && false;
module.exports.isProduction = !module.exports.isDevelopment;
module.exports.isDevelopmentClient = module.exports.isDevelopment && $aLfEi.isClient;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("1Ono8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initialize = module.exports.Action = void 0;

var $fUB1Y = parcelRequire("fUB1Y");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $fUB1Y.Action;
    }
});

var $hrrN9 = parcelRequire("hrrN9");

var $jrseT = parcelRequire("jrseT");
function $151c9a5e16d3655c$var$initialize() {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.Client,
        type: $fUB1Y.Action.INITIALIZE
    });
}
module.exports.initialize = $151c9a5e16d3655c$var$initialize;

});
parcelRegister("fUB1Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Action = void 0;
var $b958cf893ae52dac$var$Action;
(function(Action) {
    Action["INITIALIZE"] = "APP::CLIENT::INITIALIZE";
})($b958cf893ae52dac$var$Action = module.exports.Action || (module.exports.Action = {}));

});


parcelRegister("7LSs8", function(module, exports) {
"use strict";
var $5a87296009b63484$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5a87296009b63484$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5a87296009b63484$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5a87296009b63484$var$__exportStar((parcelRequire("fu8hv")), module.exports);

});
parcelRegister("fu8hv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initializeWebVitals = module.exports.interactionToNextPaint = module.exports.timeToFirstByte = module.exports.firstContentfulPaint = module.exports.cumulativeLayoutShift = module.exports.firstInputDelay = module.exports.largestContentfulPaint = module.exports.Action = void 0;

var $2xAZO = parcelRequire("2xAZO");

var $jE2J7 = parcelRequire("jE2J7");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $jE2J7.Action;
    }
});

var $hJArC = parcelRequire("hJArC");

var $hrrN9 = parcelRequire("hrrN9");

var $jrseT = parcelRequire("jrseT");

var $6dZZq = parcelRequire("6dZZq");
function $b46014df95834c04$var$largestContentfulPaint(payload) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.WebVitals,
        type: $jE2J7.Action.LARGEST_CONTENTFUL_PAINT,
        payload: payload
    });
}
module.exports.largestContentfulPaint = $b46014df95834c04$var$largestContentfulPaint;
function $b46014df95834c04$var$firstInputDelay(payload) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.WebVitals,
        type: $jE2J7.Action.FIRST_INPUT_DELAY,
        payload: payload
    });
}
module.exports.firstInputDelay = $b46014df95834c04$var$firstInputDelay;
function $b46014df95834c04$var$cumulativeLayoutShift(payload) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.WebVitals,
        type: $jE2J7.Action.CUMULATIVE_LAYOUT_SHIFT,
        payload: payload
    });
}
module.exports.cumulativeLayoutShift = $b46014df95834c04$var$cumulativeLayoutShift;
function $b46014df95834c04$var$firstContentfulPaint(payload) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.WebVitals,
        type: $jE2J7.Action.FIRST_CONTENTFUL_PAINT,
        payload: payload
    });
}
module.exports.firstContentfulPaint = $b46014df95834c04$var$firstContentfulPaint;
function $b46014df95834c04$var$timeToFirstByte(payload) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.WebVitals,
        type: $jE2J7.Action.TIME_TO_FIRST_BYTE,
        payload: payload
    });
}
module.exports.timeToFirstByte = $b46014df95834c04$var$timeToFirstByte;
function $b46014df95834c04$var$interactionToNextPaint(payload) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.WebVitals,
        type: $jE2J7.Action.INTERACTION_TO_NEXT_PAINT,
        payload: payload
    });
}
module.exports.interactionToNextPaint = $b46014df95834c04$var$interactionToNextPaint;
function $b46014df95834c04$var$initializeWebVitals(app) {
    function onReport(cb) {
        return function(data) {
            var id = data.id, metricName = data.name, value = data.value;
            var payload = {
                id: id,
                metricName: metricName,
                value: value
            };
            var event = cb(payload);
            app.dispatch(event);
        };
    }
    var untypedWindow = window;
    if ($hJArC.isServer || $hJArC.isClient && untypedWindow.__is_web_vitals_initialized__ || $6dZZq.isMobile()) // We need to prevent the Web Vitals functions from being called more than once per page load,
    // which can cause a memory leak as per the web-vitals docs.
    return;
    untypedWindow.__is_web_vitals_initialized__ = true;
    $2xAZO.onLCP(onReport($b46014df95834c04$var$largestContentfulPaint));
    $2xAZO.onFID(onReport($b46014df95834c04$var$firstInputDelay));
    $2xAZO.onCLS(onReport($b46014df95834c04$var$cumulativeLayoutShift));
    $2xAZO.onFCP(onReport($b46014df95834c04$var$firstContentfulPaint));
    $2xAZO.onTTFB(onReport($b46014df95834c04$var$timeToFirstByte));
    $2xAZO.onINP(onReport($b46014df95834c04$var$interactionToNextPaint));
}
module.exports.initializeWebVitals = $b46014df95834c04$var$initializeWebVitals;

});
parcelRegister("2xAZO", function(module, exports) {

$parcel$export(module.exports, "onCLS", () => $1d9b5c75918107f9$export$fc6227831ee7c7);
$parcel$export(module.exports, "onFCP", () => $1d9b5c75918107f9$export$52489892712e8192);
$parcel$export(module.exports, "onFID", () => $1d9b5c75918107f9$export$134ed2977d320dfd);
$parcel$export(module.exports, "onINP", () => $1d9b5c75918107f9$export$6693a9916ea977ef);
$parcel$export(module.exports, "onLCP", () => $1d9b5c75918107f9$export$da982ced0ff8a670);
$parcel$export(module.exports, "onTTFB", () => $1d9b5c75918107f9$export$6e8eea9a35032c92);
var $1d9b5c75918107f9$var$e, $1d9b5c75918107f9$var$n, $1d9b5c75918107f9$var$t, $1d9b5c75918107f9$var$i, $1d9b5c75918107f9$var$r, $1d9b5c75918107f9$var$a = -1, $1d9b5c75918107f9$var$o = function(e) {
    addEventListener("pageshow", function(n) {
        n.persisted && ($1d9b5c75918107f9$var$a = n.timeStamp, e(n));
    }, !0);
}, $1d9b5c75918107f9$var$c = function() {
    return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, $1d9b5c75918107f9$var$u = function() {
    var e = $1d9b5c75918107f9$var$c();
    return e && e.activationStart || 0;
}, $1d9b5c75918107f9$var$f = function(e, n) {
    var t = $1d9b5c75918107f9$var$c(), i = "navigate";
    $1d9b5c75918107f9$var$a >= 0 ? i = "back-forward-cache" : t && (document.prerendering || $1d9b5c75918107f9$var$u() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : t.type && (i = t.type.replace(/_/g, "-")));
    return {
        name: e,
        value: void 0 === n ? -1 : n,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: i
    };
}, $1d9b5c75918107f9$var$s = function(e, n, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            var i = new PerformanceObserver(function(e) {
                Promise.resolve().then(function() {
                    n(e.getEntries());
                });
            });
            return i.observe(Object.assign({
                type: e,
                buffered: !0
            }, t || {})), i;
        }
    } catch (e) {}
}, $1d9b5c75918107f9$var$d = function(e, n, t, i) {
    var r, a;
    return function(o) {
        n.value >= 0 && (o || i) && ((a = n.value - (r || 0)) || void 0 === r) && (r = n.value, n.delta = a, n.rating = function(e, n) {
            return e > n[1] ? "poor" : e > n[0] ? "needs-improvement" : "good";
        }(n.value, t), e(n));
    };
}, $1d9b5c75918107f9$var$l = function(e) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return e();
        });
    });
}, $1d9b5c75918107f9$var$p = function(e) {
    var n = function(n) {
        "pagehide" !== n.type && "hidden" !== document.visibilityState || e(n);
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $1d9b5c75918107f9$var$v = function(e) {
    var n = !1;
    return function(t) {
        n || (e(t), n = !0);
    };
}, $1d9b5c75918107f9$var$m = -1, $1d9b5c75918107f9$var$h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $1d9b5c75918107f9$var$g = function(e) {
    "hidden" === document.visibilityState && $1d9b5c75918107f9$var$m > -1 && ($1d9b5c75918107f9$var$m = "visibilitychange" === e.type ? e.timeStamp : 0, $1d9b5c75918107f9$var$T());
}, $1d9b5c75918107f9$var$y = function() {
    addEventListener("visibilitychange", $1d9b5c75918107f9$var$g, !0), addEventListener("prerenderingchange", $1d9b5c75918107f9$var$g, !0);
}, $1d9b5c75918107f9$var$T = function() {
    removeEventListener("visibilitychange", $1d9b5c75918107f9$var$g, !0), removeEventListener("prerenderingchange", $1d9b5c75918107f9$var$g, !0);
}, $1d9b5c75918107f9$var$E = function() {
    return $1d9b5c75918107f9$var$m < 0 && ($1d9b5c75918107f9$var$m = $1d9b5c75918107f9$var$h(), $1d9b5c75918107f9$var$y(), $1d9b5c75918107f9$var$o(function() {
        setTimeout(function() {
            $1d9b5c75918107f9$var$m = $1d9b5c75918107f9$var$h(), $1d9b5c75918107f9$var$y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $1d9b5c75918107f9$var$m;
        }
    };
}, $1d9b5c75918107f9$var$C = function(e) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return e();
    }, !0) : e();
}, $1d9b5c75918107f9$export$e610c735b5510cec = [
    1800,
    3e3
], $1d9b5c75918107f9$export$52489892712e8192 = function(e, n) {
    n = n || {}, $1d9b5c75918107f9$var$C(function() {
        var t, i = $1d9b5c75918107f9$var$E(), r = $1d9b5c75918107f9$var$f("FCP"), a = $1d9b5c75918107f9$var$s("paint", function(e) {
            e.forEach(function(e) {
                "first-contentful-paint" === e.name && (a.disconnect(), e.startTime < i.firstHiddenTime && (r.value = Math.max(e.startTime - $1d9b5c75918107f9$var$u(), 0), r.entries.push(e), t(!0)));
            });
        });
        a && (t = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$e610c735b5510cec, n.reportAllChanges), $1d9b5c75918107f9$var$o(function(i) {
            r = $1d9b5c75918107f9$var$f("FCP"), t = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$e610c735b5510cec, n.reportAllChanges), $1d9b5c75918107f9$var$l(function() {
                r.value = performance.now() - i.timeStamp, t(!0);
            });
        }));
    });
}, $1d9b5c75918107f9$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $1d9b5c75918107f9$export$fc6227831ee7c7 = function(e, n) {
    n = n || {}, $1d9b5c75918107f9$export$52489892712e8192($1d9b5c75918107f9$var$v(function() {
        var t, i = $1d9b5c75918107f9$var$f("CLS", 0), r = 0, a = [], c = function(e) {
            e.forEach(function(e) {
                if (!e.hadRecentInput) {
                    var n = a[0], t = a[a.length - 1];
                    r && e.startTime - t.startTime < 1e3 && e.startTime - n.startTime < 5e3 ? (r += e.value, a.push(e)) : (r = e.value, a = [
                        e
                    ]);
                }
            }), r > i.value && (i.value = r, i.entries = a, t());
        }, u = $1d9b5c75918107f9$var$s("layout-shift", c);
        u && (t = $1d9b5c75918107f9$var$d(e, i, $1d9b5c75918107f9$export$3f20d8e089ac35b2, n.reportAllChanges), $1d9b5c75918107f9$var$p(function() {
            c(u.takeRecords()), t(!0);
        }), $1d9b5c75918107f9$var$o(function() {
            r = 0, i = $1d9b5c75918107f9$var$f("CLS", 0), t = $1d9b5c75918107f9$var$d(e, i, $1d9b5c75918107f9$export$3f20d8e089ac35b2, n.reportAllChanges), $1d9b5c75918107f9$var$l(function() {
                return t();
            });
        }), setTimeout(t, 0));
    }));
}, $1d9b5c75918107f9$var$A = {
    passive: !0,
    capture: !0
}, $1d9b5c75918107f9$var$I = new Date, $1d9b5c75918107f9$var$P = function(i, r) {
    $1d9b5c75918107f9$var$e || ($1d9b5c75918107f9$var$e = r, $1d9b5c75918107f9$var$n = i, $1d9b5c75918107f9$var$t = new Date, $1d9b5c75918107f9$var$k(removeEventListener), $1d9b5c75918107f9$var$F());
}, $1d9b5c75918107f9$var$F = function() {
    if ($1d9b5c75918107f9$var$n >= 0 && $1d9b5c75918107f9$var$n < $1d9b5c75918107f9$var$t - $1d9b5c75918107f9$var$I) {
        var r = {
            entryType: "first-input",
            name: $1d9b5c75918107f9$var$e.type,
            target: $1d9b5c75918107f9$var$e.target,
            cancelable: $1d9b5c75918107f9$var$e.cancelable,
            startTime: $1d9b5c75918107f9$var$e.timeStamp,
            processingStart: $1d9b5c75918107f9$var$e.timeStamp + $1d9b5c75918107f9$var$n
        };
        $1d9b5c75918107f9$var$i.forEach(function(e) {
            e(r);
        }), $1d9b5c75918107f9$var$i = [];
    }
}, $1d9b5c75918107f9$var$M = function(e) {
    if (e.cancelable) {
        var n = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, n) {
            var t = function() {
                $1d9b5c75918107f9$var$P(e, n), r();
            }, i = function() {
                r();
            }, r = function() {
                removeEventListener("pointerup", t, $1d9b5c75918107f9$var$A), removeEventListener("pointercancel", i, $1d9b5c75918107f9$var$A);
            };
            addEventListener("pointerup", t, $1d9b5c75918107f9$var$A), addEventListener("pointercancel", i, $1d9b5c75918107f9$var$A);
        }(n, e) : $1d9b5c75918107f9$var$P(n, e);
    }
}, $1d9b5c75918107f9$var$k = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(n) {
        return e(n, $1d9b5c75918107f9$var$M, $1d9b5c75918107f9$var$A);
    });
}, $1d9b5c75918107f9$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $1d9b5c75918107f9$export$134ed2977d320dfd = function(t, r) {
    r = r || {}, $1d9b5c75918107f9$var$C(function() {
        var a, c = $1d9b5c75918107f9$var$E(), u = $1d9b5c75918107f9$var$f("FID"), l = function(e) {
            e.startTime < c.firstHiddenTime && (u.value = e.processingStart - e.startTime, u.entries.push(e), a(!0));
        }, m = function(e) {
            e.forEach(l);
        }, h = $1d9b5c75918107f9$var$s("first-input", m);
        a = $1d9b5c75918107f9$var$d(t, u, $1d9b5c75918107f9$export$8f7f3c48ca6fbe34, r.reportAllChanges), h && $1d9b5c75918107f9$var$p($1d9b5c75918107f9$var$v(function() {
            m(h.takeRecords()), h.disconnect();
        })), h && $1d9b5c75918107f9$var$o(function() {
            var o;
            u = $1d9b5c75918107f9$var$f("FID"), a = $1d9b5c75918107f9$var$d(t, u, $1d9b5c75918107f9$export$8f7f3c48ca6fbe34, r.reportAllChanges), $1d9b5c75918107f9$var$i = [], $1d9b5c75918107f9$var$n = -1, $1d9b5c75918107f9$var$e = null, $1d9b5c75918107f9$var$k(addEventListener), o = l, $1d9b5c75918107f9$var$i.push(o), $1d9b5c75918107f9$var$F();
        });
    });
}, $1d9b5c75918107f9$var$B = 0, $1d9b5c75918107f9$var$R = 1 / 0, $1d9b5c75918107f9$var$H = 0, $1d9b5c75918107f9$var$N = function(e) {
    e.forEach(function(e) {
        e.interactionId && ($1d9b5c75918107f9$var$R = Math.min($1d9b5c75918107f9$var$R, e.interactionId), $1d9b5c75918107f9$var$H = Math.max($1d9b5c75918107f9$var$H, e.interactionId), $1d9b5c75918107f9$var$B = $1d9b5c75918107f9$var$H ? ($1d9b5c75918107f9$var$H - $1d9b5c75918107f9$var$R) / 7 + 1 : 0);
    });
}, $1d9b5c75918107f9$var$O = function() {
    return $1d9b5c75918107f9$var$r ? $1d9b5c75918107f9$var$B : performance.interactionCount || 0;
}, $1d9b5c75918107f9$var$q = function() {
    "interactionCount" in performance || $1d9b5c75918107f9$var$r || ($1d9b5c75918107f9$var$r = $1d9b5c75918107f9$var$s("event", $1d9b5c75918107f9$var$N, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, $1d9b5c75918107f9$export$7f4cb060ded9173c = [
    200,
    500
], $1d9b5c75918107f9$var$_ = 0, $1d9b5c75918107f9$var$z = function() {
    return $1d9b5c75918107f9$var$O() - $1d9b5c75918107f9$var$_;
}, $1d9b5c75918107f9$var$G = [], $1d9b5c75918107f9$var$J = {}, $1d9b5c75918107f9$var$K = function(e) {
    var n = $1d9b5c75918107f9$var$G[$1d9b5c75918107f9$var$G.length - 1], t = $1d9b5c75918107f9$var$J[e.interactionId];
    if (t || $1d9b5c75918107f9$var$G.length < 10 || e.duration > n.latency) {
        if (t) t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
        else {
            var i = {
                id: e.interactionId,
                latency: e.duration,
                entries: [
                    e
                ]
            };
            $1d9b5c75918107f9$var$J[i.id] = i, $1d9b5c75918107f9$var$G.push(i);
        }
        $1d9b5c75918107f9$var$G.sort(function(e, n) {
            return n.latency - e.latency;
        }), $1d9b5c75918107f9$var$G.splice(10).forEach(function(e) {
            delete $1d9b5c75918107f9$var$J[e.id];
        });
    }
}, $1d9b5c75918107f9$export$6693a9916ea977ef = function(e, n) {
    n = n || {}, $1d9b5c75918107f9$var$C(function() {
        var t;
        $1d9b5c75918107f9$var$q();
        var i, r = $1d9b5c75918107f9$var$f("INP"), a = function(e) {
            e.forEach(function(e) {
                (e.interactionId && $1d9b5c75918107f9$var$K(e), "first-input" === e.entryType) && !$1d9b5c75918107f9$var$G.some(function(n) {
                    return n.entries.some(function(n) {
                        return e.duration === n.duration && e.startTime === n.startTime;
                    });
                }) && $1d9b5c75918107f9$var$K(e);
            });
            var n, t = (n = Math.min($1d9b5c75918107f9$var$G.length - 1, Math.floor($1d9b5c75918107f9$var$z() / 50)), $1d9b5c75918107f9$var$G[n]);
            t && t.latency !== r.value && (r.value = t.latency, r.entries = t.entries, i());
        }, c = $1d9b5c75918107f9$var$s("event", a, {
            durationThreshold: null !== (t = n.durationThreshold) && void 0 !== t ? t : 40
        });
        i = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$7f4cb060ded9173c, n.reportAllChanges), c && ("PerformanceEventTiming" in window && "interactionId" in PerformanceEventTiming.prototype && c.observe({
            type: "first-input",
            buffered: !0
        }), $1d9b5c75918107f9$var$p(function() {
            a(c.takeRecords()), r.value < 0 && $1d9b5c75918107f9$var$z() > 0 && (r.value = 0, r.entries = []), i(!0);
        }), $1d9b5c75918107f9$var$o(function() {
            $1d9b5c75918107f9$var$G = [], $1d9b5c75918107f9$var$_ = $1d9b5c75918107f9$var$O(), r = $1d9b5c75918107f9$var$f("INP"), i = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$7f4cb060ded9173c, n.reportAllChanges);
        }));
    });
}, $1d9b5c75918107f9$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $1d9b5c75918107f9$var$V = {}, $1d9b5c75918107f9$export$da982ced0ff8a670 = function(e, n) {
    n = n || {}, $1d9b5c75918107f9$var$C(function() {
        var t, i = $1d9b5c75918107f9$var$E(), r = $1d9b5c75918107f9$var$f("LCP"), a = function(e) {
            var n = e[e.length - 1];
            n && n.startTime < i.firstHiddenTime && (r.value = Math.max(n.startTime - $1d9b5c75918107f9$var$u(), 0), r.entries = [
                n
            ], t());
        }, c = $1d9b5c75918107f9$var$s("largest-contentful-paint", a);
        if (c) {
            t = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$948521ca5b0e1b17, n.reportAllChanges);
            var m = $1d9b5c75918107f9$var$v(function() {
                $1d9b5c75918107f9$var$V[r.id] || (a(c.takeRecords()), c.disconnect(), $1d9b5c75918107f9$var$V[r.id] = !0, t(!0));
            });
            [
                "keydown",
                "click"
            ].forEach(function(e) {
                addEventListener(e, function() {
                    return setTimeout(m, 0);
                }, !0);
            }), $1d9b5c75918107f9$var$p(m), $1d9b5c75918107f9$var$o(function(i) {
                r = $1d9b5c75918107f9$var$f("LCP"), t = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$948521ca5b0e1b17, n.reportAllChanges), $1d9b5c75918107f9$var$l(function() {
                    r.value = performance.now() - i.timeStamp, $1d9b5c75918107f9$var$V[r.id] = !0, t(!0);
                });
            });
        }
    });
}, $1d9b5c75918107f9$export$65c59ea8064668fc = [
    800,
    1800
], $1d9b5c75918107f9$var$Y = function e(n) {
    document.prerendering ? $1d9b5c75918107f9$var$C(function() {
        return e(n);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return e(n);
    }, !0) : setTimeout(n, 0);
}, $1d9b5c75918107f9$export$6e8eea9a35032c92 = function(e, n) {
    n = n || {};
    var t = $1d9b5c75918107f9$var$f("TTFB"), i = $1d9b5c75918107f9$var$d(e, t, $1d9b5c75918107f9$export$65c59ea8064668fc, n.reportAllChanges);
    $1d9b5c75918107f9$var$Y(function() {
        var r = $1d9b5c75918107f9$var$c();
        if (r) {
            var a = r.responseStart;
            if (a <= 0 || a > performance.now()) return;
            t.value = Math.max(a - $1d9b5c75918107f9$var$u(), 0), t.entries = [
                r
            ], i(!0), $1d9b5c75918107f9$var$o(function() {
                t = $1d9b5c75918107f9$var$f("TTFB", 0), (i = $1d9b5c75918107f9$var$d(e, t, $1d9b5c75918107f9$export$65c59ea8064668fc, n.reportAllChanges))(!0);
            });
        }
    });
};

});

parcelRegister("jE2J7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Action = void 0;
var $e4d3de3ab2e29cef$var$Action;
(function(Action) {
    Action["LARGEST_CONTENTFUL_PAINT"] = "APP::WEB_VITALS::LARGEST_CONTENTFUL_PAINT";
    Action["FIRST_INPUT_DELAY"] = "APP::WEB_VITALS::FIRST_INPUT_DELAY";
    Action["CUMULATIVE_LAYOUT_SHIFT"] = "APP::WEB_VITALS::CUMULATIVE_LAYOUT_SHIFT";
    Action["FIRST_CONTENTFUL_PAINT"] = "APP::WEB_VITALS::FIRST_CONTENTFUL_PAINT";
    Action["TIME_TO_FIRST_BYTE"] = "APP::WEB_VITALS::TIME_TO_FIRST_BYTE";
    Action["INTERACTION_TO_NEXT_PAINT"] = "APP::WEB_VITALS::INTERACTION_TO_NEXT_PAINT";
})($e4d3de3ab2e29cef$var$Action = module.exports.Action || (module.exports.Action = {}));

});

parcelRegister("6dZZq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isShopifyPing = module.exports.isShopifyPOS = module.exports.isShopifyMobile = module.exports.isShopifyEmbedded = module.exports.isMobile = void 0;

var $hJArC = parcelRequire("hJArC");
function $48840ad2aef1b41d$var$isMobile() {
    return $48840ad2aef1b41d$var$isShopifyMobile() || $48840ad2aef1b41d$var$isShopifyPOS() || $48840ad2aef1b41d$var$isShopifyPing();
}
module.exports.isMobile = $48840ad2aef1b41d$var$isMobile;
function $48840ad2aef1b41d$var$isShopifyEmbedded() {
    return $hJArC.isClient && window.top !== window.self || $hJArC.isUnframed;
}
module.exports.isShopifyEmbedded = $48840ad2aef1b41d$var$isShopifyEmbedded;
function $48840ad2aef1b41d$var$isShopifyMobile() {
    return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Shopify Mobile') >= 0;
}
module.exports.isShopifyMobile = $48840ad2aef1b41d$var$isShopifyMobile;
function $48840ad2aef1b41d$var$isShopifyPOS() {
    return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Shopify POS') >= 0;
}
module.exports.isShopifyPOS = $48840ad2aef1b41d$var$isShopifyPOS;
function $48840ad2aef1b41d$var$isShopifyPing() {
    return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Shopify Ping') >= 0;
}
module.exports.isShopifyPing = $48840ad2aef1b41d$var$isShopifyPing;

});



parcelRegister("lgJh4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.handleAppPrint = void 0;

var $aWaAl = parcelRequire("aWaAl");
function $f7be362715a33092$var$isRunningOniOS() {
    return navigator.userAgent.indexOf('iOS') >= 0;
}
function $f7be362715a33092$var$createHiddenInput() {
    var currentWindow = $aWaAl.getWindow();
    if (!currentWindow || !currentWindow.document || !currentWindow.document.body) return;
    var inputElement = currentWindow.document.createElement('input');
    inputElement.style.display = 'none';
    currentWindow.document.body.appendChild(inputElement);
    return inputElement;
}
function $f7be362715a33092$var$printWindow() {
    var _a;
    (_a = $aWaAl.getWindow()) === null || _a === void 0 || _a.print();
}
function $f7be362715a33092$var$handleMobileAppPrint() {
    var input = $f7be362715a33092$var$createHiddenInput();
    if (!input) return;
    input.select();
    $f7be362715a33092$var$printWindow();
    input.remove();
}
function $f7be362715a33092$var$handleAppPrint() {
    if ($f7be362715a33092$var$isRunningOniOS()) $f7be362715a33092$var$handleMobileAppPrint();
    else $f7be362715a33092$var$printWindow();
}
module.exports.handleAppPrint = $f7be362715a33092$var$handleAppPrint;

});
parcelRegister("aWaAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWindow = module.exports.getLocation = module.exports.redirect = module.exports.shouldRedirect = void 0;
function $7f67882ef734d17a$var$shouldRedirect(frame) {
    return frame === window;
}
module.exports.shouldRedirect = $7f67882ef734d17a$var$shouldRedirect;
function $7f67882ef734d17a$var$redirect(url) {
    var location = $7f67882ef734d17a$var$getLocation();
    if (!location) return;
    location.assign(url);
}
module.exports.redirect = $7f67882ef734d17a$var$redirect;
function $7f67882ef734d17a$var$getLocation() {
    return $7f67882ef734d17a$var$hasWindow() ? window.location : undefined;
}
module.exports.getLocation = $7f67882ef734d17a$var$getLocation;
function $7f67882ef734d17a$var$getWindow() {
    return $7f67882ef734d17a$var$hasWindow() ? window : undefined;
}
module.exports.getWindow = $7f67882ef734d17a$var$getWindow;
function $7f67882ef734d17a$var$hasWindow() {
    return typeof window !== 'undefined';
}

});


parcelRegister("daVWq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isV1Config = module.exports.MessageType = module.exports.LifecycleHook = module.exports.PermissionType = void 0;

var $lsjyd = parcelRequire("lsjyd");
Object.defineProperty(module.exports, "MessageType", {
    enumerable: true,
    get: function() {
        return $lsjyd.MessageType;
    }
});

var $lsjyd = parcelRequire("lsjyd");
Object.defineProperty(module.exports, "PermissionType", {
    enumerable: true,
    get: function() {
        return $lsjyd.PermissionType;
    }
});
Object.defineProperty(module.exports, "LifecycleHook", {
    enumerable: true,
    get: function() {
        return $lsjyd.LifecycleHook;
    }
});
/**
 * @internal
 * @param config
 */ function $9979277526ecc0ef$var$isV1Config(config) {
    return !config.host;
}
module.exports.isV1Config = $9979277526ecc0ef$var$isV1Config;

});

parcelRegister("jEstl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7yX6m = parcelRequire("7yX6m");
/**
 * Shopify App Bridge can be extended with hooks, which run when actions are dispatched and updated.
 * Hooks are middleware functions that can modify or cancel actions.
 *
 * The [validation middleware](../validate/README.md) is implemented using hooks.
 *
 * @remarks
 * Here’s an example hook that modifies all Toast show actions to have a duration of five seconds.
 *
 * ```ts
 * import createApp, {LifecycleHook, DispatchActionHook} from '@shopify/app-bridge';
 * import {Toast} from '@shopify/app-bridge/actions'
 *
 * const app = createApp({apiKey: API_KEY, host: HOST});
 *
 * function makeToastsFiveSeconds: DispatchActionHook(next) {
 *   return function(action){
 *       if(action.type === Toast.Action.SHOW) {
 *         const modifiedAction = {
 *           ...action,
 *           payload: {
 *             ...action.payload,
 *             duration: 5000,
 *           },
 *         };
 *         return next(modifiedAction);
 *       } else {
 *         // don’t modify non-Toast actions
 *         return next(action);
 *       }
 *   }
 * }
 *
 * app.hooks.set(LifecycleHook.DispatchAction, makeToastsFiveSeconds);
 * ```
 *
 * The hook function `makeToastsFiveSeconds()` takes a `next()` function as its argument.
 * The hook function returns an anonymous function, which takes the action being dispatched as its argument.
 *
 * To modify an action, call `next()` with the modified action, as in the example.
 * To cancel an action, don’t call `next()`, and the action will not be dispatched.
 */ var $e4e7d6c39fc4250b$var$Hooks = /** @class */ function() {
    function Hooks() {
        this.map = {};
    }
    Hooks.prototype.set = function(hook, handler) {
        if (!Object.prototype.hasOwnProperty.call(this.map, hook)) this.map[hook] = [];
        var value = {
            handler: handler,
            remove: function() {}
        };
        var remove = $7yX6m.addAndRemoveFromCollection(this.map[hook], value);
        value = {
            handler: handler,
            remove: remove
        };
        return remove;
    };
    Hooks.prototype.get = function(hook) {
        var value = this.map[hook];
        return value ? value.map(function(val) {
            return val.handler;
        }) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    Hooks.prototype.run = function(hook, final, context) {
        var initialArgs = [];
        for(var _i = 3; _i < arguments.length; _i++)initialArgs[_i - 3] = arguments[_i];
        var index = 0;
        var handlers = this.get(hook) || [];
        function handler() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var childHandler = handlers[index++];
            if (childHandler) return childHandler(handler).apply(context, args);
            return final.apply(context, args);
        }
        return handler.apply(context, initialArgs);
    };
    return Hooks;
}();
module.exports.default = $e4e7d6c39fc4250b$var$Hooks;

});
parcelRegister("7yX6m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeFromCollection = module.exports.addAndRemoveFromCollection = void 0;

var $7IW4H = parcelRequire("7IW4H");
Object.defineProperty(module.exports, "addAndRemoveFromCollection", {
    enumerable: true,
    get: function() {
        return $7IW4H.addAndRemoveFromCollection;
    }
});
Object.defineProperty(module.exports, "removeFromCollection", {
    enumerable: true,
    get: function() {
        return $7IW4H.removeFromCollection;
    }
});

});





parcelRegister("5s8Tb", function(module, exports) {
"use strict";
var $3f867673ab1f8c45$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3f867673ab1f8c45$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMutationObserver = module.exports.setupModalAutoSizing = void 0;

var $9gE6i = parcelRequire("9gE6i");

var $j1eoF = parcelRequire("j1eoF");

var $6dZZq = parcelRequire("6dZZq");
var $3f867673ab1f8c45$var$AUTO_SIZE_CLASS = 'app-bridge-utils-modal-auto-size';
var $3f867673ab1f8c45$var$autoSizeStylesheet = $3f867673ab1f8c45$var$createAutoSizeStylesheet();
function $3f867673ab1f8c45$var$createAutoSizeStylesheet() {
    if (typeof document === 'undefined') return null;
    var autoSizeStylesheet = document.createElement('style');
    autoSizeStylesheet.type = 'text/css';
    autoSizeStylesheet.innerHTML = "." + $3f867673ab1f8c45$var$AUTO_SIZE_CLASS + " { overflow: hidden; height: auto; min-height: auto; }";
    return autoSizeStylesheet;
}
function $3f867673ab1f8c45$var$addAutoSizing(app, id) {
    if (!$3f867673ab1f8c45$var$autoSizeStylesheet) return function() {};
    var head = document.getElementsByTagName('head')[0];
    var classList = document.body.classList;
    head.appendChild($3f867673ab1f8c45$var$autoSizeStylesheet);
    classList.add($3f867673ab1f8c45$var$AUTO_SIZE_CLASS);
    var mutationObserver = $3f867673ab1f8c45$var$createMutationObserver(app, id);
    return function() {
        classList.remove($3f867673ab1f8c45$var$AUTO_SIZE_CLASS);
        if (head.contains($3f867673ab1f8c45$var$autoSizeStylesheet)) head.removeChild($3f867673ab1f8c45$var$autoSizeStylesheet);
        if (mutationObserver) mutationObserver.disconnect();
    };
}
/**
 * Automatically track changes to the document.body height and dispatch and action to update the modal size
 * @remarks This utility should only be used for an app that is meant to open inside a Modal
 * @param app App Bridge client application instance
 * @returns function to remove the auto-size tracker for the document.body
 *
 * @public
 */ function $3f867673ab1f8c45$var$setupModalAutoSizing(app) {
    return $3f867673ab1f8c45$var$__awaiter(this, void 0, void 0, function() {
        function cleanup() {
            if (removeAutoSizing) {
                removeAutoSizing();
                removeAutoSizing = undefined;
            }
        }
        function handleModalSizeUpdate(appState) {
            var context = appState.context, id = appState.modal.id;
            if ($6dZZq.isMobile() || context !== $j1eoF.Context.Modal) {
                cleanup();
                return cleanup;
            }
            if (!removeAutoSizing) removeAutoSizing = $3f867673ab1f8c45$var$addAutoSizing(app, id);
            return cleanup;
        }
        var removeAutoSizing;
        return $3f867673ab1f8c45$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        app.getState().then(handleModalSizeUpdate)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        cleanup
                    ];
            }
        });
    });
}
module.exports.setupModalAutoSizing = $3f867673ab1f8c45$var$setupModalAutoSizing;
/**
 * Sets up modal auto sizing, using a MutationObserver.
 *
 * @param app App Bridge client application instance
 * @param id Currently active modal instance ID
 *
 * @internal
 */ function $3f867673ab1f8c45$var$createMutationObserver(app, id) {
    if (typeof document === 'undefined') return;
    var lastKnownWindowHeight = -1;
    var mutationTimeoutId;
    var mutationObserverConfig = {
        attributes: true,
        attributeOldValue: false,
        characterData: true,
        characterDataOldValue: false,
        childList: true,
        subtree: true
    };
    var mutationObserver = new MutationObserver(debouncedResizeHandler);
    mutationObserver.observe(document, mutationObserverConfig);
    updateHeight();
    function debouncedResizeHandler() {
        if (mutationTimeoutId) window.clearTimeout(mutationTimeoutId);
        mutationTimeoutId = window.setTimeout(updateHeight, 16);
    }
    function updateHeight() {
        var height = document.body.scrollHeight;
        if (height !== lastKnownWindowHeight) {
            lastKnownWindowHeight = height;
            app.dispatch($9gE6i.updateModalSize({
                id: id,
                height: String(height)
            }));
        }
    }
    return mutationObserver;
}
module.exports.createMutationObserver = $3f867673ab1f8c45$var$createMutationObserver;

});
parcelRegister("9gE6i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.Modal = module.exports.isMessageModal = module.exports.data = module.exports.update = module.exports.clickFooterButton = module.exports.updateModalSize = module.exports.closeModal = module.exports.openModal = module.exports.Size = module.exports.Action = module.exports.isIframeModal = module.exports.ModalMessage = module.exports.ModalIframe = void 0;

var $8Vhio = parcelRequire("8Vhio");
Object.defineProperty(module.exports, "ModalIframe", {
    enumerable: true,
    get: function() {
        return $8Vhio.ModalIframe;
    }
});
Object.defineProperty(module.exports, "ModalMessage", {
    enumerable: true,
    get: function() {
        return $8Vhio.ModalMessage;
    }
});
Object.defineProperty(module.exports, "isIframeModal", {
    enumerable: true,
    get: function() {
        return $8Vhio.isIframeModal;
    }
});

var $8Vhio = parcelRequire("8Vhio");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $8Vhio.Action;
    }
});
Object.defineProperty(module.exports, "Size", {
    enumerable: true,
    get: function() {
        return $8Vhio.Size;
    }
});
Object.defineProperty(module.exports, "openModal", {
    enumerable: true,
    get: function() {
        return $8Vhio.openModal;
    }
});
Object.defineProperty(module.exports, "closeModal", {
    enumerable: true,
    get: function() {
        return $8Vhio.closeModal;
    }
});
Object.defineProperty(module.exports, "updateModalSize", {
    enumerable: true,
    get: function() {
        return $8Vhio.updateModalSize;
    }
});
Object.defineProperty(module.exports, "clickFooterButton", {
    enumerable: true,
    get: function() {
        return $8Vhio.clickFooterButton;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $8Vhio.update;
    }
});
Object.defineProperty(module.exports, "data", {
    enumerable: true,
    get: function() {
        return $8Vhio.data;
    }
});
Object.defineProperty(module.exports, "isMessageModal", {
    enumerable: true,
    get: function() {
        return $8Vhio.isMessageModal;
    }
});
Object.defineProperty(module.exports, "Modal", {
    enumerable: true,
    get: function() {
        return $8Vhio.Modal;
    }
});
var $6bf4b6d1e2502703$var$create = function(app, options) {
    if ($8Vhio.isIframeModal(options)) return new $8Vhio.ModalIframe(app, options);
    return new $8Vhio.ModalMessage(app, options);
};
module.exports.create = $6bf4b6d1e2502703$var$create;

});
parcelRegister("8Vhio", function(module, exports) {
"use strict";
var $67f11024968068a1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $67f11024968068a1$var$__assign = module.exports && module.exports.__assign || function() {
    $67f11024968068a1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67f11024968068a1$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalIframe = module.exports.ModalMessage = module.exports.Modal = module.exports.isMessageModal = module.exports.isIframeModal = module.exports.data = module.exports.update = module.exports.clickFooterButton = module.exports.updateModalSize = module.exports.closeModal = module.exports.openModal = module.exports.Size = module.exports.Action = void 0;

var $2cTI8 = parcelRequire("2cTI8");

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");

var $8cXda = parcelRequire("8cXda");
var $67f11024968068a1$var$Action;
(function(Action) {
    Action["OPEN"] = "APP::MODAL::OPEN";
    Action["CLOSE"] = "APP::MODAL::CLOSE";
    Action["UPDATE"] = "APP::MODAL::UPDATE";
    Action["UPDATE_CONTENT"] = "APP::MODAL::CONTENT::UPDATE";
    Action["FOOTER_BUTTON_CLICK"] = "APP::MODAL::FOOTER::BUTTON::CLICK";
    Action["FOOTER_BUTTON_UPDATE"] = "APP::MODAL::FOOTER::BUTTON::UPDATE";
    Action["UPDATE_SIZE"] = "APP::MODAL::UPDATE_SIZE";
    Action["DATA"] = "APP::MODAL::DATA";
})($67f11024968068a1$var$Action = module.exports.Action || (module.exports.Action = {}));
/**
 * Options available to the Modal `size` param
 * @public
 */ var $67f11024968068a1$var$Size;
(function(Size) {
    /** Small modal size */ Size["Small"] = "small";
    /** Medium modal size */ Size["Medium"] = "medium";
    /** Large modal size (wider than medium) */ Size["Large"] = "large";
    /** @deprecated as of 1.6.5 */ Size["Full"] = "full";
    /**
     * @deprecated as of 1.12.x
     * @remarks
     * This option has been removed in favour of the `setUpModalAutoSizing` utility.
     */ Size["Auto"] = "auto";
})($67f11024968068a1$var$Size = module.exports.Size || (module.exports.Size = {}));
var $67f11024968068a1$var$FOOTER_BUTTON_PROPS = {
    group: $f8QDr.Group.Modal,
    subgroups: [
        'Footer'
    ],
    type: $f8QDr.ComponentType.Button
};
function $67f11024968068a1$var$openModal(modalPayload) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Modal,
        payload: modalPayload,
        type: $67f11024968068a1$var$Action.OPEN
    });
}
module.exports.openModal = $67f11024968068a1$var$openModal;
function $67f11024968068a1$var$closeModal(modalClosePayload) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Modal,
        payload: modalClosePayload,
        type: $67f11024968068a1$var$Action.CLOSE
    });
}
module.exports.closeModal = $67f11024968068a1$var$closeModal;
/**
 * Action creator for modal update size action
 * @internal
 */ function $67f11024968068a1$var$updateModalSize(updateSizePayload) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Modal,
        payload: updateSizePayload,
        type: $67f11024968068a1$var$Action.UPDATE_SIZE
    });
}
module.exports.updateModalSize = $67f11024968068a1$var$updateModalSize;
function $67f11024968068a1$var$clickFooterButton(id, payload) {
    var component = $67f11024968068a1$var$__assign({
        id: id
    }, $67f11024968068a1$var$FOOTER_BUTTON_PROPS);
    return $8cXda.clickButton($f8QDr.Group.Modal, component, payload);
}
module.exports.clickFooterButton = $67f11024968068a1$var$clickFooterButton;
function $67f11024968068a1$var$update(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Modal,
        type: $67f11024968068a1$var$Action.UPDATE
    });
}
module.exports.update = $67f11024968068a1$var$update;
function $67f11024968068a1$var$data(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Modal,
        type: $67f11024968068a1$var$Action.DATA
    });
}
module.exports.data = $67f11024968068a1$var$data;
function $67f11024968068a1$var$isIframeModal(options) {
    return typeof options.url === 'string' || typeof options.path === 'string';
}
module.exports.isIframeModal = $67f11024968068a1$var$isIframeModal;
function $67f11024968068a1$var$isMessageModal(options) {
    return typeof options.message === 'string';
}
module.exports.isMessageModal = $67f11024968068a1$var$isMessageModal;
var $67f11024968068a1$var$Modal = /** @class */ function(_super) {
    $67f11024968068a1$var$__extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = $67f11024968068a1$var$Size.Small;
        return _this;
    }
    Object.defineProperty(Modal.prototype, "footer", {
        get: function() {
            if (!this.footerPrimary && !this.footerSecondary) return undefined;
            return {
                buttons: {
                    primary: this.footerPrimary,
                    secondary: this.footerSecondary
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "footerOptions", {
        get: function() {
            if (!this.footerPrimaryOptions && !this.footerSecondaryOptions) return undefined;
            return {
                buttons: {
                    primary: this.footerPrimaryOptions,
                    secondary: this.footerSecondaryOptions
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Modal.prototype.close = function() {
        this.app.dispatch($67f11024968068a1$var$closeModal({
            id: this.id
        }));
    };
    Modal.prototype.setFooterPrimaryButton = function(newOptions, updateCb) {
        var _this = this;
        var subgroups = $67f11024968068a1$var$FOOTER_BUTTON_PROPS.subgroups;
        this.footerPrimaryOptions = this.getChildButton(newOptions, this.footerPrimaryOptions);
        this.footerPrimary = this.footerPrimaryOptions ? $2cTI8.getSingleButton(this, this.footerPrimaryOptions, subgroups, function(newPayload) {
            _this.updatePrimaryFooterButton(newPayload, updateCb);
        }) : undefined;
    };
    Modal.prototype.setFooterSecondaryButtons = function(newOptions, updateCb) {
        var _this = this;
        var subgroups = $67f11024968068a1$var$FOOTER_BUTTON_PROPS.subgroups;
        var newButtons = newOptions || [];
        var currentOptions = this.footerOptions && this.footerOptions.buttons.secondary || [];
        this.footerSecondaryOptions = this.getUpdatedChildActions(newButtons, currentOptions);
        this.footerSecondary = this.footerSecondaryOptions ? this.footerSecondaryOptions.map(function(action) {
            return $2cTI8.getSingleButton(_this, action, subgroups, function(newPayload) {
                _this.updateSecondaryFooterButton(newPayload, updateCb);
            });
        }) : undefined;
    };
    Modal.prototype.getChildButton = function(newAction, currentAction) {
        var newButtons = newAction ? [
            newAction
        ] : [];
        var currentButtons = currentAction ? [
            currentAction
        ] : [];
        var updatedButton = this.getUpdatedChildActions(newButtons, currentButtons);
        return updatedButton ? updatedButton[0] : undefined;
    };
    Modal.prototype.updatePrimaryFooterButton = function(newPayload, updateCb) {
        if (!this.footer || !this.footer.buttons.primary) return;
        if ($ditiI.updateActionFromPayload(this.footer.buttons.primary, newPayload)) updateCb();
    };
    Modal.prototype.updateSecondaryFooterButton = function(newPayload, updateCb) {
        if (!this.footer || !this.footer.buttons || !this.footer.buttons.secondary) return;
        var updated;
        for(var _i = 0, _a = this.footer.buttons.secondary; _i < _a.length; _i++){
            var action = _a[_i];
            updated = $ditiI.updateActionFromPayload(action, newPayload);
            if (updated) break;
        }
        if (updated) updateCb();
    };
    return Modal;
}($cfM0i.ActionSetWithChildren);
module.exports.Modal = $67f11024968068a1$var$Modal;
var $67f11024968068a1$var$ModalMessage = /** @class */ function(_super) {
    $67f11024968068a1$var$__extends(ModalMessage, _super);
    function ModalMessage(app, options) {
        var _this = _super.call(this, app, $f8QDr.Group.Modal, $f8QDr.Group.Modal) || this;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ModalMessage.prototype, "payload", {
        get: function() {
            return $67f11024968068a1$var$__assign($67f11024968068a1$var$__assign({}, this.options), {
                footer: this.footer,
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModalMessage.prototype, "options", {
        get: function() {
            return {
                footer: this.footerOptions,
                message: this.message,
                size: this.size,
                title: this.title
            };
        },
        enumerable: false,
        configurable: true
    });
    ModalMessage.prototype.set = function(options, shouldUpdate) {
        var _this = this;
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var title = mergedOptions.title, footer = mergedOptions.footer, message = mergedOptions.message, size = mergedOptions.size;
        this.title = title;
        this.message = message;
        this.size = size;
        this.setFooterPrimaryButton(footer ? footer.buttons.primary : undefined, function() {
            _this.dispatch($67f11024968068a1$var$Action.UPDATE);
        });
        this.setFooterSecondaryButtons(footer ? footer.buttons.secondary : undefined, function() {
            _this.dispatch($67f11024968068a1$var$Action.UPDATE);
        });
        if (shouldUpdate) this.dispatch($67f11024968068a1$var$Action.UPDATE);
        return this;
    };
    ModalMessage.prototype.dispatch = function(action) {
        switch(action){
            case $67f11024968068a1$var$Action.OPEN:
                this.app.dispatch($67f11024968068a1$var$openModal(this.payload));
                break;
            case $67f11024968068a1$var$Action.CLOSE:
                this.close();
                break;
            case $67f11024968068a1$var$Action.UPDATE:
                this.app.dispatch($67f11024968068a1$var$update(this.payload));
                break;
        }
        return this;
    };
    return ModalMessage;
}($67f11024968068a1$var$Modal);
module.exports.ModalMessage = $67f11024968068a1$var$ModalMessage;
var $67f11024968068a1$var$ModalIframe = /** @class */ function(_super) {
    $67f11024968068a1$var$__extends(ModalIframe, _super);
    function ModalIframe(app, options) {
        var _this = _super.call(this, app, $f8QDr.Group.Modal, $f8QDr.Group.Modal) || this;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ModalIframe.prototype, "payload", {
        get: function() {
            return $67f11024968068a1$var$__assign($67f11024968068a1$var$__assign({}, this.options), {
                footer: this.footer,
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModalIframe.prototype, "options", {
        get: function() {
            return {
                footer: this.footerOptions,
                path: this.path,
                size: this.size,
                title: this.title,
                url: this.url,
                loading: this.loading
            };
        },
        enumerable: false,
        configurable: true
    });
    ModalIframe.prototype.set = function(options, shouldUpdate) {
        var _this = this;
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var title = mergedOptions.title, footer = mergedOptions.footer, path = mergedOptions.path, url = mergedOptions.url, size = mergedOptions.size, loading = mergedOptions.loading;
        this.title = title;
        this.url = url;
        this.path = path;
        this.size = size;
        this.loading = loading;
        this.setFooterPrimaryButton(footer ? footer.buttons.primary : undefined, function() {
            _this.dispatch($67f11024968068a1$var$Action.UPDATE);
        });
        this.setFooterSecondaryButtons(footer ? footer.buttons.secondary : undefined, function() {
            _this.dispatch($67f11024968068a1$var$Action.UPDATE);
        });
        if (shouldUpdate) this.dispatch($67f11024968068a1$var$Action.UPDATE);
        return this;
    };
    ModalIframe.prototype.dispatch = function(action, payload) {
        switch(action){
            case $67f11024968068a1$var$Action.OPEN:
                this.app.dispatch($67f11024968068a1$var$openModal(this.payload));
                break;
            case $67f11024968068a1$var$Action.CLOSE:
                this.close();
                break;
            case $67f11024968068a1$var$Action.UPDATE:
                this.app.dispatch($67f11024968068a1$var$update(this.payload));
                break;
            case $67f11024968068a1$var$Action.DATA:
                this.app.dispatch($67f11024968068a1$var$data(payload || {}));
                break;
        }
        return this;
    };
    return ModalIframe;
}($67f11024968068a1$var$Modal);
module.exports.ModalIframe = $67f11024968068a1$var$ModalIframe;

});
parcelRegister("2cTI8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSingleButton = void 0;

var $8cXda = parcelRequire("8cXda");
function $19b7eac2774f7d65$var$getSingleButton(action, button, subgroups, updateCb) {
    action.addChild(button, action.group, subgroups);
    action.subscribeToChild(button, $8cXda.Action.UPDATE, updateCb);
    return button.payload;
}
module.exports.getSingleButton = $19b7eac2774f7d65$var$getSingleButton;

});
parcelRegister("8cXda", function(module, exports) {
"use strict";
var $5f9d5fd77b033b25$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5f9d5fd77b033b25$var$__assign = module.exports && module.exports.__assign || function() {
    $5f9d5fd77b033b25$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5f9d5fd77b033b25$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Button = module.exports.update = module.exports.clickButton = module.exports.Style = module.exports.Icon = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $5f9d5fd77b033b25$var$Action;
(function(Action) {
    Action["CLICK"] = "CLICK";
    Action["UPDATE"] = "UPDATE";
})($5f9d5fd77b033b25$var$Action = module.exports.Action || (module.exports.Action = {}));
var $5f9d5fd77b033b25$var$Icon;
(function(Icon) {
    Icon["Print"] = "print";
})($5f9d5fd77b033b25$var$Icon = module.exports.Icon || (module.exports.Icon = {}));
var $5f9d5fd77b033b25$var$Style;
(function(Style) {
    Style["Danger"] = "danger";
})($5f9d5fd77b033b25$var$Style = module.exports.Style || (module.exports.Style = {}));
function $5f9d5fd77b033b25$var$clickButton(group, component, payload) {
    var id = component.id;
    var action = $ditiI.getEventNameSpace(group, $5f9d5fd77b033b25$var$Action.CLICK, component);
    var buttonPayload = {
        id: id,
        payload: payload
    };
    return $ditiI.actionWrapper({
        type: action,
        group: group,
        payload: buttonPayload
    });
}
module.exports.clickButton = $5f9d5fd77b033b25$var$clickButton;
function $5f9d5fd77b033b25$var$update(group, component, props) {
    var id = component.id;
    var label = props.label;
    var action = $ditiI.getEventNameSpace(group, $5f9d5fd77b033b25$var$Action.UPDATE, component);
    var buttonPayload = $5f9d5fd77b033b25$var$__assign($5f9d5fd77b033b25$var$__assign({}, props), {
        id: id,
        label: label
    });
    return $ditiI.actionWrapper({
        type: action,
        group: group,
        payload: buttonPayload
    });
}
module.exports.update = $5f9d5fd77b033b25$var$update;
var $5f9d5fd77b033b25$var$Button = /** @class */ function(_super) {
    $5f9d5fd77b033b25$var$__extends(Button, _super);
    function Button(app, options) {
        var _this = _super.call(this, app, $f8QDr.ComponentType.Button, $f8QDr.Group.Button) || this;
        _this.disabled = false;
        _this.loading = false;
        _this.plain = false;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(Button.prototype, "options", {
        get: function() {
            return {
                disabled: this.disabled,
                icon: this.icon,
                label: this.label,
                style: this.style,
                loading: this.loading,
                plain: this.plain
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "payload", {
        get: function() {
            return $5f9d5fd77b033b25$var$__assign($5f9d5fd77b033b25$var$__assign({}, this.options), {
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    Button.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var label = mergedOptions.label, disabled = mergedOptions.disabled, icon = mergedOptions.icon, style = mergedOptions.style, loading = mergedOptions.loading, plain = mergedOptions.plain;
        this.label = label;
        this.disabled = Boolean(disabled);
        this.icon = icon;
        this.style = style;
        this.loading = Boolean(loading);
        this.plain = Boolean(plain);
        if (shouldUpdate) this.dispatch($5f9d5fd77b033b25$var$Action.UPDATE);
        return this;
    };
    Button.prototype.dispatch = function(action, payload) {
        switch(action){
            case $5f9d5fd77b033b25$var$Action.CLICK:
                this.app.dispatch($5f9d5fd77b033b25$var$clickButton(this.group, this.component, payload));
                break;
            case $5f9d5fd77b033b25$var$Action.UPDATE:
                var updateAction = $5f9d5fd77b033b25$var$update(this.group, this.component, this.payload);
                this.app.dispatch(updateAction);
                break;
        }
        return this;
    };
    return Button;
}($cfM0i.ActionSet);
module.exports.Button = $5f9d5fd77b033b25$var$Button;

});
parcelRegister("cfM0i", function(module, exports) {
"use strict";
var $8ebc1f4f44af8bdd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8ebc1f4f44af8bdd$var$__assign = module.exports && module.exports.__assign || function() {
    $8ebc1f4f44af8bdd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ebc1f4f44af8bdd$var$__assign.apply(this, arguments);
};
var $8ebc1f4f44af8bdd$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $8ebc1f4f44af8bdd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unsubscribeActions = module.exports.ActionSetWithChildren = module.exports.ActionSet = void 0;

var $lsjyd = parcelRequire("lsjyd");

var $7IW4H = parcelRequire("7IW4H");

var $jsxab = parcelRequire("jsxab");

var $f8QDr = parcelRequire("f8QDr");

var $8ebc1f4f44af8bdd$var$uuid_1 = $8ebc1f4f44af8bdd$var$__importDefault((parcelRequire("a4rFw")));

var $ditiI = parcelRequire("ditiI");
var $8ebc1f4f44af8bdd$var$ActionSet = /** @class */ function() {
    function ActionSet(app, type, group, id) {
        var _this = this;
        this.app = app;
        this.type = type;
        this.group = group;
        this.subgroups = [];
        this.subscriptions = [];
        if (!app) $jsxab.throwError($jsxab.Action.INVALID_ACTION, 'Missing required `app`');
        this.id = id || $8ebc1f4f44af8bdd$var$uuid_1.default();
        this.defaultGroup = group;
        var defaultSet = this.set;
        this.set = function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (!_this.app.hooks) return defaultSet.apply(_this, args);
            return (_a = _this.app.hooks).run.apply(_a, $8ebc1f4f44af8bdd$var$__spreadArray([
                $lsjyd.LifecycleHook.UpdateAction,
                defaultSet,
                _this
            ], args));
        };
    }
    ActionSet.prototype.set = function() {
        var _ = [];
        for(var _i = 0; _i < arguments.length; _i++)_[_i] = arguments[_i];
    };
    Object.defineProperty(ActionSet.prototype, "component", {
        get: function() {
            return {
                id: this.id,
                subgroups: this.subgroups,
                type: this.type
            };
        },
        enumerable: false,
        configurable: true
    });
    ActionSet.prototype.updateSubscription = function(subscriptionToRemove, group, subgroups) {
        var eventType = subscriptionToRemove.eventType, callback = subscriptionToRemove.callback, component = subscriptionToRemove.component;
        var currentIndex;
        currentIndex = this.subscriptions.findIndex(function(subscription) {
            return subscription === subscriptionToRemove;
        });
        if (currentIndex >= 0) this.subscriptions[currentIndex].unsubscribe();
        else currentIndex = undefined;
        this.group = group;
        this.subgroups = subgroups;
        Object.assign(component, {
            subgroups: this.subgroups
        });
        return this.subscribe(eventType, callback, component, currentIndex);
    };
    ActionSet.prototype.error = function(callback) {
        var _this = this;
        var subscriptionIndices = [];
        $ditiI.forEachInEnum($jsxab.Action, function(eventNameSpace) {
            // Keep track of subscription index so we can call unsubscribe later
            // This ensure it will continue to work even when the subscription has been updated
            subscriptionIndices.push(_this.subscriptions.length);
            _this.subscribe(eventNameSpace, callback);
        });
        return function() {
            var subscriptionsToRemove = subscriptionIndices.map(function(index) {
                return _this.subscriptions[index];
            });
            subscriptionsToRemove.forEach(function(toRemove) {
                $7IW4H.removeFromCollection(_this.subscriptions, toRemove, function(removed) {
                    removed.unsubscribe();
                });
            });
        };
    };
    ActionSet.prototype.subscribe = function(eventName, callback, component, currentIndex) {
        var _this = this;
        var eventComponent = component || this.component;
        var eventType = eventName.toUpperCase();
        var boundedCallback = typeof currentIndex === 'number' ? callback : callback.bind(this);
        var eventNameSpace;
        if ($jsxab.isErrorEventName(eventName)) eventNameSpace = $ditiI.getEventNameSpace($f8QDr.Group.Error, eventName, $8ebc1f4f44af8bdd$var$__assign($8ebc1f4f44af8bdd$var$__assign({}, eventComponent), {
            type: ''
        }));
        else eventNameSpace = $ditiI.getEventNameSpace(this.group, eventName, eventComponent);
        var unsubscribe = this.app.subscribe(eventNameSpace, boundedCallback, component ? component.id : this.id);
        var subscription = {
            eventType: eventType,
            unsubscribe: unsubscribe,
            callback: boundedCallback,
            component: eventComponent,
            updateSubscribe: function(group, subgroups) {
                return _this.updateSubscription(subscription, group, subgroups);
            }
        };
        if (typeof currentIndex === 'number' && currentIndex >= 0 && currentIndex < this.subscriptions.length) this.subscriptions[currentIndex] = subscription;
        else this.subscriptions.push(subscription);
        return unsubscribe;
    };
    ActionSet.prototype.unsubscribe = function(resetOnly) {
        if (resetOnly === void 0) resetOnly = false;
        $8ebc1f4f44af8bdd$var$unsubscribeActions(this.subscriptions, this.defaultGroup, resetOnly);
        return this;
    };
    return ActionSet;
}();
module.exports.ActionSet = $8ebc1f4f44af8bdd$var$ActionSet;
var $8ebc1f4f44af8bdd$var$ActionSetWithChildren = /** @class */ function(_super) {
    $8ebc1f4f44af8bdd$var$__extends(ActionSetWithChildren, _super);
    function ActionSetWithChildren() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.children = [];
        return _this;
    }
    ActionSetWithChildren.prototype.unsubscribe = function(unsubscribeChildren, resetParentOnly) {
        if (unsubscribeChildren === void 0) unsubscribeChildren = true;
        if (resetParentOnly === void 0) resetParentOnly = false;
        $8ebc1f4f44af8bdd$var$unsubscribeActions(this.subscriptions, this.defaultGroup, resetParentOnly);
        this.children.forEach(function(child) {
            if (child instanceof ActionSetWithChildren) child.unsubscribe(unsubscribeChildren, !unsubscribeChildren);
            else child.unsubscribe(!unsubscribeChildren);
        });
        return this;
    };
    ActionSetWithChildren.prototype.getChild = function(id) {
        var childIndex = this.children.findIndex(function(child) {
            return child.id === id;
        });
        return childIndex >= 0 ? this.children[childIndex] : undefined;
    };
    ActionSetWithChildren.prototype.getChildIndex = function(id) {
        return this.children.findIndex(function(child) {
            return child.id === id;
        });
    };
    ActionSetWithChildren.prototype.getChildSubscriptions = function(id, eventType) {
        return this.subscriptions.filter(function(sub) {
            return sub.component.id === id && (!eventType || eventType === sub.eventType);
        });
    };
    ActionSetWithChildren.prototype.addChild = function(child, group, subgroups) {
        var _this = this;
        var subscriptions = child.subscriptions;
        var existingChild = this.getChild(child.id);
        // Add child if it doesn't already exist
        if (!existingChild) this.children.push(child);
        if (!subscriptions || group === child.group && subgroups === child.subgroups) return this;
        subscriptions.forEach(function(subscription) {
            var updateSubscribe = subscription.updateSubscribe;
            updateSubscribe(group, subgroups);
        });
        // Update child's group and subgroups
        Object.assign(child, {
            group: group,
            subgroups: subgroups
        });
        // Update child's children subscriptions
        if (child instanceof ActionSetWithChildren) child.children.forEach(function(childIter) {
            return _this.addChild(childIter, group, subgroups);
        });
        return this;
    };
    ActionSetWithChildren.prototype.removeChild = function(id) {
        var _this = this;
        $7IW4H.removeFromCollection(this.children, this.getChild(id), function() {
            var toBeRemoved = _this.subscriptions.filter(function(subs) {
                return subs.component.id === id;
            });
            toBeRemoved.forEach(function(toRemove) {
                $7IW4H.removeFromCollection(_this.subscriptions, toRemove, function(removed) {
                    removed.unsubscribe();
                });
            });
        });
        return this;
    };
    ActionSetWithChildren.prototype.subscribeToChild = function(child, eventName, callback) {
        var _this = this;
        var boundedCallback = callback.bind(this);
        if (eventName instanceof Array) {
            eventName.forEach(function(eventNameIter) {
                return _this.subscribeToChild(child, eventNameIter, callback);
            });
            return this;
        }
        if (typeof eventName !== 'string') return this;
        var eventType = eventName.toUpperCase();
        var currentSubscriptions = this.getChildSubscriptions(child.id, eventType);
        if (currentSubscriptions.length > 0) // Subscription is already there, simply update it
        currentSubscriptions.forEach(function(subs) {
            return subs.updateSubscribe(_this.group, child.subgroups);
        });
        else {
            var childComponent = {
                id: child.id,
                subgroups: child.subgroups,
                type: child.type
            };
            this.subscribe(eventType, boundedCallback, childComponent);
        }
        return this;
    };
    ActionSetWithChildren.prototype.getUpdatedChildActions = function(newActions, currentActions) {
        if (newActions.length === 0) {
            while(currentActions.length > 0){
                var action = currentActions.pop();
                if (!action) break;
                this.removeChild(action.id);
            }
            return undefined;
        }
        // Only allow unique actions
        var uniqueActions = newActions.filter(function(action, index, actionsArr) {
            return index === actionsArr.indexOf(action);
        });
        var newActionIds = uniqueActions.map(function(action) {
            return action.id;
        });
        // Remove unused actions
        var unusedActions = currentActions.filter(function(action) {
            return newActionIds.indexOf(action.id) < 0;
        });
        while(unusedActions.length > 0){
            var action = unusedActions.pop();
            if (!action) break;
            this.removeChild(action.id);
        }
        return uniqueActions;
    };
    return ActionSetWithChildren;
}($8ebc1f4f44af8bdd$var$ActionSet);
module.exports.ActionSetWithChildren = $8ebc1f4f44af8bdd$var$ActionSetWithChildren;
function $8ebc1f4f44af8bdd$var$unsubscribeActions(subscriptions, defaultGroup, reassign) {
    if (reassign === void 0) reassign = false;
    subscriptions.forEach(function(subscription) {
        if (reassign) {
            var updateSubscribe = subscription.updateSubscribe;
            // eslint-disable-next-line no-warning-comments
            // TODO: Support cases where we don't wipe out group and subgroups to defaults
            updateSubscribe(defaultGroup, []);
        } else {
            var unsubscribe = subscription.unsubscribe;
            unsubscribe();
        }
    });
    if (!reassign) subscriptions.length = 0;
}
module.exports.unsubscribeActions = $8ebc1f4f44af8bdd$var$unsubscribeActions;

});
parcelRegister("a4rFw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateUuid = void 0;
/**
 * Convert a number or array of integers to a string of padded hex octets.
 */ function $754fbd8ef4c31a44$var$asHex(value) {
    return Array.from(value).map(function(i) {
        return ("00" + i.toString(16)).slice(-2);
    }).join('');
}
/**
 * Attempt to securely generate random bytes/
 */ function $754fbd8ef4c31a44$var$getRandomBytes(size) {
    // SPRNG
    if (typeof Uint8Array === 'function' && typeof window === 'object' && window.crypto) {
        var buffer = new Uint8Array(size);
        var randomValues = window.crypto.getRandomValues(buffer);
        if (randomValues) return randomValues;
    }
    // Insecure random
    return Array.from(new Array(size), function() {
        return Math.random() * 255 | 0;
    });
}
/**
 * Generate a RFC4122-compliant v4 UUID.
 *
 * @see http://www.ietf.org/rfc/rfc4122.txt
 */ function $754fbd8ef4c31a44$var$generateUuid() {
    var version = 64;
    var clockSeqHiAndReserved = $754fbd8ef4c31a44$var$getRandomBytes(1);
    var timeHiAndVersion = $754fbd8ef4c31a44$var$getRandomBytes(2);
    clockSeqHiAndReserved[0] &= 191;
    // tslint:disable-next-line:binary-expression-operand-order
    timeHiAndVersion[0] &= 15 | version;
    return [
        // time-low
        $754fbd8ef4c31a44$var$asHex($754fbd8ef4c31a44$var$getRandomBytes(4)),
        '-',
        // time-mid
        $754fbd8ef4c31a44$var$asHex($754fbd8ef4c31a44$var$getRandomBytes(2)),
        '-',
        // time-high-and-version
        $754fbd8ef4c31a44$var$asHex(timeHiAndVersion),
        '-',
        // clock-seq-and-reserved
        $754fbd8ef4c31a44$var$asHex(clockSeqHiAndReserved),
        // clock-seq-loq
        $754fbd8ef4c31a44$var$asHex($754fbd8ef4c31a44$var$getRandomBytes(1)),
        '-',
        // node
        $754fbd8ef4c31a44$var$asHex($754fbd8ef4c31a44$var$getRandomBytes(6))
    ].join('');
}
module.exports.generateUuid = $754fbd8ef4c31a44$var$generateUuid;
module.exports.default = $754fbd8ef4c31a44$var$generateUuid;

});







parcelRegister("bJVCp", function(module, exports) {
"use strict";
var $88c09785ad261e01$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88c09785ad261e01$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $88c09785ad261e01$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$88c09785ad261e01$var$__exportStar((parcelRequire("dUIDG")), module.exports);

$88c09785ad261e01$var$__exportStar((parcelRequire("kyXX6")), module.exports);

});
parcelRegister("dUIDG", function(module, exports) {
"use strict";
var $a21321b7d0efa059$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a21321b7d0efa059$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a21321b7d0efa059$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a21321b7d0efa059$var$__createBinding(result, mod, k);
    }
    $a21321b7d0efa059$var$__setModuleDefault(result, mod);
    return result;
};
var $a21321b7d0efa059$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a21321b7d0efa059$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSessionToken = void 0;

var $jsxab = parcelRequire("jsxab");

var $a21321b7d0efa059$var$SessionToken = $a21321b7d0efa059$var$__importStar((parcelRequire("2t21q")));
function $a21321b7d0efa059$var$getSessionToken(appBridge) {
    return $a21321b7d0efa059$var$__awaiter(this, void 0, void 0, function() {
        return $a21321b7d0efa059$var$__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    var unsubscribe = appBridge.subscribe($a21321b7d0efa059$var$SessionToken.Action.RESPOND, function(_a) {
                        var sessionToken = _a.sessionToken;
                        if (sessionToken) resolve(sessionToken);
                        else reject($jsxab.fromAction('Failed to retrieve a session token', $jsxab.Action.FAILED_AUTHENTICATION));
                        unsubscribe();
                    });
                    appBridge.dispatch($a21321b7d0efa059$var$SessionToken.request());
                })
            ];
        });
    });
}
module.exports.getSessionToken = $a21321b7d0efa059$var$getSessionToken;

});
parcelRegister("2t21q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.respond = module.exports.request = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $f8QDr = parcelRequire("f8QDr");
var $1cbfdbbe8a60311d$var$Action;
(function(Action) {
    Action["REQUEST"] = "APP::SESSION_TOKEN::REQUEST";
    Action["RESPOND"] = "APP::SESSION_TOKEN::RESPOND";
})($1cbfdbbe8a60311d$var$Action = module.exports.Action || (module.exports.Action = {}));
function $1cbfdbbe8a60311d$var$request() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.SessionToken,
        type: $1cbfdbbe8a60311d$var$Action.REQUEST
    });
}
module.exports.request = $1cbfdbbe8a60311d$var$request;
function $1cbfdbbe8a60311d$var$respond(sessionToken) {
    return $ditiI.actionWrapper({
        payload: sessionToken,
        group: $f8QDr.Group.SessionToken,
        type: $1cbfdbbe8a60311d$var$Action.RESPOND
    });
}
module.exports.respond = $1cbfdbbe8a60311d$var$respond;

});


parcelRegister("kyXX6", function(module, exports) {
"use strict";
var $ef857ceba8a86cad$var$__assign = module.exports && module.exports.__assign || function() {
    $ef857ceba8a86cad$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef857ceba8a86cad$var$__assign.apply(this, arguments);
};
var $ef857ceba8a86cad$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ef857ceba8a86cad$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.authenticatedFetch = void 0;

var $kaqVb = parcelRequire("kaqVb");

var $dUIDG = parcelRequire("dUIDG");
function $ef857ceba8a86cad$var$authenticatedFetch(app, fetchOperationOrOptions) {
    var _this = this;
    if (fetchOperationOrOptions === void 0) fetchOperationOrOptions = undefined;
    return function(uri, options) {
        if (options === void 0) options = {};
        return $ef857ceba8a86cad$var$__awaiter(_this, void 0, void 0, function() {
            var sessionToken, headers, finalHeaders, authenticatedFetchOptions, fetchOperation, response, reauthorizeUrl_1, requestFailureReauthorizeUrlHeader_1;
            var _a;
            return $ef857ceba8a86cad$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $dUIDG.getSessionToken(app)
                        ];
                    case 1:
                        sessionToken = _b.sent();
                        headers = new Headers(options.headers);
                        headers.append('Authorization', "Bearer " + sessionToken);
                        headers.append('X-Requested-With', 'XMLHttpRequest');
                        finalHeaders = {};
                        headers.forEach(function(value, key) {
                            finalHeaders[key] = value;
                        });
                        authenticatedFetchOptions = typeof fetchOperationOrOptions === 'object' ? fetchOperationOrOptions : undefined;
                        fetchOperation = typeof fetchOperationOrOptions === 'function' ? fetchOperationOrOptions : (_a = authenticatedFetchOptions === null || authenticatedFetchOptions === void 0 ? void 0 : authenticatedFetchOptions.fetchOperation) !== null && _a !== void 0 ? _a : fetch;
                        return [
                            4 /*yield*/ ,
                            fetchOperation(uri, $ef857ceba8a86cad$var$__assign($ef857ceba8a86cad$var$__assign({}, options), {
                                headers: finalHeaders
                            }))
                        ];
                    case 2:
                        response = _b.sent();
                        if (authenticatedFetchOptions) {
                            reauthorizeUrl_1 = authenticatedFetchOptions.reauthorizeUrl, requestFailureReauthorizeUrlHeader_1 = authenticatedFetchOptions.requestFailureReauthorizeUrlHeader;
                            response.headers.forEach(function(value, name) {
                                if (requestFailureReauthorizeUrlHeader_1.toLowerCase() === name.toLowerCase()) {
                                    var redirectUrl = new URL(reauthorizeUrl_1 || value, location.href).href;
                                    var redirect = $kaqVb.Redirect.create(app);
                                    if (redirectUrl) redirect.dispatch($kaqVb.Redirect.Action.REMOTE, redirectUrl);
                                    else // eslint-disable-next-line no-console
                                    console.warn("Couldn't find a fallback auth path to redirect to.");
                                }
                            });
                        }
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
}
module.exports.authenticatedFetch = $ef857ceba8a86cad$var$authenticatedFetch;

});
parcelRegister("kaqVb", function(module, exports) {
"use strict";
var $eae99fd572e271bd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eae99fd572e271bd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eae99fd572e271bd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eae99fd572e271bd$var$__createBinding(result, mod, k);
    }
    $eae99fd572e271bd$var$__setModuleDefault(result, mod);
    return result;
};
var $eae99fd572e271bd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $eae99fd572e271bd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebVitals = module.exports.unstable_Picker = module.exports.Performance = module.exports.Pos = module.exports.AppLink = module.exports.ChannelMenu = module.exports.NavigationMenu = module.exports.Share = module.exports.ContextualSaveBar = module.exports.MarketingExternalActivityTopBar = module.exports.TitleBar = module.exports.SessionToken = module.exports.ResourcePicker = module.exports.Redirect = module.exports.Print = module.exports.ModalContent = module.exports.Modal = module.exports.Loading = module.exports.LeaveConfirmation = module.exports.History = module.exports.Toast = module.exports.Fullscreen = module.exports.FeedbackModal = module.exports.Features = module.exports.Flash = module.exports.Error = module.exports.Client = module.exports.Cart = module.exports.Scanner = module.exports.ButtonGroup = module.exports.Button = module.exports.AuthCode = module.exports.isAppBridgeAction = void 0;

var $eae99fd572e271bd$var$AuthCode = $eae99fd572e271bd$var$__importStar((parcelRequire("jWnCY")));
module.exports.AuthCode = $eae99fd572e271bd$var$AuthCode;

var $eae99fd572e271bd$var$Button = $eae99fd572e271bd$var$__importStar((parcelRequire("kI6MI")));
module.exports.Button = $eae99fd572e271bd$var$Button;

var $eae99fd572e271bd$var$ButtonGroup = $eae99fd572e271bd$var$__importStar((parcelRequire("3yPaJ")));
module.exports.ButtonGroup = $eae99fd572e271bd$var$ButtonGroup;

var $eae99fd572e271bd$var$Cart = $eae99fd572e271bd$var$__importStar((parcelRequire("eZfU1")));
module.exports.Cart = $eae99fd572e271bd$var$Cart;

var $eae99fd572e271bd$var$Client = $eae99fd572e271bd$var$__importStar((parcelRequire("1Ono8")));
module.exports.Client = $eae99fd572e271bd$var$Client;

var $eae99fd572e271bd$var$Error = $eae99fd572e271bd$var$__importStar((parcelRequire("1maiX")));
module.exports.Error = $eae99fd572e271bd$var$Error;

var $eae99fd572e271bd$var$Flash = $eae99fd572e271bd$var$__importStar((parcelRequire("j2d97")));
module.exports.Flash = $eae99fd572e271bd$var$Flash;

var $eae99fd572e271bd$var$Features = $eae99fd572e271bd$var$__importStar((parcelRequire("92uGF")));
module.exports.Features = $eae99fd572e271bd$var$Features;

var $eae99fd572e271bd$var$FeedbackModal = $eae99fd572e271bd$var$__importStar((parcelRequire("7NgdN")));
module.exports.FeedbackModal = $eae99fd572e271bd$var$FeedbackModal;

var $eae99fd572e271bd$var$Fullscreen = $eae99fd572e271bd$var$__importStar((parcelRequire("kpKpp")));
module.exports.Fullscreen = $eae99fd572e271bd$var$Fullscreen;

var $eae99fd572e271bd$var$LeaveConfirmation = $eae99fd572e271bd$var$__importStar((parcelRequire("7TNJ4")));
module.exports.LeaveConfirmation = $eae99fd572e271bd$var$LeaveConfirmation;

var $eae99fd572e271bd$var$Loading = $eae99fd572e271bd$var$__importStar((parcelRequire("dHAOf")));
module.exports.Loading = $eae99fd572e271bd$var$Loading;

var $eae99fd572e271bd$var$Modal = $eae99fd572e271bd$var$__importStar((parcelRequire("9gE6i")));
module.exports.Modal = $eae99fd572e271bd$var$Modal;

var $eae99fd572e271bd$var$ModalContent = $eae99fd572e271bd$var$__importStar((parcelRequire("gvdlm")));
module.exports.ModalContent = $eae99fd572e271bd$var$ModalContent;

var $eae99fd572e271bd$var$History = $eae99fd572e271bd$var$__importStar((parcelRequire("9fkeR")));
module.exports.History = $eae99fd572e271bd$var$History;

var $eae99fd572e271bd$var$Redirect = $eae99fd572e271bd$var$__importStar((parcelRequire("cKecn")));
module.exports.Redirect = $eae99fd572e271bd$var$Redirect;

var $eae99fd572e271bd$var$Print = $eae99fd572e271bd$var$__importStar((parcelRequire("5hZgj")));
module.exports.Print = $eae99fd572e271bd$var$Print;

var $eae99fd572e271bd$var$ResourcePicker = $eae99fd572e271bd$var$__importStar((parcelRequire("63FoC")));
module.exports.ResourcePicker = $eae99fd572e271bd$var$ResourcePicker;

var $eae99fd572e271bd$var$Scanner = $eae99fd572e271bd$var$__importStar((parcelRequire("iHUBk")));
module.exports.Scanner = $eae99fd572e271bd$var$Scanner;

var $eae99fd572e271bd$var$SessionToken = $eae99fd572e271bd$var$__importStar((parcelRequire("6ZuZX")));
module.exports.SessionToken = $eae99fd572e271bd$var$SessionToken;

var $eae99fd572e271bd$var$TitleBar = $eae99fd572e271bd$var$__importStar((parcelRequire("75nq8")));
module.exports.TitleBar = $eae99fd572e271bd$var$TitleBar;

var $eae99fd572e271bd$var$Toast = $eae99fd572e271bd$var$__importStar((parcelRequire("hKtt3")));
module.exports.Toast = $eae99fd572e271bd$var$Toast;

var $eae99fd572e271bd$var$ContextualSaveBar = $eae99fd572e271bd$var$__importStar((parcelRequire("57uPI")));
module.exports.ContextualSaveBar = $eae99fd572e271bd$var$ContextualSaveBar;

var $eae99fd572e271bd$var$Share = $eae99fd572e271bd$var$__importStar((parcelRequire("4d8dB")));
module.exports.Share = $eae99fd572e271bd$var$Share;

var $eae99fd572e271bd$var$NavigationMenu = $eae99fd572e271bd$var$__importStar((parcelRequire("26UOk")));
module.exports.NavigationMenu = $eae99fd572e271bd$var$NavigationMenu;

var $eae99fd572e271bd$var$ChannelMenu = $eae99fd572e271bd$var$__importStar((parcelRequire("doCr6")));
module.exports.ChannelMenu = $eae99fd572e271bd$var$ChannelMenu;

var $eae99fd572e271bd$var$AppLink = $eae99fd572e271bd$var$__importStar((parcelRequire("3g8Ye")));
module.exports.AppLink = $eae99fd572e271bd$var$AppLink;

var $eae99fd572e271bd$var$Pos = $eae99fd572e271bd$var$__importStar((parcelRequire("liH6l")));
module.exports.Pos = $eae99fd572e271bd$var$Pos;

var $eae99fd572e271bd$var$MarketingExternalActivityTopBar = $eae99fd572e271bd$var$__importStar((parcelRequire("jv6D2")));
module.exports.MarketingExternalActivityTopBar = $eae99fd572e271bd$var$MarketingExternalActivityTopBar;

var $eae99fd572e271bd$var$Performance = $eae99fd572e271bd$var$__importStar((parcelRequire("cwMLc")));
module.exports.Performance = $eae99fd572e271bd$var$Performance;

var $eae99fd572e271bd$var$unstable_Picker = $eae99fd572e271bd$var$__importStar((parcelRequire("fnmJU")));
module.exports.unstable_Picker = $eae99fd572e271bd$var$unstable_Picker;

var $eae99fd572e271bd$var$WebVitals = $eae99fd572e271bd$var$__importStar((parcelRequire("7LSs8")));
module.exports.WebVitals = $eae99fd572e271bd$var$WebVitals;

var $gMmax = parcelRequire("gMmax");
Object.defineProperty(module.exports, "isAppBridgeAction", {
    enumerable: true,
    get: function() {
        return $gMmax.isAppBridgeAction;
    }
});

$eae99fd572e271bd$var$__exportStar((parcelRequire("hrrN9")), module.exports);

});
parcelRegister("jWnCY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.request = module.exports.Action = module.exports.respond = void 0;

var $6bWS0 = parcelRequire("6bWS0");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $6bWS0.Action;
    }
});

var $jrseT = parcelRequire("jrseT");

var $hrrN9 = parcelRequire("hrrN9");

var $6bWS0 = parcelRequire("6bWS0");
Object.defineProperty(module.exports, "respond", {
    enumerable: true,
    get: function() {
        return $6bWS0.respond;
    }
});
function $e845c3131c55a6b6$var$request(id) {
    return $jrseT.actionWrapper({
        group: $hrrN9.Group.AuthCode,
        type: $6bWS0.Action.REQUEST,
        payload: {
            id: id
        }
    });
}
module.exports.request = $e845c3131c55a6b6$var$request;

});
parcelRegister("6bWS0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.respond = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $f8QDr = parcelRequire("f8QDr");
var $48216f8483e6b102$var$Action;
(function(Action) {
    Action["REQUEST"] = "APP::AUTH_CODE::REQUEST";
    Action["RESPOND"] = "APP::AUTH_CODE::RESPOND";
})($48216f8483e6b102$var$Action = module.exports.Action || (module.exports.Action = {}));
function $48216f8483e6b102$var$respond(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.AuthCode,
        type: $48216f8483e6b102$var$Action.RESPOND
    });
}
module.exports.respond = $48216f8483e6b102$var$respond;

});


parcelRegister("kI6MI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.isValidButtonProps = module.exports.Button = module.exports.update = module.exports.Style = module.exports.Icon = module.exports.clickButton = module.exports.Action = void 0;

var $8cXda = parcelRequire("8cXda");
Object.defineProperty(module.exports, "Button", {
    enumerable: true,
    get: function() {
        return $8cXda.Button;
    }
});

var $8cXda = parcelRequire("8cXda");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $8cXda.Action;
    }
});
Object.defineProperty(module.exports, "clickButton", {
    enumerable: true,
    get: function() {
        return $8cXda.clickButton;
    }
});
Object.defineProperty(module.exports, "Icon", {
    enumerable: true,
    get: function() {
        return $8cXda.Icon;
    }
});
Object.defineProperty(module.exports, "Style", {
    enumerable: true,
    get: function() {
        return $8cXda.Style;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $8cXda.update;
    }
});
function $f13d2dff6f921a7e$var$isValidButtonProps(button) {
    return typeof button.id === 'string' && typeof button.label === 'string';
}
module.exports.isValidButtonProps = $f13d2dff6f921a7e$var$isValidButtonProps;
function $f13d2dff6f921a7e$var$create(app, options) {
    return new $8cXda.Button(app, options);
}
module.exports.create = $f13d2dff6f921a7e$var$create;

});

parcelRegister("3yPaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.ButtonGroup = module.exports.isGroupedButtonPayload = module.exports.isGroupedButton = module.exports.update = module.exports.Action = void 0;

var $6O9od = parcelRequire("6O9od");
Object.defineProperty(module.exports, "ButtonGroup", {
    enumerable: true,
    get: function() {
        return $6O9od.ButtonGroup;
    }
});

var $6O9od = parcelRequire("6O9od");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $6O9od.Action;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $6O9od.update;
    }
});
Object.defineProperty(module.exports, "isGroupedButton", {
    enumerable: true,
    get: function() {
        return $6O9od.isGroupedButton;
    }
});
Object.defineProperty(module.exports, "isGroupedButtonPayload", {
    enumerable: true,
    get: function() {
        return $6O9od.isGroupedButtonPayload;
    }
});
function $297c3dcdbf1682ec$var$create(app, options) {
    return new $6O9od.ButtonGroup(app, options);
}
module.exports.create = $297c3dcdbf1682ec$var$create;

});
parcelRegister("6O9od", function(module, exports) {
"use strict";
var $4f4eb226b699932c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4f4eb226b699932c$var$__assign = module.exports && module.exports.__assign || function() {
    $4f4eb226b699932c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f4eb226b699932c$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.ButtonGroup = module.exports.isGroupedButtonPayload = module.exports.isGroupedButton = module.exports.update = module.exports.Action = void 0;

var $2cTI8 = parcelRequire("2cTI8");

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $4f4eb226b699932c$var$Action;
(function(Action) {
    Action["UPDATE"] = "UPDATE";
})($4f4eb226b699932c$var$Action = module.exports.Action || (module.exports.Action = {}));
function $4f4eb226b699932c$var$update(group, component, props) {
    return $4f4eb226b699932c$var$buttonActionWrapper(group, component, $4f4eb226b699932c$var$Action.UPDATE, props);
}
module.exports.update = $4f4eb226b699932c$var$update;
function $4f4eb226b699932c$var$isGroupedButton(options) {
    var castOptions = options;
    return castOptions.buttons && castOptions.buttons.length > 0 && castOptions.label !== undefined;
}
module.exports.isGroupedButton = $4f4eb226b699932c$var$isGroupedButton;
function $4f4eb226b699932c$var$isGroupedButtonPayload(payload) {
    var castOptions = payload;
    return Array.isArray(castOptions.buttons) && typeof castOptions.id === 'string' && typeof castOptions.label === 'string';
}
module.exports.isGroupedButtonPayload = $4f4eb226b699932c$var$isGroupedButtonPayload;
var $4f4eb226b699932c$var$ButtonGroup = /** @class */ function(_super) {
    $4f4eb226b699932c$var$__extends(ButtonGroup, _super);
    function ButtonGroup(app, options) {
        var _this = _super.call(this, app, $f8QDr.ComponentType.ButtonGroup, $f8QDr.Group.ButtonGroup) || this;
        _this.disabled = false;
        _this.plain = false;
        _this.buttonsOptions = [];
        _this.buttons = [];
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ButtonGroup.prototype, "options", {
        get: function() {
            return {
                buttons: this.buttonsOptions,
                disabled: this.disabled,
                label: this.label,
                plain: this.plain
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "payload", {
        get: function() {
            return $4f4eb226b699932c$var$__assign($4f4eb226b699932c$var$__assign({}, this.options), {
                buttons: this.buttons,
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    ButtonGroup.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var label = mergedOptions.label, disabled = mergedOptions.disabled, buttons = mergedOptions.buttons, plain = mergedOptions.plain;
        this.label = label;
        this.disabled = Boolean(disabled);
        this.buttons = this.getButtons(buttons);
        this.plain = Boolean(plain);
        if (shouldUpdate) this.dispatch($4f4eb226b699932c$var$Action.UPDATE);
        return this;
    };
    ButtonGroup.prototype.dispatch = function(action) {
        switch(action){
            case $4f4eb226b699932c$var$Action.UPDATE:
                var updateAction = $4f4eb226b699932c$var$update(this.group, this.component, this.payload);
                this.app.dispatch(updateAction);
                break;
        }
        return this;
    };
    ButtonGroup.prototype.updateButtons = function(newPayload) {
        if (!this.buttons || this.buttons.length === 0) return;
        var updated;
        for(var _i = 0, _a = this.buttons; _i < _a.length; _i++){
            var action = _a[_i];
            updated = $ditiI.updateActionFromPayload(action, newPayload);
            if (updated) break;
        }
        if (updated) this.dispatch($4f4eb226b699932c$var$Action.UPDATE);
    };
    ButtonGroup.prototype.getSingleButton = function(button) {
        return $2cTI8.getSingleButton(this, button, this.subgroups, this.updateButtons);
    };
    ButtonGroup.prototype.getButtons = function(buttonOptions) {
        var _this = this;
        var buttons = [];
        if (!buttonOptions) return [];
        buttonOptions.forEach(function(button) {
            var singleButton = $2cTI8.getSingleButton(_this, button, _this.subgroups, _this.updateButtons);
            buttons.push(singleButton);
        });
        this.buttonsOptions = buttonOptions;
        return buttons;
    };
    return ButtonGroup;
}($cfM0i.ActionSetWithChildren);
module.exports.ButtonGroup = $4f4eb226b699932c$var$ButtonGroup;
function $4f4eb226b699932c$var$create(app, options) {
    return new $4f4eb226b699932c$var$ButtonGroup(app, options);
}
module.exports.create = $4f4eb226b699932c$var$create;
function $4f4eb226b699932c$var$buttonActionWrapper(group, component, eventName, props, payload) {
    var id = component.id;
    var label = props.label;
    var action = $ditiI.getEventNameSpace(group, eventName, component);
    var buttonPayload = $4f4eb226b699932c$var$__assign($4f4eb226b699932c$var$__assign({}, props), {
        id: id,
        label: label,
        payload: payload
    });
    return $ditiI.actionWrapper({
        type: action,
        group: group,
        payload: buttonPayload
    });
}

});


parcelRegister("eZfU1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.setLineItemProperties = module.exports.removeLineItemDiscount = module.exports.setLineItemDiscount = module.exports.removeLineItem = module.exports.updateLineItem = module.exports.addLineItem = module.exports.removeProperties = module.exports.setProperties = module.exports.setDiscount = module.exports.updateCustomerAddress = module.exports.addCustomerAddress = module.exports.setCustomer = module.exports.update = module.exports.fetch = module.exports.Cart = module.exports.Action = void 0;

var $kOdkv = parcelRequire("kOdkv");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $kOdkv.Action;
    }
});
Object.defineProperty(module.exports, "Cart", {
    enumerable: true,
    get: function() {
        return $kOdkv.Cart;
    }
});
Object.defineProperty(module.exports, "fetch", {
    enumerable: true,
    get: function() {
        return $kOdkv.fetch;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $kOdkv.update;
    }
});
Object.defineProperty(module.exports, "setCustomer", {
    enumerable: true,
    get: function() {
        return $kOdkv.setCustomer;
    }
});
Object.defineProperty(module.exports, "addCustomerAddress", {
    enumerable: true,
    get: function() {
        return $kOdkv.addCustomerAddress;
    }
});
Object.defineProperty(module.exports, "updateCustomerAddress", {
    enumerable: true,
    get: function() {
        return $kOdkv.updateCustomerAddress;
    }
});
Object.defineProperty(module.exports, "setDiscount", {
    enumerable: true,
    get: function() {
        return $kOdkv.setDiscount;
    }
});
Object.defineProperty(module.exports, "setProperties", {
    enumerable: true,
    get: function() {
        return $kOdkv.setProperties;
    }
});
Object.defineProperty(module.exports, "removeProperties", {
    enumerable: true,
    get: function() {
        return $kOdkv.removeProperties;
    }
});
Object.defineProperty(module.exports, "addLineItem", {
    enumerable: true,
    get: function() {
        return $kOdkv.addLineItem;
    }
});
Object.defineProperty(module.exports, "updateLineItem", {
    enumerable: true,
    get: function() {
        return $kOdkv.updateLineItem;
    }
});
Object.defineProperty(module.exports, "removeLineItem", {
    enumerable: true,
    get: function() {
        return $kOdkv.removeLineItem;
    }
});
Object.defineProperty(module.exports, "setLineItemDiscount", {
    enumerable: true,
    get: function() {
        return $kOdkv.setLineItemDiscount;
    }
});
Object.defineProperty(module.exports, "removeLineItemDiscount", {
    enumerable: true,
    get: function() {
        return $kOdkv.removeLineItemDiscount;
    }
});
Object.defineProperty(module.exports, "setLineItemProperties", {
    enumerable: true,
    get: function() {
        return $kOdkv.setLineItemProperties;
    }
});
function $ae93191cc4ad7d97$var$create(app, options) {
    return new $kOdkv.Cart(app, options);
}
module.exports.create = $ae93191cc4ad7d97$var$create;

});
parcelRegister("kOdkv", function(module, exports) {
"use strict";
var $f262d12f1638131b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f262d12f1638131b$var$__assign = module.exports && module.exports.__assign || function() {
    $f262d12f1638131b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f262d12f1638131b$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cart = module.exports.setLineItemProperties = module.exports.removeLineItemDiscount = module.exports.setLineItemDiscount = module.exports.removeLineItem = module.exports.updateLineItem = module.exports.addLineItem = module.exports.removeProperties = module.exports.setProperties = module.exports.setDiscount = module.exports.updateCustomerAddress = module.exports.addCustomerAddress = module.exports.setCustomer = module.exports.update = module.exports.fetch = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $f262d12f1638131b$var$Action;
(function(Action) {
    Action["FETCH"] = "APP::CART::FETCH";
    Action["UPDATE"] = "APP::CART::UPDATE";
    Action["SET_CUSTOMER"] = "APP::CART::SET_CUSTOMER";
    Action["REMOVE_CUSTOMER"] = "APP::CART::REMOVE_CUSTOMER";
    Action["ADD_CUSTOMER_ADDRESS"] = "APP::CART::ADD_CUSTOMER_ADDRESS";
    Action["UPDATE_CUSTOMER_ADDRESS"] = "APP::CART::UPDATE_CUSTOMER_ADDRESS";
    Action["SET_DISCOUNT"] = "APP::CART::SET_DISCOUNT";
    Action["REMOVE_DISCOUNT"] = "APP::CART::REMOVE_DISCOUNT";
    Action["SET_PROPERTIES"] = "APP::CART::SET_PROPERTIES";
    Action["REMOVE_PROPERTIES"] = "APP::CART::REMOVE_PROPERTIES";
    Action["CLEAR"] = "APP::CART::CLEAR";
    Action["ADD_LINE_ITEM"] = "APP::CART::ADD_LINE_ITEM";
    Action["UPDATE_LINE_ITEM"] = "APP::CART::UPDATE_LINE_ITEM";
    Action["REMOVE_LINE_ITEM"] = "APP::CART::REMOVE_LINE_ITEM";
    Action["SET_LINE_ITEM_DISCOUNT"] = "APP::CART::SET_LINE_ITEM_DISCOUNT";
    Action["REMOVE_LINE_ITEM_DISCOUNT"] = "APP::CART::REMOVE_LINE_ITEM_DISCOUNT";
    Action["SET_LINE_ITEM_PROPERTIES"] = "APP::CART::SET_LINE_ITEM_PROPERTIES";
    Action["REMOVE_LINE_ITEM_PROPERTIES"] = "APP::CART::REMOVE_LINE_ITEM_PROPERTIES";
})($f262d12f1638131b$var$Action = module.exports.Action || (module.exports.Action = {}));
/**
 * Cart action
 * @internal
 */ function $f262d12f1638131b$var$createCartAction(type, payload) {
    if (payload === void 0) payload = {};
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Cart,
        type: type,
        payload: payload
    });
}
function $f262d12f1638131b$var$fetch() {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.FETCH);
}
module.exports.fetch = $f262d12f1638131b$var$fetch;
function $f262d12f1638131b$var$update(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.UPDATE, payload);
}
module.exports.update = $f262d12f1638131b$var$update;
function $f262d12f1638131b$var$setCustomer(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.SET_CUSTOMER, payload);
}
module.exports.setCustomer = $f262d12f1638131b$var$setCustomer;
function $f262d12f1638131b$var$addCustomerAddress(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.ADD_CUSTOMER_ADDRESS, payload);
}
module.exports.addCustomerAddress = $f262d12f1638131b$var$addCustomerAddress;
function $f262d12f1638131b$var$updateCustomerAddress(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.UPDATE_CUSTOMER_ADDRESS, payload);
}
module.exports.updateCustomerAddress = $f262d12f1638131b$var$updateCustomerAddress;
function $f262d12f1638131b$var$setDiscount(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.SET_DISCOUNT, payload);
}
module.exports.setDiscount = $f262d12f1638131b$var$setDiscount;
function $f262d12f1638131b$var$setProperties(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.SET_PROPERTIES, payload);
}
module.exports.setProperties = $f262d12f1638131b$var$setProperties;
function $f262d12f1638131b$var$removeProperties(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.REMOVE_PROPERTIES, payload);
}
module.exports.removeProperties = $f262d12f1638131b$var$removeProperties;
function $f262d12f1638131b$var$addLineItem(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.ADD_LINE_ITEM, payload);
}
module.exports.addLineItem = $f262d12f1638131b$var$addLineItem;
function $f262d12f1638131b$var$updateLineItem(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.UPDATE_LINE_ITEM, payload);
}
module.exports.updateLineItem = $f262d12f1638131b$var$updateLineItem;
function $f262d12f1638131b$var$removeLineItem(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.REMOVE_LINE_ITEM, payload);
}
module.exports.removeLineItem = $f262d12f1638131b$var$removeLineItem;
function $f262d12f1638131b$var$setLineItemDiscount(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.SET_LINE_ITEM_DISCOUNT, payload);
}
module.exports.setLineItemDiscount = $f262d12f1638131b$var$setLineItemDiscount;
function $f262d12f1638131b$var$removeLineItemDiscount(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.REMOVE_LINE_ITEM_DISCOUNT, payload);
}
module.exports.removeLineItemDiscount = $f262d12f1638131b$var$removeLineItemDiscount;
function $f262d12f1638131b$var$setLineItemProperties(payload) {
    return $f262d12f1638131b$var$createCartAction($f262d12f1638131b$var$Action.SET_LINE_ITEM_PROPERTIES, payload);
}
module.exports.setLineItemProperties = $f262d12f1638131b$var$setLineItemProperties;
/**
 * Cart
 */ var $f262d12f1638131b$var$Cart = /** @class */ function(_super) {
    $f262d12f1638131b$var$__extends(Cart, _super);
    function Cart(app, options) {
        return _super.call(this, app, $f8QDr.Group.Cart, $f8QDr.Group.Cart, options ? options.id : undefined) || this;
    }
    Cart.prototype.dispatch = function(action, payload) {
        switch(action){
            case $f262d12f1638131b$var$Action.FETCH:
                this.dispatchCartAction($f262d12f1638131b$var$Action.FETCH);
                break;
            case $f262d12f1638131b$var$Action.UPDATE:
                this.dispatchCartAction($f262d12f1638131b$var$Action.UPDATE, payload);
                break;
            case $f262d12f1638131b$var$Action.SET_CUSTOMER:
                this.dispatchCartAction($f262d12f1638131b$var$Action.SET_CUSTOMER, payload);
                break;
            case $f262d12f1638131b$var$Action.REMOVE_CUSTOMER:
                this.dispatchCartAction($f262d12f1638131b$var$Action.REMOVE_CUSTOMER, payload);
                break;
            case $f262d12f1638131b$var$Action.ADD_CUSTOMER_ADDRESS:
                this.dispatchCartAction($f262d12f1638131b$var$Action.ADD_CUSTOMER_ADDRESS, payload);
                break;
            case $f262d12f1638131b$var$Action.UPDATE_CUSTOMER_ADDRESS:
                this.dispatchCartAction($f262d12f1638131b$var$Action.UPDATE_CUSTOMER_ADDRESS, payload);
                break;
            case $f262d12f1638131b$var$Action.SET_DISCOUNT:
                this.dispatchCartAction($f262d12f1638131b$var$Action.SET_DISCOUNT, payload);
                break;
            case $f262d12f1638131b$var$Action.REMOVE_DISCOUNT:
                this.dispatchCartAction($f262d12f1638131b$var$Action.REMOVE_DISCOUNT, payload);
                break;
            case $f262d12f1638131b$var$Action.SET_PROPERTIES:
                this.dispatchCartAction($f262d12f1638131b$var$Action.SET_PROPERTIES, payload);
                break;
            case $f262d12f1638131b$var$Action.REMOVE_PROPERTIES:
                this.dispatchCartAction($f262d12f1638131b$var$Action.REMOVE_PROPERTIES, payload);
                break;
            case $f262d12f1638131b$var$Action.CLEAR:
                this.dispatchCartAction($f262d12f1638131b$var$Action.CLEAR, payload);
                break;
            case $f262d12f1638131b$var$Action.ADD_LINE_ITEM:
                this.dispatchCartAction($f262d12f1638131b$var$Action.ADD_LINE_ITEM, payload);
                break;
            case $f262d12f1638131b$var$Action.UPDATE_LINE_ITEM:
                this.dispatchCartAction($f262d12f1638131b$var$Action.UPDATE_LINE_ITEM, payload);
                break;
            case $f262d12f1638131b$var$Action.REMOVE_LINE_ITEM:
                this.dispatchCartAction($f262d12f1638131b$var$Action.REMOVE_LINE_ITEM, payload);
                break;
            case $f262d12f1638131b$var$Action.SET_LINE_ITEM_DISCOUNT:
                this.dispatchCartAction($f262d12f1638131b$var$Action.SET_LINE_ITEM_DISCOUNT, payload);
                break;
            case $f262d12f1638131b$var$Action.REMOVE_LINE_ITEM_DISCOUNT:
                this.dispatchCartAction($f262d12f1638131b$var$Action.REMOVE_LINE_ITEM_DISCOUNT, payload);
                break;
            case $f262d12f1638131b$var$Action.SET_LINE_ITEM_PROPERTIES:
                this.dispatchCartAction($f262d12f1638131b$var$Action.SET_LINE_ITEM_PROPERTIES, payload);
                break;
            case $f262d12f1638131b$var$Action.REMOVE_LINE_ITEM_PROPERTIES:
                this.dispatchCartAction($f262d12f1638131b$var$Action.REMOVE_LINE_ITEM_PROPERTIES, payload);
                break;
        }
        return this;
    };
    Cart.prototype.dispatchCartAction = function(type, payload) {
        this.app.dispatch($f262d12f1638131b$var$createCartAction(type, $f262d12f1638131b$var$__assign($f262d12f1638131b$var$__assign({}, payload), {
            id: this.id
        })));
    };
    return Cart;
}($cfM0i.ActionSet);
module.exports.Cart = $f262d12f1638131b$var$Cart;

});


parcelRegister("j2d97", function(module, exports) {
"use strict";
var $ddb866bd14081cee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ddb866bd14081cee$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ddb866bd14081cee$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ddb866bd14081cee$var$__exportStar((parcelRequire("4ZcJ8")), module.exports);

});
parcelRegister("4ZcJ8", function(module, exports) {
"use strict";
var $3a16bb382720903f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.Flash = module.exports.show = module.exports.clear = void 0;

var $dGEy9 = parcelRequire("dGEy9");
Object.defineProperty(module.exports, "clear", {
    enumerable: true,
    get: function() {
        return $dGEy9.clear;
    }
});
Object.defineProperty(module.exports, "show", {
    enumerable: true,
    get: function() {
        return $dGEy9.show;
    }
});
var $3a16bb382720903f$var$Flash = /** @class */ function(_super) {
    $3a16bb382720903f$var$__extends(Flash, _super);
    function Flash() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Flash;
}($dGEy9.Toast);
module.exports.Flash = $3a16bb382720903f$var$Flash;
function $3a16bb382720903f$var$create(app, options) {
    return new $3a16bb382720903f$var$Flash(app, options);
}
module.exports.create = $3a16bb382720903f$var$create;

});
parcelRegister("dGEy9", function(module, exports) {
"use strict";
var $9f6ea6f2df15b3f9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9f6ea6f2df15b3f9$var$__assign = module.exports && module.exports.__assign || function() {
    $9f6ea6f2df15b3f9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9f6ea6f2df15b3f9$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Toast = module.exports.primaryAction = module.exports.clear = module.exports.show = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $9f6ea6f2df15b3f9$var$Action;
(function(Action) {
    Action["SHOW"] = "APP::TOAST::SHOW";
    Action["CLEAR"] = "APP::TOAST::CLEAR";
    Action["ACTION"] = "APP::TOAST::ACTION";
})($9f6ea6f2df15b3f9$var$Action = module.exports.Action || (module.exports.Action = {}));
function $9f6ea6f2df15b3f9$var$show(toastMessage) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Toast,
        payload: toastMessage,
        type: $9f6ea6f2df15b3f9$var$Action.SHOW
    });
}
module.exports.show = $9f6ea6f2df15b3f9$var$show;
function $9f6ea6f2df15b3f9$var$clear(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Toast,
        type: $9f6ea6f2df15b3f9$var$Action.CLEAR
    });
}
module.exports.clear = $9f6ea6f2df15b3f9$var$clear;
function $9f6ea6f2df15b3f9$var$primaryAction(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Toast,
        type: $9f6ea6f2df15b3f9$var$Action.ACTION
    });
}
module.exports.primaryAction = $9f6ea6f2df15b3f9$var$primaryAction;
var $9f6ea6f2df15b3f9$var$Toast = /** @class */ function(_super) {
    $9f6ea6f2df15b3f9$var$__extends(Toast, _super);
    function Toast(app, options) {
        var _this = _super.call(this, app, $f8QDr.Group.Toast, $f8QDr.Group.Toast) || this;
        _this.message = '';
        _this.duration = 5000;
        _this.set(options);
        return _this;
    }
    Object.defineProperty(Toast.prototype, "options", {
        get: function() {
            var _a;
            return {
                duration: this.duration,
                isError: this.isError,
                message: this.message,
                action: ((_a = this.action) === null || _a === void 0 ? void 0 : _a.content) ? {
                    content: this.action.content
                } : undefined
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Toast.prototype, "payload", {
        get: function() {
            return $9f6ea6f2df15b3f9$var$__assign({
                id: this.id
            }, this.options);
        },
        enumerable: false,
        configurable: true
    });
    Toast.prototype.set = function(options) {
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var message = mergedOptions.message, duration = mergedOptions.duration, isError = mergedOptions.isError, action = mergedOptions.action;
        this.message = message;
        this.duration = duration;
        this.isError = isError;
        this.action = (action === null || action === void 0 ? void 0 : action.content) ? {
            content: action.content || ''
        } : undefined;
        return this;
    };
    Toast.prototype.dispatch = function(action) {
        switch(action){
            case $9f6ea6f2df15b3f9$var$Action.SHOW:
                var openAction = $9f6ea6f2df15b3f9$var$show(this.payload);
                this.app.dispatch(openAction);
                break;
            case $9f6ea6f2df15b3f9$var$Action.CLEAR:
                this.app.dispatch($9f6ea6f2df15b3f9$var$clear({
                    id: this.id
                }));
                break;
            case $9f6ea6f2df15b3f9$var$Action.ACTION:
                this.app.dispatch($9f6ea6f2df15b3f9$var$primaryAction({
                    id: this.id
                }));
                break;
        }
        return this;
    };
    return Toast;
}($cfM0i.ActionSet);
module.exports.Toast = $9f6ea6f2df15b3f9$var$Toast;

});



parcelRegister("92uGF", function(module, exports) {
"use strict";
var $694c1ad05702f35b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $694c1ad05702f35b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $694c1ad05702f35b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$694c1ad05702f35b$var$__exportStar((parcelRequire("ap3v3")), module.exports);

$694c1ad05702f35b$var$__exportStar((parcelRequire("aEcbl")), module.exports);

});
parcelRegister("ap3v3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.Features = void 0;

var $9SlK5 = parcelRequire("9SlK5");
Object.defineProperty(module.exports, "Features", {
    enumerable: true,
    get: function() {
        return $9SlK5.Features;
    }
});
/**
 * @public
 */ function $792ef42d625c9e65$var$create(app, options) {
    return new $9SlK5.Features(app, options);
}
module.exports.create = $792ef42d625c9e65$var$create;

});
parcelRegister("9SlK5", function(module, exports) {
"use strict";
var $730a05c81caac24f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $730a05c81caac24f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $730a05c81caac24f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$730a05c81caac24f$var$__exportStar((parcelRequire("ffOH1")), module.exports);

$730a05c81caac24f$var$__exportStar((parcelRequire("bXMB3")), module.exports);

});
parcelRegister("ffOH1", function(module, exports) {
"use strict";
var $b1af94476a79e975$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b1af94476a79e975$var$__assign = module.exports && module.exports.__assign || function() {
    $b1af94476a79e975$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b1af94476a79e975$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Features = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");

var $bXMB3 = parcelRequire("bXMB3");
/**
 * A set of Actions for Updating, Requesting Features of AppBridge
 * @public
 */ var $b1af94476a79e975$var$Features = /** @class */ function(_super) {
    $b1af94476a79e975$var$__extends(Features, _super);
    function Features(app, options) {
        return _super.call(this, app, $f8QDr.Group.Features, $f8QDr.Group.Features, options ? options.id : undefined) || this;
    }
    /**
     * @public
     */ Features.prototype.dispatch = function(action, payload) {
        switch(action){
            case $bXMB3.Action.REQUEST:
                this.dispatchFeaturesAction($bXMB3.Action.REQUEST, payload);
                break;
        }
        return this;
    };
    /**
     * @internal
     */ Features.prototype.dispatchFeaturesAction = function(type, payload) {
        this.app.dispatch($ditiI.actionWrapper({
            group: $f8QDr.Group.Features,
            type: type,
            payload: $b1af94476a79e975$var$__assign($b1af94476a79e975$var$__assign({}, payload || {}), {
                id: this.id
            })
        }));
    };
    return Features;
}($cfM0i.ActionSet);
module.exports.Features = $b1af94476a79e975$var$Features;

});
parcelRegister("bXMB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Action = void 0;
/**
 * Action Types for the Features group
 * @public
 */ var $8b5ae6afc955c317$var$Action;
(function(Action) {
    Action["UPDATE"] = "APP::FEATURES::UPDATE";
    Action["REQUEST"] = "APP::FEATURES::REQUEST";
    /**
     * @deprecated as of 2.1.0. Use "APP::FEATURES::UPDATE" instead
     */ Action["REQUEST_UPDATE"] = "APP::FEATURES::REQUEST::UPDATE";
})($8b5ae6afc955c317$var$Action = module.exports.Action || (module.exports.Action = {}));

});




parcelRegister("aEcbl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Action = void 0;

var $9SlK5 = parcelRequire("9SlK5");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $9SlK5.Action;
    }
});

});


parcelRegister("7NgdN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.FeedbackModal = module.exports.close = module.exports.open = module.exports.Action = void 0;

var $8TWqN = parcelRequire("8TWqN");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $8TWqN.Action;
    }
});
Object.defineProperty(module.exports, "open", {
    enumerable: true,
    get: function() {
        return $8TWqN.open;
    }
});
Object.defineProperty(module.exports, "close", {
    enumerable: true,
    get: function() {
        return $8TWqN.close;
    }
});
Object.defineProperty(module.exports, "FeedbackModal", {
    enumerable: true,
    get: function() {
        return $8TWqN.FeedbackModal;
    }
});
Object.defineProperty(module.exports, "create", {
    enumerable: true,
    get: function() {
        return $8TWqN.create;
    }
});

});
parcelRegister("8TWqN", function(module, exports) {
"use strict";
var $67b0c8fb7348a5f7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $67b0c8fb7348a5f7$var$__assign = module.exports && module.exports.__assign || function() {
    $67b0c8fb7348a5f7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67b0c8fb7348a5f7$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.FeedbackModal = module.exports.close = module.exports.open = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
/**
 * Action for the Feedback Modal group
 * @public
 */ var $67b0c8fb7348a5f7$var$Action;
(function(Action) {
    Action["OPEN"] = "APP::FEEDBACK_MODAL::OPEN";
    Action["CLOSE"] = "APP::FEEDBACK_MODAL::CLOSE";
})($67b0c8fb7348a5f7$var$Action = module.exports.Action || (module.exports.Action = {}));
function $67b0c8fb7348a5f7$var$open(payload) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.FeedbackModal,
        payload: payload,
        type: $67b0c8fb7348a5f7$var$Action.OPEN
    });
}
module.exports.open = $67b0c8fb7348a5f7$var$open;
function $67b0c8fb7348a5f7$var$close(payload) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.FeedbackModal,
        payload: payload,
        type: $67b0c8fb7348a5f7$var$Action.CLOSE
    });
}
module.exports.close = $67b0c8fb7348a5f7$var$close;
/**
 * FeedbackModal action set
 */ var $67b0c8fb7348a5f7$var$FeedbackModal = /** @class */ function(_super) {
    $67b0c8fb7348a5f7$var$__extends(FeedbackModal, _super);
    /**
     * Returns a new instance of a FeedbackModal action set
     * @param app the client application
     */ function FeedbackModal(app, options) {
        var _this = _super.call(this, app, $f8QDr.Group.FeedbackModal, $f8QDr.Group.FeedbackModal) || this;
        _this.options = options;
        _this.set(options);
        return _this;
    }
    Object.defineProperty(FeedbackModal.prototype, "payload", {
        /**
         * Returns the action set payload
         */ get: function() {
            return $67b0c8fb7348a5f7$var$__assign({
                id: this.id
            }, this.options);
        },
        enumerable: false,
        configurable: true
    });
    FeedbackModal.prototype.set = function(options) {
        this.options = $ditiI.getMergedProps(this.options, options);
        return this;
    };
    /**
     * Dispatches a given action with the action set payload
     * @param action the action enum
     * @returns the action set instance
     */ FeedbackModal.prototype.dispatch = function(action) {
        switch(action){
            case $67b0c8fb7348a5f7$var$Action.OPEN:
                var openAction = $67b0c8fb7348a5f7$var$open(this.payload);
                this.app.dispatch(openAction);
                break;
            case $67b0c8fb7348a5f7$var$Action.CLOSE:
                var closeAction = $67b0c8fb7348a5f7$var$close(this.payload);
                this.app.dispatch(closeAction);
                break;
        }
        return this;
    };
    return FeedbackModal;
}($cfM0i.ActionSet);
module.exports.FeedbackModal = $67b0c8fb7348a5f7$var$FeedbackModal;
/**
 * Returns a new instance of a FeedbackModal action set
 * @param app the client application
 */ function $67b0c8fb7348a5f7$var$create(app, options) {
    return new $67b0c8fb7348a5f7$var$FeedbackModal(app, options);
}
module.exports.create = $67b0c8fb7348a5f7$var$create;

});


parcelRegister("kpKpp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.Action = module.exports.Fullscreen = module.exports.exit = module.exports.enter = void 0;

var $9vs0f = parcelRequire("9vs0f");
Object.defineProperty(module.exports, "Fullscreen", {
    enumerable: true,
    get: function() {
        return $9vs0f.Fullscreen;
    }
});
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $9vs0f.Action;
    }
});

var $9vs0f = parcelRequire("9vs0f");
Object.defineProperty(module.exports, "enter", {
    enumerable: true,
    get: function() {
        return $9vs0f.enter;
    }
});
Object.defineProperty(module.exports, "exit", {
    enumerable: true,
    get: function() {
        return $9vs0f.exit;
    }
});
/**
 * Returns a new instance of a Fullscreen action set
 * @param app the client application
 *
 * @beta
 */ function $edca2441c61df799$var$create(app) {
    return new $9vs0f.Fullscreen(app);
}
module.exports.create = $edca2441c61df799$var$create;

});
parcelRegister("9vs0f", function(module, exports) {
"use strict";
var $6ebcbb1fefd25dbb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fullscreen = module.exports.exit = module.exports.enter = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
/**
 * Fullscreen action type enum
 * @remarks includes the action prefix and group
 *
 * @beta
 */ var $6ebcbb1fefd25dbb$var$Action;
(function(Action) {
    Action["ENTER"] = "APP::FULLSCREEN::ENTER";
    Action["EXIT"] = "APP::FULLSCREEN::EXIT";
})($6ebcbb1fefd25dbb$var$Action = module.exports.Action || (module.exports.Action = {}));
function $6ebcbb1fefd25dbb$var$enter() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Fullscreen,
        type: $6ebcbb1fefd25dbb$var$Action.ENTER
    });
}
module.exports.enter = $6ebcbb1fefd25dbb$var$enter;
function $6ebcbb1fefd25dbb$var$exit() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Fullscreen,
        type: $6ebcbb1fefd25dbb$var$Action.EXIT
    });
}
module.exports.exit = $6ebcbb1fefd25dbb$var$exit;
/**
 * Fullscreen action set
 * @beta
 */ var $6ebcbb1fefd25dbb$var$Fullscreen = /** @class */ function(_super) {
    $6ebcbb1fefd25dbb$var$__extends(Fullscreen, _super);
    /**
     * Returns a new instance of a Fullscreen action set
     * @param app the client application
     */ function Fullscreen(app) {
        return _super.call(this, app, $f8QDr.Group.Fullscreen, $f8QDr.Group.Fullscreen) || this;
    }
    Object.defineProperty(Fullscreen.prototype, "payload", {
        /**
         * Returns the action set payload
         */ get: function() {
            return {
                id: this.id
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Dispatches a given action with the action set payload
     * @param action the action enum
     * @returns the action set instance
     */ Fullscreen.prototype.dispatch = function(action) {
        this.app.dispatch($ditiI.actionWrapper({
            group: this.group,
            type: action,
            payload: this.payload
        }));
        return this;
    };
    return Fullscreen;
}($cfM0i.ActionSet);
module.exports.Fullscreen = $6ebcbb1fefd25dbb$var$Fullscreen;

});


parcelRegister("7TNJ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.LeaveConfirmation = module.exports.confirm = module.exports.disable = module.exports.enable = module.exports.Action = void 0;

var $kmT2g = parcelRequire("kmT2g");
Object.defineProperty(module.exports, "LeaveConfirmation", {
    enumerable: true,
    get: function() {
        return $kmT2g.LeaveConfirmation;
    }
});

var $kmT2g = parcelRequire("kmT2g");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $kmT2g.Action;
    }
});
Object.defineProperty(module.exports, "enable", {
    enumerable: true,
    get: function() {
        return $kmT2g.enable;
    }
});
Object.defineProperty(module.exports, "disable", {
    enumerable: true,
    get: function() {
        return $kmT2g.disable;
    }
});
Object.defineProperty(module.exports, "confirm", {
    enumerable: true,
    get: function() {
        return $kmT2g.confirm;
    }
});
/**
 * Returns a new instance of a Leave Confirmation action set
 * @param app the client application
 */ function $5c043df7f98b2625$var$create(app, options) {
    if (options === void 0) options = {};
    return new $kmT2g.LeaveConfirmation(app, options);
}
module.exports.create = $5c043df7f98b2625$var$create;

});
parcelRegister("kmT2g", function(module, exports) {
"use strict";
var $ed408da180aa84f1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ed408da180aa84f1$var$__assign = module.exports && module.exports.__assign || function() {
    $ed408da180aa84f1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed408da180aa84f1$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LeaveConfirmation = module.exports.confirm = module.exports.disable = module.exports.enable = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
/**
 * Action for the Leave Confirmation group
 * @public
 */ var $ed408da180aa84f1$var$Action;
(function(Action) {
    Action["ENABLE"] = "APP::LEAVE_CONFIRMATION::ENABLE";
    Action["DISABLE"] = "APP::LEAVE_CONFIRMATION::DISABLE";
    Action["CONFIRM"] = "APP::LEAVE_CONFIRMATION::CONFIRM";
})($ed408da180aa84f1$var$Action = module.exports.Action || (module.exports.Action = {}));
function $ed408da180aa84f1$var$enable(payload) {
    if (payload === void 0) payload = {};
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.LeaveConfirmation,
        payload: payload,
        type: $ed408da180aa84f1$var$Action.ENABLE
    });
}
module.exports.enable = $ed408da180aa84f1$var$enable;
function $ed408da180aa84f1$var$disable(payload) {
    if (payload === void 0) payload = {};
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.LeaveConfirmation,
        payload: payload,
        type: $ed408da180aa84f1$var$Action.DISABLE
    });
}
module.exports.disable = $ed408da180aa84f1$var$disable;
function $ed408da180aa84f1$var$confirm(payload) {
    if (payload === void 0) payload = {};
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.LeaveConfirmation,
        payload: payload,
        type: $ed408da180aa84f1$var$Action.CONFIRM
    });
}
module.exports.confirm = $ed408da180aa84f1$var$confirm;
/**
 * Leave Confirmation action set
 */ var $ed408da180aa84f1$var$LeaveConfirmation = /** @class */ function(_super) {
    $ed408da180aa84f1$var$__extends(LeaveConfirmation, _super);
    /**
     * Returns a new instance of a Leave Confirmation action set
     * @param app the client application
     */ function LeaveConfirmation(app, options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, app, $f8QDr.Group.LeaveConfirmation, $f8QDr.Group.LeaveConfirmation) || this;
        _this.options = options;
        _this.set(options);
        return _this;
    }
    Object.defineProperty(LeaveConfirmation.prototype, "payload", {
        /**
         * Returns the action set payload
         */ get: function() {
            return $ed408da180aa84f1$var$__assign({
                id: this.id
            }, this.options);
        },
        enumerable: false,
        configurable: true
    });
    LeaveConfirmation.prototype.set = function(options) {
        this.options = $ditiI.getMergedProps(this.options, options);
        return this;
    };
    /**
     * Dispatches a given action with the action set payload
     * @param action the action enum
     * @returns the action set instance
     */ LeaveConfirmation.prototype.dispatch = function(action) {
        switch(action){
            case $ed408da180aa84f1$var$Action.ENABLE:
                var enableAction = $ed408da180aa84f1$var$enable(this.payload);
                this.app.dispatch(enableAction);
                break;
            case $ed408da180aa84f1$var$Action.DISABLE:
                var disableAction = $ed408da180aa84f1$var$disable(this.payload);
                this.app.dispatch(disableAction);
                break;
            case $ed408da180aa84f1$var$Action.CONFIRM:
                var confirmAction = $ed408da180aa84f1$var$confirm(this.payload);
                this.app.dispatch(confirmAction);
                break;
        }
        return this;
    };
    return LeaveConfirmation;
}($cfM0i.ActionSet);
module.exports.LeaveConfirmation = $ed408da180aa84f1$var$LeaveConfirmation;

});


parcelRegister("dHAOf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.stop = module.exports.start = module.exports.Action = module.exports.Loading = void 0;

var $8EWmI = parcelRequire("8EWmI");
Object.defineProperty(module.exports, "Loading", {
    enumerable: true,
    get: function() {
        return $8EWmI.Loading;
    }
});

var $8EWmI = parcelRequire("8EWmI");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $8EWmI.Action;
    }
});
Object.defineProperty(module.exports, "start", {
    enumerable: true,
    get: function() {
        return $8EWmI.start;
    }
});
Object.defineProperty(module.exports, "stop", {
    enumerable: true,
    get: function() {
        return $8EWmI.stop;
    }
});
function $9f9bd81b778c4aca$var$create(app) {
    return new $8EWmI.Loading(app);
}
module.exports.create = $9f9bd81b778c4aca$var$create;

});
parcelRegister("8EWmI", function(module, exports) {
"use strict";
var $64df555452b1bd2a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Loading = module.exports.stop = module.exports.start = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $64df555452b1bd2a$var$Action;
(function(Action) {
    Action["START"] = "APP::LOADING::START";
    Action["STOP"] = "APP::LOADING::STOP";
})($64df555452b1bd2a$var$Action = module.exports.Action || (module.exports.Action = {}));
function $64df555452b1bd2a$var$start(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Loading,
        type: $64df555452b1bd2a$var$Action.START
    });
}
module.exports.start = $64df555452b1bd2a$var$start;
function $64df555452b1bd2a$var$stop(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Loading,
        type: $64df555452b1bd2a$var$Action.STOP
    });
}
module.exports.stop = $64df555452b1bd2a$var$stop;
var $64df555452b1bd2a$var$Loading = /** @class */ function(_super) {
    $64df555452b1bd2a$var$__extends(Loading, _super);
    function Loading(app) {
        return _super.call(this, app, $f8QDr.Group.Loading, $f8QDr.Group.Loading) || this;
    }
    Object.defineProperty(Loading.prototype, "payload", {
        get: function() {
            return {
                id: this.id
            };
        },
        enumerable: false,
        configurable: true
    });
    Loading.prototype.dispatch = function(action) {
        switch(action){
            case $64df555452b1bd2a$var$Action.START:
                this.app.dispatch($64df555452b1bd2a$var$start(this.payload));
                break;
            case $64df555452b1bd2a$var$Action.STOP:
                this.app.dispatch($64df555452b1bd2a$var$stop(this.payload));
                break;
        }
        return this;
    };
    return Loading;
}($cfM0i.ActionSet);
module.exports.Loading = $64df555452b1bd2a$var$Loading;

});


parcelRegister("gvdlm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.ModalContent = module.exports.Action = void 0;

var $gFuME = parcelRequire("gFuME");
Object.defineProperty(module.exports, "ModalContent", {
    enumerable: true,
    get: function() {
        return $gFuME.ModalContent;
    }
});

var $gFuME = parcelRequire("gFuME");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $gFuME.Action;
    }
});
/**
 * @public
 */ function $c039e458e897defe$var$create(app, options) {
    return new $gFuME.ModalContent(app, options);
}
module.exports.create = $c039e458e897defe$var$create;

});
parcelRegister("gFuME", function(module, exports) {
"use strict";
var $c2285aa708b9af47$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c2285aa708b9af47$var$__assign = module.exports && module.exports.__assign || function() {
    $c2285aa708b9af47$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2285aa708b9af47$var$__assign.apply(this, arguments);
};
var $c2285aa708b9af47$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c2285aa708b9af47$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalContent = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");

var $8Vhio = parcelRequire("8Vhio");
var $c2285aa708b9af47$var$Action;
(function(Action) {
    Action["LOADING"] = "LOADING";
    Action["LOADED"] = "LOADED";
})($c2285aa708b9af47$var$Action = module.exports.Action || (module.exports.Action = {}));
/**
 * A set of Actions for updating the modal component
 * @public
 */ var $c2285aa708b9af47$var$ModalContent = /** @class */ function(_super) {
    $c2285aa708b9af47$var$__extends(ModalContent, _super);
    function ModalContent(app, options) {
        return _super.call(this, app, $f8QDr.Group.Modal, $f8QDr.Group.Modal, options ? options.id : undefined) || this;
    }
    ModalContent.prototype.loaded = function() {
        this.dispatch($c2285aa708b9af47$var$Action.LOADED);
    };
    ModalContent.prototype.loading = function() {
        this.dispatch($c2285aa708b9af47$var$Action.LOADING);
    };
    /**
     * @private
     */ ModalContent.prototype.dispatch = function(action) {
        switch(action){
            case $c2285aa708b9af47$var$Action.LOADED:
                this.dispatchModalAction($8Vhio.Action.UPDATE_CONTENT, {
                    loading: false
                });
                break;
            case $c2285aa708b9af47$var$Action.LOADING:
                this.dispatchModalAction($8Vhio.Action.UPDATE_CONTENT, {
                    loading: true
                });
                break;
        }
        return this;
    };
    /**
     * @internal
     */ ModalContent.prototype.dispatchModalAction = function(type, payload) {
        return $c2285aa708b9af47$var$__awaiter(this, void 0, void 0, function() {
            var updateAction;
            return $c2285aa708b9af47$var$__generator(this, function(_a) {
                updateAction = $ditiI.actionWrapper({
                    type: type,
                    group: $f8QDr.Group.Modal,
                    payload: $c2285aa708b9af47$var$__assign({}, payload)
                });
                this.app.dispatch(updateAction);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return ModalContent;
}($cfM0i.ActionSet);
module.exports.ModalContent = $c2285aa708b9af47$var$ModalContent;

});


parcelRegister("9fkeR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.replace = module.exports.push = module.exports.Action = module.exports.History = void 0;

var $iS7lb = parcelRequire("iS7lb");
Object.defineProperty(module.exports, "History", {
    enumerable: true,
    get: function() {
        return $iS7lb.History;
    }
});

var $iS7lb = parcelRequire("iS7lb");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $iS7lb.Action;
    }
});
Object.defineProperty(module.exports, "push", {
    enumerable: true,
    get: function() {
        return $iS7lb.push;
    }
});
Object.defineProperty(module.exports, "replace", {
    enumerable: true,
    get: function() {
        return $iS7lb.replace;
    }
});
function $6bb536c4ac20d212$var$create(app) {
    return new $iS7lb.History(app);
}
module.exports.create = $6bb536c4ac20d212$var$create;

});
parcelRegister("iS7lb", function(module, exports) {
"use strict";
var $dbd2f6dc5c2e1544$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dbd2f6dc5c2e1544$var$__assign = module.exports && module.exports.__assign || function() {
    $dbd2f6dc5c2e1544$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dbd2f6dc5c2e1544$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.History = module.exports.replace = module.exports.push = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $dbd2f6dc5c2e1544$var$Action;
(function(Action) {
    Action["PUSH"] = "APP::NAVIGATION::HISTORY::PUSH";
    Action["REPLACE"] = "APP::NAVIGATION::HISTORY::REPLACE";
})($dbd2f6dc5c2e1544$var$Action = module.exports.Action || (module.exports.Action = {}));
function $dbd2f6dc5c2e1544$var$push(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Navigation,
        type: $dbd2f6dc5c2e1544$var$Action.PUSH
    });
}
module.exports.push = $dbd2f6dc5c2e1544$var$push;
function $dbd2f6dc5c2e1544$var$replace(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Navigation,
        type: $dbd2f6dc5c2e1544$var$Action.REPLACE
    });
}
module.exports.replace = $dbd2f6dc5c2e1544$var$replace;
var $dbd2f6dc5c2e1544$var$History = /** @class */ function(_super) {
    $dbd2f6dc5c2e1544$var$__extends(History, _super);
    function History(app) {
        return _super.call(this, app, 'History', $f8QDr.Group.Navigation) || this;
    }
    Object.defineProperty(History.prototype, "payload", {
        get: function() {
            return {
                id: this.id
            };
        },
        enumerable: false,
        configurable: true
    });
    History.prototype.dispatch = function(type, path) {
        var payload = $dbd2f6dc5c2e1544$var$__assign($dbd2f6dc5c2e1544$var$__assign({}, this.payload), {
            path: path
        });
        switch(type){
            case $dbd2f6dc5c2e1544$var$Action.PUSH:
                this.app.dispatch($dbd2f6dc5c2e1544$var$push(payload));
                break;
            case $dbd2f6dc5c2e1544$var$Action.REPLACE:
                this.app.dispatch($dbd2f6dc5c2e1544$var$replace(payload));
                break;
        }
        return this;
    };
    return History;
}($cfM0i.ActionSet);
module.exports.History = $dbd2f6dc5c2e1544$var$History;

});


parcelRegister("cKecn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.isProductVariantCreateResourcePayload = module.exports.isProductVariantResourcePayload = module.exports.isCreateResourcePayload = module.exports.isAdminSection = module.exports.isRemotePayload = module.exports.isAdminSectionPayload = module.exports.isAdminPathPayload = module.exports.isAppPayload = module.exports.getRelativePath = module.exports.normalizeUrl = module.exports.getPathWithSearchAndHash = module.exports.toDestination = module.exports.toApp = module.exports.toRemote = module.exports.toAdminSection = module.exports.toAdminPath = module.exports.isResourcePayload = module.exports.ResourceType = module.exports.Action = module.exports.Redirect = void 0;

var $5f53Z = parcelRequire("5f53Z");
Object.defineProperty(module.exports, "Redirect", {
    enumerable: true,
    get: function() {
        return $5f53Z.Redirect;
    }
});
Object.defineProperty(module.exports, "isCreateResourcePayload", {
    enumerable: true,
    get: function() {
        return $5f53Z.isCreateResourcePayload;
    }
});
Object.defineProperty(module.exports, "isProductVariantResourcePayload", {
    enumerable: true,
    get: function() {
        return $5f53Z.isProductVariantResourcePayload;
    }
});

var $5f53Z = parcelRequire("5f53Z");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $5f53Z.Action;
    }
});
Object.defineProperty(module.exports, "ResourceType", {
    enumerable: true,
    get: function() {
        return $5f53Z.ResourceType;
    }
});
Object.defineProperty(module.exports, "isResourcePayload", {
    enumerable: true,
    get: function() {
        return $5f53Z.isResourcePayload;
    }
});
Object.defineProperty(module.exports, "toAdminPath", {
    enumerable: true,
    get: function() {
        return $5f53Z.toAdminPath;
    }
});
Object.defineProperty(module.exports, "toAdminSection", {
    enumerable: true,
    get: function() {
        return $5f53Z.toAdminSection;
    }
});
Object.defineProperty(module.exports, "toRemote", {
    enumerable: true,
    get: function() {
        return $5f53Z.toRemote;
    }
});
Object.defineProperty(module.exports, "toApp", {
    enumerable: true,
    get: function() {
        return $5f53Z.toApp;
    }
});
Object.defineProperty(module.exports, "toDestination", {
    enumerable: true,
    get: function() {
        return $5f53Z.toDestination;
    }
});
Object.defineProperty(module.exports, "getPathWithSearchAndHash", {
    enumerable: true,
    get: function() {
        return $5f53Z.getPathWithSearchAndHash;
    }
});
Object.defineProperty(module.exports, "normalizeUrl", {
    enumerable: true,
    get: function() {
        return $5f53Z.normalizeUrl;
    }
});
Object.defineProperty(module.exports, "getRelativePath", {
    enumerable: true,
    get: function() {
        return $5f53Z.getRelativePath;
    }
});
Object.defineProperty(module.exports, "isAppPayload", {
    enumerable: true,
    get: function() {
        return $5f53Z.isAppPayload;
    }
});
Object.defineProperty(module.exports, "isAdminPathPayload", {
    enumerable: true,
    get: function() {
        return $5f53Z.isAdminPathPayload;
    }
});
Object.defineProperty(module.exports, "isAdminSectionPayload", {
    enumerable: true,
    get: function() {
        return $5f53Z.isAdminSectionPayload;
    }
});
Object.defineProperty(module.exports, "isRemotePayload", {
    enumerable: true,
    get: function() {
        return $5f53Z.isRemotePayload;
    }
});
Object.defineProperty(module.exports, "isAdminSection", {
    enumerable: true,
    get: function() {
        return $5f53Z.isAdminSection;
    }
});
function $9474cb756439db6d$var$isProductVariantCreateResourcePayload(resource) {
    if (!$5f53Z.isProductVariantResourcePayload(resource)) return false;
    return $5f53Z.isCreateResourcePayload(resource.variant);
}
module.exports.isProductVariantCreateResourcePayload = $9474cb756439db6d$var$isProductVariantCreateResourcePayload;
function $9474cb756439db6d$var$create(app) {
    return new $5f53Z.Redirect(app);
}
module.exports.create = $9474cb756439db6d$var$create;

});
parcelRegister("5f53Z", function(module, exports) {
"use strict";
var $3d1247f01e4a51b6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3d1247f01e4a51b6$var$__assign = module.exports && module.exports.__assign || function() {
    $3d1247f01e4a51b6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3d1247f01e4a51b6$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Redirect = module.exports.isProductVariantResourcePayload = module.exports.isCreateResourcePayload = module.exports.isAdminSection = module.exports.isRemotePayload = module.exports.isAdminSectionPayload = module.exports.isAdminPathPayload = module.exports.isAppPayload = module.exports.getRelativePath = module.exports.normalizeUrl = module.exports.getPathWithSearchAndHash = module.exports.toDestination = module.exports.toApp = module.exports.toRemote = module.exports.toAdminSection = module.exports.toAdminPath = module.exports.isResourcePayload = module.exports.ResourceType = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $3d1247f01e4a51b6$var$Action;
(function(Action) {
    Action["ADMIN_SECTION"] = "APP::NAVIGATION::REDIRECT::ADMIN::SECTION";
    Action["ADMIN_PATH"] = "APP::NAVIGATION::REDIRECT::ADMIN::PATH";
    Action["REMOTE"] = "APP::NAVIGATION::REDIRECT::REMOTE";
    Action["APP"] = "APP::NAVIGATION::REDIRECT::APP";
})($3d1247f01e4a51b6$var$Action = module.exports.Action || (module.exports.Action = {}));
var $3d1247f01e4a51b6$var$ResourceType;
(function(ResourceType) {
    ResourceType["Product"] = "products";
    ResourceType["Collection"] = "collections";
    ResourceType["Order"] = "orders";
    ResourceType["Customer"] = "customers";
    ResourceType["Discount"] = "discounts";
})($3d1247f01e4a51b6$var$ResourceType = module.exports.ResourceType || (module.exports.ResourceType = {}));
function $3d1247f01e4a51b6$var$isResourcePayload(resource) {
    // tslint:disable-next-line:no-boolean-literal-compare
    return typeof resource.id === 'string';
}
module.exports.isResourcePayload = $3d1247f01e4a51b6$var$isResourcePayload;
function $3d1247f01e4a51b6$var$toAdminPath(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Navigation,
        type: $3d1247f01e4a51b6$var$Action.ADMIN_PATH
    });
}
module.exports.toAdminPath = $3d1247f01e4a51b6$var$toAdminPath;
function $3d1247f01e4a51b6$var$toAdminSection(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Navigation,
        type: $3d1247f01e4a51b6$var$Action.ADMIN_SECTION
    });
}
module.exports.toAdminSection = $3d1247f01e4a51b6$var$toAdminSection;
function $3d1247f01e4a51b6$var$toRemote(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Navigation,
        type: $3d1247f01e4a51b6$var$Action.REMOTE
    });
}
module.exports.toRemote = $3d1247f01e4a51b6$var$toRemote;
function $3d1247f01e4a51b6$var$toApp(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Navigation,
        type: $3d1247f01e4a51b6$var$Action.APP
    });
}
module.exports.toApp = $3d1247f01e4a51b6$var$toApp;
function $3d1247f01e4a51b6$var$toDestination(action, payload, id) {
    switch(action){
        case $3d1247f01e4a51b6$var$Action.APP:
            var appPayload = $3d1247f01e4a51b6$var$isAppPayload(payload) ? payload : {
                path: payload
            };
            return $3d1247f01e4a51b6$var$toApp($3d1247f01e4a51b6$var$__assign({
                id: id
            }, appPayload));
        case $3d1247f01e4a51b6$var$Action.ADMIN_PATH:
            var adminPathPayload = $3d1247f01e4a51b6$var$isAdminPathPayload(payload) ? payload : {
                path: payload
            };
            return $3d1247f01e4a51b6$var$toAdminPath($3d1247f01e4a51b6$var$__assign({
                id: id
            }, adminPathPayload));
        case $3d1247f01e4a51b6$var$Action.ADMIN_SECTION:
            var adminSectionPayload = $3d1247f01e4a51b6$var$isAdminSectionPayload(payload) ? payload : {
                section: payload
            };
            return $3d1247f01e4a51b6$var$toAdminSection($3d1247f01e4a51b6$var$__assign({
                id: id
            }, adminSectionPayload));
        case $3d1247f01e4a51b6$var$Action.REMOTE:
            var remotePayload = $3d1247f01e4a51b6$var$isRemotePayload(payload) ? payload : {
                url: payload
            };
            return $3d1247f01e4a51b6$var$toRemote($3d1247f01e4a51b6$var$__assign({
                id: id
            }, remotePayload));
    }
}
module.exports.toDestination = $3d1247f01e4a51b6$var$toDestination;
function $3d1247f01e4a51b6$var$getPathWithSearchAndHash(_a) {
    var pathname = _a.pathname, search = _a.search, hash = _a.hash;
    return "" + pathname + (search || '') + (hash || '');
}
module.exports.getPathWithSearchAndHash = $3d1247f01e4a51b6$var$getPathWithSearchAndHash;
function $3d1247f01e4a51b6$var$normalizeUrl(to) {
    if (to instanceof URL) return to.toString();
    if (typeof to === 'string') return to;
    return $3d1247f01e4a51b6$var$getRelativePath(to);
}
module.exports.normalizeUrl = $3d1247f01e4a51b6$var$normalizeUrl;
function $3d1247f01e4a51b6$var$getRelativePath(to) {
    if (typeof to === 'string') {
        if (to.startsWith('/')) return to;
        return $3d1247f01e4a51b6$var$getPathWithSearchAndHash(new URL(to));
    }
    var search = to.search instanceof URLSearchParams ? to.search.toString() : to.search;
    return $3d1247f01e4a51b6$var$getPathWithSearchAndHash($3d1247f01e4a51b6$var$__assign($3d1247f01e4a51b6$var$__assign({}, to), {
        search: search
    }));
}
module.exports.getRelativePath = $3d1247f01e4a51b6$var$getRelativePath;
function $3d1247f01e4a51b6$var$isAppPayload(payload) {
    return typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'path');
}
module.exports.isAppPayload = $3d1247f01e4a51b6$var$isAppPayload;
function $3d1247f01e4a51b6$var$isAdminPathPayload(payload) {
    return typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'path');
}
module.exports.isAdminPathPayload = $3d1247f01e4a51b6$var$isAdminPathPayload;
function $3d1247f01e4a51b6$var$isAdminSectionPayload(payload) {
    return typeof payload === 'object' && typeof payload.section === 'object' && Object.prototype.hasOwnProperty.call(payload.section, 'name');
}
module.exports.isAdminSectionPayload = $3d1247f01e4a51b6$var$isAdminSectionPayload;
function $3d1247f01e4a51b6$var$isRemotePayload(payload) {
    return typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'url');
}
module.exports.isRemotePayload = $3d1247f01e4a51b6$var$isRemotePayload;
function $3d1247f01e4a51b6$var$isAdminSection(to) {
    return typeof to === 'object' && typeof (to === null || to === void 0 ? void 0 : to.name) === 'string';
}
module.exports.isAdminSection = $3d1247f01e4a51b6$var$isAdminSection;
function $3d1247f01e4a51b6$var$isCreateResourcePayload(resource) {
    // tslint:disable-next-line:no-boolean-literal-compare
    return resource.create === true;
}
module.exports.isCreateResourcePayload = $3d1247f01e4a51b6$var$isCreateResourcePayload;
function $3d1247f01e4a51b6$var$isProductVariantResourcePayload(resource) {
    var castResource = resource;
    // tslint:disable-next-line:no-boolean-literal-compare
    return castResource.id !== undefined && castResource.variant !== undefined;
}
module.exports.isProductVariantResourcePayload = $3d1247f01e4a51b6$var$isProductVariantResourcePayload;
var $3d1247f01e4a51b6$var$Redirect = /** @class */ function(_super) {
    $3d1247f01e4a51b6$var$__extends(Redirect, _super);
    function Redirect(app) {
        return _super.call(this, app, 'Redirect', $f8QDr.Group.Navigation) || this;
    }
    Object.defineProperty(Redirect.prototype, "payload", {
        get: function() {
            return {
                id: this.id
            };
        },
        enumerable: false,
        configurable: true
    });
    Redirect.prototype.dispatch = function(action, payload) {
        var redirectAction = $3d1247f01e4a51b6$var$toDestination(action, payload, this.payload.id);
        this.app.dispatch(redirectAction);
        return this;
    };
    return Redirect;
}($cfM0i.ActionSet);
module.exports.Redirect = $3d1247f01e4a51b6$var$Redirect;

});


parcelRegister("63FoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.ResourcePicker = module.exports.WeightUnit = module.exports.update = module.exports.select = module.exports.ResourceType = module.exports.ProductVariantInventoryPolicy = module.exports.ProductVariantInventoryManagement = module.exports.ProductStatus = module.exports.open = module.exports.FulfillmentServiceType = module.exports.CollectionSortOrder = module.exports.close = module.exports.cancel = module.exports.ActionVerb = module.exports.Action = void 0;

var $lxLhN = parcelRequire("lxLhN");
Object.defineProperty(module.exports, "ResourcePicker", {
    enumerable: true,
    get: function() {
        return $lxLhN.ResourcePicker;
    }
});

var $lxLhN = parcelRequire("lxLhN");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $lxLhN.Action;
    }
});
Object.defineProperty(module.exports, "ActionVerb", {
    enumerable: true,
    get: function() {
        return $lxLhN.ActionVerb;
    }
});
Object.defineProperty(module.exports, "cancel", {
    enumerable: true,
    get: function() {
        return $lxLhN.cancel;
    }
});
Object.defineProperty(module.exports, "close", {
    enumerable: true,
    get: function() {
        return $lxLhN.close;
    }
});
Object.defineProperty(module.exports, "CollectionSortOrder", {
    enumerable: true,
    get: function() {
        return $lxLhN.CollectionSortOrder;
    }
});
Object.defineProperty(module.exports, "FulfillmentServiceType", {
    enumerable: true,
    get: function() {
        return $lxLhN.FulfillmentServiceType;
    }
});
Object.defineProperty(module.exports, "open", {
    enumerable: true,
    get: function() {
        return $lxLhN.open;
    }
});
Object.defineProperty(module.exports, "ProductStatus", {
    enumerable: true,
    get: function() {
        return $lxLhN.ProductStatus;
    }
});
Object.defineProperty(module.exports, "ProductVariantInventoryManagement", {
    enumerable: true,
    get: function() {
        return $lxLhN.ProductVariantInventoryManagement;
    }
});
Object.defineProperty(module.exports, "ProductVariantInventoryPolicy", {
    enumerable: true,
    get: function() {
        return $lxLhN.ProductVariantInventoryPolicy;
    }
});
Object.defineProperty(module.exports, "ResourceType", {
    enumerable: true,
    get: function() {
        return $lxLhN.ResourceType;
    }
});
Object.defineProperty(module.exports, "select", {
    enumerable: true,
    get: function() {
        return $lxLhN.select;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $lxLhN.update;
    }
});
Object.defineProperty(module.exports, "WeightUnit", {
    enumerable: true,
    get: function() {
        return $lxLhN.WeightUnit;
    }
});
var $4693224586c8a3cf$var$create = function(app, baseOptions) {
    var resourceType = baseOptions.resourceType, _a = baseOptions.options, options = _a === void 0 ? {} : _a;
    return new $lxLhN.ResourcePicker(app, options, resourceType);
};
module.exports.create = $4693224586c8a3cf$var$create;

});
parcelRegister("lxLhN", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResourcePicker = exports.update = exports.close = exports.cancel = exports.open = exports.select = exports.ActionVerb = exports.ResourceType = exports.ProductStatus = exports.ProductVariantInventoryManagement = exports.ProductVariantInventoryPolicy = exports.WeightUnit = exports.FulfillmentServiceType = exports.CollectionSortOrder = exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var Action;
(function(Action) {
    Action["OPEN"] = "APP::RESOURCE_PICKER::OPEN";
    Action["SELECT"] = "APP::RESOURCE_PICKER::SELECT";
    // Deprecated in 0.5.0 use 'APP::RESOURCE_PICKER::CANCEL' instead
    Action["CLOSE"] = "APP::RESOURCE_PICKER::CLOSE";
    Action["UPDATE"] = "APP::RESOURCE_PICKER::UPDATE";
    Action["CANCEL"] = "APP::RESOURCE_PICKER::CANCEL";
})(Action = exports.Action || (exports.Action = {}));
var CollectionSortOrder;
(function(CollectionSortOrder) {
    CollectionSortOrder["Manual"] = "MANUAL";
    CollectionSortOrder["BestSelling"] = "BEST_SELLING";
    CollectionSortOrder["AlphaAsc"] = "ALPHA_ASC";
    CollectionSortOrder["AlphaDesc"] = "ALPHA_DESC";
    CollectionSortOrder["PriceDesc"] = "PRICE_DESC";
    CollectionSortOrder["PriceAsc"] = "PRICE_ASC";
    CollectionSortOrder["CreatedDesc"] = "CREATED_DESC";
    CollectionSortOrder["Created"] = "CREATED";
    CollectionSortOrder["MostRelevant"] = "MOST_RELEVANT";
})(CollectionSortOrder = exports.CollectionSortOrder || (exports.CollectionSortOrder = {}));
var FulfillmentServiceType;
(function(FulfillmentServiceType) {
    FulfillmentServiceType["GiftCard"] = "GIFT_CARD";
    FulfillmentServiceType["Manual"] = "MANUAL";
    FulfillmentServiceType["ThirdParty"] = "THIRD_PARTY";
})(FulfillmentServiceType = exports.FulfillmentServiceType || (exports.FulfillmentServiceType = {}));
var WeightUnit;
(function(WeightUnit) {
    WeightUnit["Kilograms"] = "KILOGRAMS";
    WeightUnit["Grams"] = "GRAMS";
    WeightUnit["Pounds"] = "POUNDS";
    WeightUnit["Ounces"] = "OUNCES";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
var ProductVariantInventoryPolicy;
(function(ProductVariantInventoryPolicy) {
    ProductVariantInventoryPolicy["Deny"] = "DENY";
    ProductVariantInventoryPolicy["Continue"] = "CONTINUE";
})(ProductVariantInventoryPolicy = exports.ProductVariantInventoryPolicy || (exports.ProductVariantInventoryPolicy = {}));
var ProductVariantInventoryManagement;
(function(ProductVariantInventoryManagement) {
    ProductVariantInventoryManagement["Shopify"] = "SHOPIFY";
    ProductVariantInventoryManagement["NotManaged"] = "NOT_MANAGED";
    ProductVariantInventoryManagement["FulfillmentService"] = "FULFILLMENT_SERVICE";
})(ProductVariantInventoryManagement = exports.ProductVariantInventoryManagement || (exports.ProductVariantInventoryManagement = {}));
var ProductStatus;
(function(ProductStatus) {
    ProductStatus["Active"] = "ACTIVE";
    ProductStatus["Archived"] = "ARCHIVED";
    ProductStatus["Draft"] = "DRAFT";
})(ProductStatus = exports.ProductStatus || (exports.ProductStatus = {}));
var ResourceType;
(function(ResourceType) {
    ResourceType["Product"] = "product";
    ResourceType["ProductVariant"] = "variant";
    ResourceType["Collection"] = "collection";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
var ActionVerb;
(function(ActionVerb) {
    ActionVerb["Add"] = "add";
    ActionVerb["Select"] = "select";
})(ActionVerb = exports.ActionVerb || (exports.ActionVerb = {}));
function select(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.ResourcePicker,
        type: Action.SELECT
    });
}
exports.select = select;
function open(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.ResourcePicker,
        type: Action.OPEN
    });
}
exports.open = open;
function cancel(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.ResourcePicker,
        type: Action.CANCEL
    });
}
exports.cancel = cancel;
function close(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.ResourcePicker,
        type: Action.CANCEL
    });
}
exports.close = close;
function update(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.ResourcePicker,
        type: Action.UPDATE
    });
}
exports.update = update;
var ResourcePicker = /** @class */ function(_super) {
    __extends(ResourcePicker, _super);
    function ResourcePicker(app, options, resourceType) {
        var _this = _super.call(this, app, $f8QDr.Group.ResourcePicker, $f8QDr.Group.ResourcePicker) || this;
        _this.initialSelectionIds = [];
        _this.selection = [];
        _this.resourceType = resourceType;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ResourcePicker.prototype, "payload", {
        get: function() {
            return __assign(__assign({}, this.options), {
                id: this.id,
                resourceType: this.resourceType
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourcePicker.prototype, "options", {
        get: function() {
            var options = {
                initialQuery: this.initialQuery,
                filterQuery: this.filterQuery,
                selectMultiple: this.selectMultiple,
                initialSelectionIds: this.initialSelectionIds,
                showHidden: this.showHidden,
                actionVerb: this.actionVerb
            };
            if (this.resourceType === ResourceType.Product) {
                var productOptions = __assign(__assign({}, options), {
                    showVariants: this.showVariants,
                    showDraft: this.showDraft,
                    showArchived: this.showArchived,
                    showDraftBadge: this.showDraftBadge,
                    showArchivedBadge: this.showArchivedBadge
                });
                return productOptions;
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    ResourcePicker.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var initialQuery = mergedOptions.initialQuery, filterQuery = mergedOptions.filterQuery, _a = mergedOptions.initialSelectionIds, initialSelectionIds = _a === void 0 ? [] : _a, _b = mergedOptions.showHidden, showHidden = _b === void 0 ? true : _b, _c = mergedOptions.showVariants, showVariants = _c === void 0 ? true : _c, _d = mergedOptions.showDraft, showDraft = _d === void 0 ? true : _d, _e = mergedOptions.showArchived, showArchived = _e === void 0 ? true : _e, _f = mergedOptions.showDraftBadge, showDraftBadge = _f === void 0 ? false : _f, _g = mergedOptions.showArchivedBadge, showArchivedBadge = _g === void 0 ? false : _g, _h = mergedOptions.selectMultiple, selectMultiple = _h === void 0 ? true : _h, _j = mergedOptions.actionVerb, actionVerb = _j === void 0 ? ActionVerb.Add : _j;
        this.initialQuery = initialQuery;
        this.filterQuery = filterQuery;
        this.initialSelectionIds = initialSelectionIds;
        this.showHidden = showHidden;
        this.showVariants = showVariants;
        this.showDraft = showDraft;
        this.showArchived = showArchived;
        this.showDraftBadge = showDraftBadge;
        this.showArchivedBadge = showArchivedBadge;
        this.selectMultiple = selectMultiple;
        this.actionVerb = actionVerb;
        if (shouldUpdate) this.update();
        return this;
    };
    ResourcePicker.prototype.dispatch = function(action, selection) {
        if (action === Action.OPEN) this.open();
        else if (action === Action.UPDATE) this.update();
        else if (action === Action.CLOSE || action === Action.CANCEL) this.cancel();
        else if (action === Action.SELECT) {
            this.selection = selection;
            this.app.dispatch(select({
                id: this.id,
                selection: this.selection
            }));
        }
        return this;
    };
    ResourcePicker.prototype.update = function() {
        this.app.dispatch(update(this.payload));
    };
    ResourcePicker.prototype.open = function() {
        this.app.dispatch(open(this.payload));
    };
    ResourcePicker.prototype.cancel = function() {
        this.app.dispatch(cancel({
            id: this.id
        }));
    };
    ResourcePicker.prototype.close = function() {
        this.cancel();
    };
    return ResourcePicker;
}($cfM0i.ActionSet);
exports.ResourcePicker = ResourcePicker;

});


parcelRegister("iHUBk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.capture = module.exports.openCamera = module.exports.Scanner = module.exports.Action = void 0;

var $fwNL1 = parcelRequire("fwNL1");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $fwNL1.Action;
    }
});
Object.defineProperty(module.exports, "Scanner", {
    enumerable: true,
    get: function() {
        return $fwNL1.Scanner;
    }
});
Object.defineProperty(module.exports, "openCamera", {
    enumerable: true,
    get: function() {
        return $fwNL1.openCamera;
    }
});
Object.defineProperty(module.exports, "capture", {
    enumerable: true,
    get: function() {
        return $fwNL1.capture;
    }
});
/**
 * @public
 */ function $d9e825f50d0f14b8$var$create(app, options) {
    return new $fwNL1.Scanner(app, options);
}
module.exports.create = $d9e825f50d0f14b8$var$create;

});
parcelRegister("fwNL1", function(module, exports) {
"use strict";
var $b4e070f51ac825a1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.capture = module.exports.openCamera = module.exports.Scanner = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
/**
 * Action Types for the Features group
 * @public
 */ var $b4e070f51ac825a1$var$Action;
(function(Action) {
    Action["OPEN_CAMERA"] = "APP::SCANNER::OPEN::CAMERA";
    Action["CAPTURE"] = "APP::SCANNER::CAPTURE";
})($b4e070f51ac825a1$var$Action = module.exports.Action || (module.exports.Action = {}));
/**
 * A set of Actions for displaying a Camera Scanner component
 * @public
 */ var $b4e070f51ac825a1$var$Scanner = /** @class */ function(_super) {
    $b4e070f51ac825a1$var$__extends(Scanner, _super);
    function Scanner(app, options) {
        return _super.call(this, app, $f8QDr.Group.Scanner, $f8QDr.Group.Scanner, options ? options.id : undefined) || this;
    }
    /**
     * @public
     */ Scanner.prototype.dispatch = function(action) {
        switch(action){
            case $b4e070f51ac825a1$var$Action.OPEN_CAMERA:
                this.dispatchScannerAction($b4e070f51ac825a1$var$Action.OPEN_CAMERA);
                break;
        }
        return this;
    };
    /**
     * @internal
     */ Scanner.prototype.dispatchScannerAction = function(type) {
        this.app.dispatch($ditiI.actionWrapper({
            type: type,
            group: $f8QDr.Group.Scanner,
            payload: {
                id: this.id
            }
        }));
    };
    return Scanner;
}($cfM0i.ActionSet);
module.exports.Scanner = $b4e070f51ac825a1$var$Scanner;
function $b4e070f51ac825a1$var$openCamera() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Scanner,
        type: $b4e070f51ac825a1$var$Action.OPEN_CAMERA
    });
}
module.exports.openCamera = $b4e070f51ac825a1$var$openCamera;
function $b4e070f51ac825a1$var$capture(payload) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Scanner,
        type: $b4e070f51ac825a1$var$Action.CAPTURE,
        payload: payload
    });
}
module.exports.capture = $b4e070f51ac825a1$var$capture;

});


parcelRegister("6ZuZX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.respond = module.exports.request = module.exports.Action = void 0;

var $2t21q = parcelRequire("2t21q");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $2t21q.Action;
    }
});
Object.defineProperty(module.exports, "request", {
    enumerable: true,
    get: function() {
        return $2t21q.request;
    }
});
Object.defineProperty(module.exports, "respond", {
    enumerable: true,
    get: function() {
        return $2t21q.respond;
    }
});

});

parcelRegister("75nq8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.TitleBar = module.exports.update = module.exports.clickBreadcrumb = module.exports.clickActionButton = module.exports.Action = void 0;

var $f37m7 = parcelRequire("f37m7");
Object.defineProperty(module.exports, "TitleBar", {
    enumerable: true,
    get: function() {
        return $f37m7.TitleBar;
    }
});

var $f37m7 = parcelRequire("f37m7");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $f37m7.Action;
    }
});
Object.defineProperty(module.exports, "clickActionButton", {
    enumerable: true,
    get: function() {
        return $f37m7.clickActionButton;
    }
});
Object.defineProperty(module.exports, "clickBreadcrumb", {
    enumerable: true,
    get: function() {
        return $f37m7.clickBreadcrumb;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $f37m7.update;
    }
});
function $528b2adeebf6bb15$var$create(app, options) {
    return new $f37m7.TitleBar(app, options);
}
module.exports.create = $528b2adeebf6bb15$var$create;

});
parcelRegister("f37m7", function(module, exports) {
"use strict";
var $af4cd788ac9e8870$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $af4cd788ac9e8870$var$__assign = module.exports && module.exports.__assign || function() {
    $af4cd788ac9e8870$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af4cd788ac9e8870$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TitleBar = module.exports.update = module.exports.clickBreadcrumb = module.exports.clickActionButton = module.exports.Action = void 0;

var $cfM0i = parcelRequire("cfM0i");

var $8cXda = parcelRequire("8cXda");

var $6O9od = parcelRequire("6O9od");

var $fL92L = parcelRequire("fL92L");

var $2cTI8 = parcelRequire("2cTI8");

var $ditiI = parcelRequire("ditiI");

var $f8QDr = parcelRequire("f8QDr");
var $af4cd788ac9e8870$var$Action;
(function(Action) {
    Action["UPDATE"] = "APP::TITLEBAR::UPDATE";
    Action["BUTTON_CLICK"] = "APP::TITLEBAR::BUTTONS::BUTTON::CLICK";
    Action["BUTTON_UPDATE"] = "APP::TITLEBAR::BUTTONS::BUTTON::UPDATE";
    Action["BUTTON_GROUP_UPDATE"] = "APP::TITLEBAR::BUTTONS::BUTTONGROUP::UPDATE";
    Action["BREADCRUMBS_CLICK"] = "APP::TITLEBAR::BREADCRUMBS::BUTTON::CLICK";
    Action["BREADCRUMBS_UPDATE"] = "APP::TITLEBAR::BREADCRUMBS::BUTTON::UPDATE";
})($af4cd788ac9e8870$var$Action = module.exports.Action || (module.exports.Action = {}));
var $af4cd788ac9e8870$var$TITLEBAR_BUTTON_PROPS = {
    group: $f8QDr.Group.TitleBar,
    subgroups: [
        'Buttons'
    ]
};
var $af4cd788ac9e8870$var$BREADCRUMB_BUTTON_PROPS = {
    group: $f8QDr.Group.TitleBar,
    subgroups: [
        'Breadcrumbs'
    ],
    type: $f8QDr.ComponentType.Button
};
function $af4cd788ac9e8870$var$clickActionButton(id, payload) {
    var type = $f8QDr.ComponentType.Button;
    var component = $af4cd788ac9e8870$var$__assign({
        id: id,
        type: type
    }, $af4cd788ac9e8870$var$TITLEBAR_BUTTON_PROPS);
    return $8cXda.clickButton($f8QDr.Group.TitleBar, component, payload);
}
module.exports.clickActionButton = $af4cd788ac9e8870$var$clickActionButton;
function $af4cd788ac9e8870$var$clickBreadcrumb(id, payload) {
    var component = $af4cd788ac9e8870$var$__assign({
        id: id
    }, $af4cd788ac9e8870$var$BREADCRUMB_BUTTON_PROPS);
    return $8cXda.clickButton($f8QDr.Group.TitleBar, component, payload);
}
module.exports.clickBreadcrumb = $af4cd788ac9e8870$var$clickBreadcrumb;
function $af4cd788ac9e8870$var$update(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.TitleBar,
        type: $af4cd788ac9e8870$var$Action.UPDATE
    });
}
module.exports.update = $af4cd788ac9e8870$var$update;
var $af4cd788ac9e8870$var$TitleBar = /** @class */ function(_super) {
    $af4cd788ac9e8870$var$__extends(TitleBar, _super);
    function TitleBar(app, options) {
        var _this = _super.call(this, app, $f8QDr.Group.TitleBar, $f8QDr.Group.TitleBar) || this;
        if (!options.title && !options.breadcrumbs && !options.buttons) return _this;
        // Trigger 'update' on creation
        _this.set(options);
        return _this;
    }
    Object.defineProperty(TitleBar.prototype, "buttons", {
        get: function() {
            if (!this.primary && !this.secondary) return undefined;
            return {
                primary: this.primary,
                secondary: this.secondary
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TitleBar.prototype, "buttonsOptions", {
        get: function() {
            if (!this.primaryOptions && !this.secondaryOptions) return undefined;
            return {
                primary: this.primaryOptions,
                secondary: this.secondaryOptions
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TitleBar.prototype, "options", {
        get: function() {
            return {
                breadcrumbs: this.breadcrumbsOption,
                buttons: this.buttonsOptions,
                title: this.title
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TitleBar.prototype, "payload", {
        get: function() {
            return $af4cd788ac9e8870$var$__assign($af4cd788ac9e8870$var$__assign({}, this.options), {
                breadcrumbs: this.breadcrumb,
                buttons: this.buttons,
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    TitleBar.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var title = mergedOptions.title, buttons = mergedOptions.buttons, breadcrumbs = mergedOptions.breadcrumbs;
        this.title = title;
        this.setBreadcrumbs(breadcrumbs);
        this.setPrimaryButton(buttons ? buttons.primary : undefined);
        this.setSecondaryButton(buttons ? buttons.secondary : undefined);
        if (shouldUpdate) this.dispatch($af4cd788ac9e8870$var$Action.UPDATE);
        return this;
    };
    TitleBar.prototype.dispatch = function(action) {
        switch(action){
            case $af4cd788ac9e8870$var$Action.UPDATE:
                this.app.dispatch($af4cd788ac9e8870$var$update(this.payload));
                break;
        }
        return this;
    };
    TitleBar.prototype.getButton = function(button, subgroups, updateCb) {
        if (button instanceof $6O9od.ButtonGroup) return $fL92L.getGroupedButton(this, button, subgroups, updateCb);
        return $2cTI8.getSingleButton(this, button, subgroups, updateCb);
    };
    TitleBar.prototype.updatePrimaryButton = function(newPayload) {
        if (!this.primary) return;
        if ($ditiI.updateActionFromPayload(this.primary, newPayload)) this.dispatch($af4cd788ac9e8870$var$Action.UPDATE);
    };
    TitleBar.prototype.updateSecondaryButtons = function(newPayload) {
        if (!this.secondary) return;
        var buttonToUpdate = this.secondary.find(function(action) {
            return action.id === newPayload.id;
        });
        if (!buttonToUpdate) return;
        var updated = false;
        if ($6O9od.isGroupedButtonPayload(newPayload)) updated = $ditiI.updateActionFromPayload(buttonToUpdate, newPayload);
        else updated = $ditiI.updateActionFromPayload(buttonToUpdate, newPayload);
        if (updated) this.dispatch($af4cd788ac9e8870$var$Action.UPDATE);
    };
    TitleBar.prototype.updateBreadcrumbButton = function(newPayload) {
        if (!this.breadcrumb) return;
        if ($ditiI.updateActionFromPayload(this.breadcrumb, newPayload)) this.dispatch($af4cd788ac9e8870$var$Action.UPDATE);
    };
    TitleBar.prototype.setPrimaryButton = function(newOptions) {
        this.primaryOptions = this.getChildButton(newOptions, this.primaryOptions);
        this.primary = this.primaryOptions ? this.getButton(this.primaryOptions, $af4cd788ac9e8870$var$TITLEBAR_BUTTON_PROPS.subgroups, this.updatePrimaryButton) : undefined;
    };
    TitleBar.prototype.setSecondaryButton = function(newOptions) {
        var _this = this;
        var newButtons = newOptions || [];
        var currentButtons = this.secondaryOptions || [];
        this.secondaryOptions = this.getUpdatedChildActions(newButtons, currentButtons);
        this.secondary = this.secondaryOptions ? this.secondaryOptions.map(function(action) {
            return _this.getButton(action, $af4cd788ac9e8870$var$TITLEBAR_BUTTON_PROPS.subgroups, _this.updateSecondaryButtons);
        }) : undefined;
    };
    TitleBar.prototype.setBreadcrumbs = function(breadcrumb) {
        this.breadcrumbsOption = this.getChildButton(breadcrumb, this.breadcrumbsOption);
        this.breadcrumb = this.breadcrumbsOption ? this.getButton(this.breadcrumbsOption, $af4cd788ac9e8870$var$BREADCRUMB_BUTTON_PROPS.subgroups, this.updateBreadcrumbButton) : undefined;
    };
    TitleBar.prototype.getChildButton = function(newAction, currentAction) {
        var newButtons = newAction ? [
            newAction
        ] : [];
        var currentButtons = currentAction ? [
            currentAction
        ] : [];
        var updatedButton = this.getUpdatedChildActions(newButtons, currentButtons);
        return updatedButton ? updatedButton[0] : undefined;
    };
    return TitleBar;
}($cfM0i.ActionSetWithChildren);
module.exports.TitleBar = $af4cd788ac9e8870$var$TitleBar;

});
parcelRegister("fL92L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGroupedButton = void 0;

var $6O9od = parcelRequire("6O9od");
function $b79242b0d2f1b216$var$getGroupedButton(action, button, subgroups, updateCb) {
    action.addChild(button, action.group, subgroups);
    var id = button.id, label = button.label, disabled = button.disabled, buttons = button.buttons, plain = button.plain;
    action.subscribeToChild(button, $6O9od.Action.UPDATE, updateCb);
    return {
        id: id,
        label: label,
        buttons: buttons,
        disabled: disabled,
        plain: plain
    };
}
module.exports.getGroupedButton = $b79242b0d2f1b216$var$getGroupedButton;

});



parcelRegister("hKtt3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.Toast = module.exports.primaryAction = module.exports.clear = module.exports.show = module.exports.Action = void 0;

var $dGEy9 = parcelRequire("dGEy9");
Object.defineProperty(module.exports, "Toast", {
    enumerable: true,
    get: function() {
        return $dGEy9.Toast;
    }
});

var $dGEy9 = parcelRequire("dGEy9");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $dGEy9.Action;
    }
});
Object.defineProperty(module.exports, "show", {
    enumerable: true,
    get: function() {
        return $dGEy9.show;
    }
});
Object.defineProperty(module.exports, "clear", {
    enumerable: true,
    get: function() {
        return $dGEy9.clear;
    }
});
Object.defineProperty(module.exports, "primaryAction", {
    enumerable: true,
    get: function() {
        return $dGEy9.primaryAction;
    }
});
function $cebd97367f057fa8$var$create(app, options) {
    return new $dGEy9.Toast(app, options);
}
module.exports.create = $cebd97367f057fa8$var$create;

});

parcelRegister("57uPI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.ContextualSaveBar = module.exports.update = module.exports.discard = module.exports.save = module.exports.hide = module.exports.show = module.exports.Action = void 0;

var $hQsYN = parcelRequire("hQsYN");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $hQsYN.Action;
    }
});
Object.defineProperty(module.exports, "show", {
    enumerable: true,
    get: function() {
        return $hQsYN.show;
    }
});
Object.defineProperty(module.exports, "hide", {
    enumerable: true,
    get: function() {
        return $hQsYN.hide;
    }
});
Object.defineProperty(module.exports, "save", {
    enumerable: true,
    get: function() {
        return $hQsYN.save;
    }
});
Object.defineProperty(module.exports, "discard", {
    enumerable: true,
    get: function() {
        return $hQsYN.discard;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $hQsYN.update;
    }
});
Object.defineProperty(module.exports, "ContextualSaveBar", {
    enumerable: true,
    get: function() {
        return $hQsYN.ContextualSaveBar;
    }
});
/**
 * Returns a new instance of a ContextualSaveBar action set
 * @param app the client application
 *
 */ function $3ba58605a216d037$var$create(app, options) {
    return new $hQsYN.ContextualSaveBar(app, options);
}
module.exports.create = $3ba58605a216d037$var$create;

});
parcelRegister("hQsYN", function(module, exports) {
"use strict";
var $cfddc5c12324eb7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cfddc5c12324eb7d$var$__assign = module.exports && module.exports.__assign || function() {
    $cfddc5c12324eb7d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cfddc5c12324eb7d$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextualSaveBar = module.exports.update = module.exports.discard = module.exports.save = module.exports.hide = module.exports.show = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
/**
 * ContextualSaveBar action enum
 */ var $cfddc5c12324eb7d$var$Action;
(function(Action) {
    Action["DISCARD"] = "APP::CONTEXTUAL_SAVE_BAR::DISCARD";
    Action["SAVE"] = "APP::CONTEXTUAL_SAVE_BAR::SAVE";
    Action["SHOW"] = "APP::CONTEXTUAL_SAVE_BAR::SHOW";
    Action["HIDE"] = "APP::CONTEXTUAL_SAVE_BAR::HIDE";
    Action["UPDATE"] = "APP::CONTEXTUAL_SAVE_BAR::UPDATE";
})($cfddc5c12324eb7d$var$Action = module.exports.Action || (module.exports.Action = {}));
function $cfddc5c12324eb7d$var$createContextBarAction(action, payload) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.ContextualSaveBar,
        type: action,
        payload: payload
    });
}
function $cfddc5c12324eb7d$var$show(payload) {
    return $cfddc5c12324eb7d$var$createContextBarAction($cfddc5c12324eb7d$var$Action.SHOW, payload);
}
module.exports.show = $cfddc5c12324eb7d$var$show;
function $cfddc5c12324eb7d$var$hide(payload) {
    return $cfddc5c12324eb7d$var$createContextBarAction($cfddc5c12324eb7d$var$Action.HIDE, payload);
}
module.exports.hide = $cfddc5c12324eb7d$var$hide;
function $cfddc5c12324eb7d$var$save(payload) {
    return $cfddc5c12324eb7d$var$createContextBarAction($cfddc5c12324eb7d$var$Action.SAVE, payload);
}
module.exports.save = $cfddc5c12324eb7d$var$save;
function $cfddc5c12324eb7d$var$discard(payload) {
    return $cfddc5c12324eb7d$var$createContextBarAction($cfddc5c12324eb7d$var$Action.DISCARD, payload);
}
module.exports.discard = $cfddc5c12324eb7d$var$discard;
function $cfddc5c12324eb7d$var$update(payload) {
    return $cfddc5c12324eb7d$var$createContextBarAction($cfddc5c12324eb7d$var$Action.UPDATE, payload);
}
module.exports.update = $cfddc5c12324eb7d$var$update;
/**
 * ContextualSaveBar action set
 */ var $cfddc5c12324eb7d$var$ContextualSaveBar = /** @class */ function(_super) {
    $cfddc5c12324eb7d$var$__extends(ContextualSaveBar, _super);
    /**
     * Returns a new instance of a ContextualSaveBar action set
     * @param app the client application
     */ function ContextualSaveBar(app, options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, app, $f8QDr.Group.ContextualSaveBar, $f8QDr.Group.ContextualSaveBar) || this;
        _this.options = options;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ContextualSaveBar.prototype, "payload", {
        /**
         * Returns the action set payload
         */ get: function() {
            return $cfddc5c12324eb7d$var$__assign({
                id: this.id
            }, this.options);
        },
        enumerable: false,
        configurable: true
    });
    ContextualSaveBar.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        this.options = mergedOptions;
        if (shouldUpdate) this.dispatch($cfddc5c12324eb7d$var$Action.UPDATE);
        return this;
    };
    /**
     * Dispatches a given action with the action set payload
     * @param action the action enum
     * @returns the action set instance
     */ ContextualSaveBar.prototype.dispatch = function(action) {
        this.app.dispatch($cfddc5c12324eb7d$var$createContextBarAction(action, this.payload));
        return this;
    };
    return ContextualSaveBar;
}($cfM0i.ActionSet);
module.exports.ContextualSaveBar = $cfddc5c12324eb7d$var$ContextualSaveBar;

});


parcelRegister("4d8dB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.Share = module.exports.close = module.exports.show = module.exports.Action = void 0;

var $6o3MF = parcelRequire("6o3MF");
Object.defineProperty(module.exports, "Share", {
    enumerable: true,
    get: function() {
        return $6o3MF.Share;
    }
});

var $6o3MF = parcelRequire("6o3MF");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $6o3MF.Action;
    }
});
Object.defineProperty(module.exports, "show", {
    enumerable: true,
    get: function() {
        return $6o3MF.show;
    }
});
Object.defineProperty(module.exports, "close", {
    enumerable: true,
    get: function() {
        return $6o3MF.close;
    }
});
/**
 * @public
 */ function $310ec0553a1a479c$var$create(app) {
    return new $6o3MF.Share(app);
}
module.exports.create = $310ec0553a1a479c$var$create;

});
parcelRegister("6o3MF", function(module, exports) {
"use strict";
var $4a67eb632b42dd98$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4a67eb632b42dd98$var$__assign = module.exports && module.exports.__assign || function() {
    $4a67eb632b42dd98$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4a67eb632b42dd98$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.close = module.exports.show = module.exports.Share = module.exports.Action = void 0;

var $f8QDr = parcelRequire("f8QDr");

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");
/**
 * Types
 */ /**
 * @public
 */ var $4a67eb632b42dd98$var$Action;
(function(Action) {
    Action["SHOW"] = "APP::SHARE::SHOW";
    Action["CLOSE"] = "APP::SHARE::CLOSE";
})($4a67eb632b42dd98$var$Action = module.exports.Action || (module.exports.Action = {}));
/**
 * Action
 */ /**
 * A set of actions for displaying a Share Sheet component
 * @public
 */ var $4a67eb632b42dd98$var$Share = /** @class */ function(_super) {
    $4a67eb632b42dd98$var$__extends(Share, _super);
    function Share(app) {
        return _super.call(this, app, $f8QDr.Group.Share, $f8QDr.Group.Share) || this;
    }
    Share.prototype.dispatch = function(action, payload) {
        switch(action){
            case $4a67eb632b42dd98$var$Action.SHOW:
                this.dispatchShareAction($4a67eb632b42dd98$var$Action.SHOW, payload);
                break;
            case $4a67eb632b42dd98$var$Action.CLOSE:
                this.dispatchShareAction($4a67eb632b42dd98$var$Action.CLOSE, payload);
                break;
            default:
                throw new Error("Action: " + action + " not supported");
        }
        return this;
    };
    /**
     * @internal
     */ Share.prototype.dispatchShareAction = function(actionType, payload) {
        this.app.dispatch($ditiI.actionWrapper({
            type: actionType,
            group: $f8QDr.Group.Share,
            payload: $4a67eb632b42dd98$var$__assign({
                id: this.id
            }, payload)
        }));
    };
    return Share;
}($cfM0i.ActionSet);
module.exports.Share = $4a67eb632b42dd98$var$Share;
function $4a67eb632b42dd98$var$show() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Share,
        type: $4a67eb632b42dd98$var$Action.SHOW
    });
}
module.exports.show = $4a67eb632b42dd98$var$show;
function $4a67eb632b42dd98$var$close(payload) {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Share,
        type: $4a67eb632b42dd98$var$Action.CLOSE,
        payload: payload
    });
}
module.exports.close = $4a67eb632b42dd98$var$close;

});


parcelRegister("26UOk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.NavigationMenu = module.exports.update = module.exports.Action = void 0;

var $aexzd = parcelRequire("aexzd");
Object.defineProperty(module.exports, "NavigationMenu", {
    enumerable: true,
    get: function() {
        return $aexzd.NavigationMenu;
    }
});

var $aexzd = parcelRequire("aexzd");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $aexzd.Action;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $aexzd.update;
    }
});
function $189835c3e41ee758$var$create(app, options) {
    return new $aexzd.NavigationMenu(app, options);
}
module.exports.create = $189835c3e41ee758$var$create;

});
parcelRegister("aexzd", function(module, exports) {
"use strict";
var $77353fe0629f741a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $77353fe0629f741a$var$__assign = module.exports && module.exports.__assign || function() {
    $77353fe0629f741a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $77353fe0629f741a$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NavigationMenu = module.exports.update = module.exports.Action = void 0;

var $iPOLj = parcelRequire("iPOLj");

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $77353fe0629f741a$var$SUBGROUPS = [
    'Navigation_Menu'
];
var $77353fe0629f741a$var$Action;
(function(Action) {
    Action["UPDATE"] = "APP::MENU::NAVIGATION_MENU::UPDATE";
    Action["LINK_UPDATE"] = "APP::MENU::NAVIGATION_MENU::LINK::UPDATE";
})($77353fe0629f741a$var$Action = module.exports.Action || (module.exports.Action = {}));
function $77353fe0629f741a$var$update(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Menu,
        type: $77353fe0629f741a$var$Action.UPDATE
    });
}
module.exports.update = $77353fe0629f741a$var$update;
var $77353fe0629f741a$var$NavigationMenu = /** @class */ function(_super) {
    $77353fe0629f741a$var$__extends(NavigationMenu, _super);
    function NavigationMenu(app, options) {
        var _this = _super.call(this, app, 'Navigation_Menu', $f8QDr.Group.Menu) || this;
        _this.items = [];
        // Trigger 'update' on creation
        _this.set(options);
        return _this;
    }
    Object.defineProperty(NavigationMenu.prototype, "options", {
        get: function() {
            return {
                items: this.itemsOptions,
                active: this.activeOptions
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationMenu.prototype, "payload", {
        get: function() {
            return $77353fe0629f741a$var$__assign($77353fe0629f741a$var$__assign({}, this.options), {
                active: this.active,
                items: this.items,
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    NavigationMenu.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var items = mergedOptions.items, active = mergedOptions.active;
        this.setItems(items);
        this.activeOptions = active;
        this.active = active && active.id;
        if (shouldUpdate) this.dispatch($77353fe0629f741a$var$Action.UPDATE);
        return this;
    };
    NavigationMenu.prototype.dispatch = function(action) {
        switch(action){
            case $77353fe0629f741a$var$Action.UPDATE:
                this.app.dispatch($77353fe0629f741a$var$update(this.payload));
                break;
        }
        return this;
    };
    NavigationMenu.prototype.updateItem = function(newPayload) {
        if (!this.items) return;
        var itemToUpdate = this.items.find(function(action) {
            return action.id === newPayload.id;
        });
        if (!itemToUpdate) return;
        if ($ditiI.updateActionFromPayload(itemToUpdate, newPayload)) this.dispatch($77353fe0629f741a$var$Action.UPDATE);
    };
    NavigationMenu.prototype.setItems = function(newOptions) {
        var _this = this;
        var newItems = newOptions || [];
        var currentItems = this.itemsOptions || [];
        this.itemsOptions = this.getUpdatedChildActions(newItems, currentItems);
        this.items = this.itemsOptions ? this.itemsOptions.map(function(action) {
            _this.addChild(action, _this.group, $77353fe0629f741a$var$SUBGROUPS);
            _this.subscribeToChild(action, $iPOLj.Action.UPDATE, _this.updateItem);
            return action.payload;
        }) : [];
    };
    return NavigationMenu;
}($cfM0i.ActionSetWithChildren);
module.exports.NavigationMenu = $77353fe0629f741a$var$NavigationMenu;

});
parcelRegister("iPOLj", function(module, exports) {
"use strict";
var $db645db023c26e10$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $db645db023c26e10$var$__assign = module.exports && module.exports.__assign || function() {
    $db645db023c26e10$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $db645db023c26e10$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppLink = module.exports.update = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");

var $5f53Z = parcelRequire("5f53Z");
var $db645db023c26e10$var$Action;
(function(Action) {
    Action["UPDATE"] = "UPDATE";
})($db645db023c26e10$var$Action = module.exports.Action || (module.exports.Action = {}));
function $db645db023c26e10$var$update(group, component, updatePayload) {
    var id = component.id;
    var label = updatePayload.label, destination = updatePayload.destination;
    var linkPayload = $db645db023c26e10$var$__assign($db645db023c26e10$var$__assign({}, updatePayload), {
        id: id,
        label: label,
        destination: destination
    });
    return $ditiI.actionWrapper({
        group: group,
        type: $ditiI.getEventNameSpace(group, $db645db023c26e10$var$Action.UPDATE, component),
        payload: linkPayload
    });
}
module.exports.update = $db645db023c26e10$var$update;
var $db645db023c26e10$var$AppLink = /** @class */ function(_super) {
    $db645db023c26e10$var$__extends(AppLink, _super);
    function AppLink(app, options) {
        var _this = _super.call(this, app, $f8QDr.Group.Link, $f8QDr.Group.Link) || this;
        _this.label = '';
        _this.destination = '';
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(AppLink.prototype, "options", {
        get: function() {
            var _a = this, label = _a.label, destination = _a.destination;
            return {
                label: label,
                destination: destination,
                redirectType: $5f53Z.Action.APP
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppLink.prototype, "payload", {
        get: function() {
            var _a = this.options, label = _a.label, destination = _a.destination, redirectType = _a.redirectType;
            var path = destination;
            return {
                id: this.id,
                label: label,
                destination: {
                    path: path
                },
                redirectType: redirectType
            };
        },
        enumerable: false,
        configurable: true
    });
    AppLink.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var _a = $ditiI.getMergedProps(this.options, options), label = _a.label, destination = _a.destination;
        this.label = label;
        this.destination = destination;
        if (shouldUpdate) this.dispatch($db645db023c26e10$var$Action.UPDATE);
        return this;
    };
    AppLink.prototype.dispatch = function(action) {
        switch(action){
            case $db645db023c26e10$var$Action.UPDATE:
                var updateAction = $db645db023c26e10$var$update(this.group, this.component, this.payload);
                this.app.dispatch(updateAction);
                break;
        }
        return this;
    };
    return AppLink;
}($cfM0i.ActionSet);
module.exports.AppLink = $db645db023c26e10$var$AppLink;

});



parcelRegister("doCr6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.ChannelMenu = module.exports.update = module.exports.Action = void 0;

var $4MRkb = parcelRequire("4MRkb");
Object.defineProperty(module.exports, "ChannelMenu", {
    enumerable: true,
    get: function() {
        return $4MRkb.ChannelMenu;
    }
});

var $4MRkb = parcelRequire("4MRkb");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $4MRkb.Action;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $4MRkb.update;
    }
});
function $9c0b54de2f29032c$var$create(app, options) {
    return new $4MRkb.ChannelMenu(app, options);
}
module.exports.create = $9c0b54de2f29032c$var$create;

});
parcelRegister("4MRkb", function(module, exports) {
"use strict";
var $37c502443018ea21$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $37c502443018ea21$var$__assign = module.exports && module.exports.__assign || function() {
    $37c502443018ea21$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37c502443018ea21$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChannelMenu = module.exports.update = module.exports.Action = void 0;

var $iPOLj = parcelRequire("iPOLj");

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var $37c502443018ea21$var$SUBGROUPS = [
    'Channel_Menu'
];
var $37c502443018ea21$var$Action;
(function(Action) {
    Action["UPDATE"] = "APP::MENU::CHANNEL_MENU::UPDATE";
    Action["LINK_UPDATE"] = "APP::MENU::CHANNEL_MENU::LINK::UPDATE";
})($37c502443018ea21$var$Action = module.exports.Action || (module.exports.Action = {}));
function $37c502443018ea21$var$update(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.Menu,
        type: $37c502443018ea21$var$Action.UPDATE
    });
}
module.exports.update = $37c502443018ea21$var$update;
var $37c502443018ea21$var$ChannelMenu = /** @class */ function(_super) {
    $37c502443018ea21$var$__extends(ChannelMenu, _super);
    function ChannelMenu(app, options) {
        var _this = _super.call(this, app, 'Channel_Menu', $f8QDr.Group.Menu) || this;
        _this.items = [];
        // Trigger 'update' on creation
        _this.set(options);
        return _this;
    }
    Object.defineProperty(ChannelMenu.prototype, "options", {
        get: function() {
            return {
                items: this.itemsOptions,
                active: this.activeOptions
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChannelMenu.prototype, "payload", {
        get: function() {
            return $37c502443018ea21$var$__assign($37c502443018ea21$var$__assign({}, this.options), {
                active: this.active,
                items: this.items,
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    ChannelMenu.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var items = mergedOptions.items, active = mergedOptions.active;
        this.setItems(items);
        this.activeOptions = active;
        this.active = active && active.id;
        if (shouldUpdate) this.dispatch($37c502443018ea21$var$Action.UPDATE);
        return this;
    };
    ChannelMenu.prototype.dispatch = function(action) {
        switch(action){
            case $37c502443018ea21$var$Action.UPDATE:
                this.app.dispatch($37c502443018ea21$var$update(this.payload));
                break;
        }
        return this;
    };
    ChannelMenu.prototype.updateItem = function(newPayload) {
        if (!this.items) return;
        var itemToUpdate = this.items.find(function(action) {
            return action.id === newPayload.id;
        });
        if (!itemToUpdate) return;
        if ($ditiI.updateActionFromPayload(itemToUpdate, newPayload)) this.dispatch($37c502443018ea21$var$Action.UPDATE);
    };
    ChannelMenu.prototype.setItems = function(newOptions) {
        var _this = this;
        var newItems = newOptions || [];
        var currentItems = this.itemsOptions || [];
        this.itemsOptions = this.getUpdatedChildActions(newItems, currentItems);
        this.items = this.itemsOptions ? this.itemsOptions.map(function(action) {
            _this.addChild(action, _this.group, $37c502443018ea21$var$SUBGROUPS);
            _this.subscribeToChild(action, $iPOLj.Action.UPDATE, _this.updateItem);
            return action.payload;
        }) : [];
    };
    return ChannelMenu;
}($cfM0i.ActionSetWithChildren);
module.exports.ChannelMenu = $37c502443018ea21$var$ChannelMenu;

});


parcelRegister("3g8Ye", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.AppLink = module.exports.update = module.exports.Action = void 0;

var $iPOLj = parcelRequire("iPOLj");
Object.defineProperty(module.exports, "AppLink", {
    enumerable: true,
    get: function() {
        return $iPOLj.AppLink;
    }
});

var $iPOLj = parcelRequire("iPOLj");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $iPOLj.Action;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $iPOLj.update;
    }
});
function $25f9d31557ed1a9e$var$create(app, options) {
    return new $iPOLj.AppLink(app, options);
}
module.exports.create = $25f9d31557ed1a9e$var$create;

});

parcelRegister("liH6l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.Pos = module.exports.close = module.exports.Action = void 0;

var $6l62U = parcelRequire("6l62U");
Object.defineProperty(module.exports, "Pos", {
    enumerable: true,
    get: function() {
        return $6l62U.Pos;
    }
});

var $6l62U = parcelRequire("6l62U");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $6l62U.Action;
    }
});
Object.defineProperty(module.exports, "close", {
    enumerable: true,
    get: function() {
        return $6l62U.close;
    }
});
function $f81cb672b8cf47a6$var$create(app) {
    return new $6l62U.Pos(app);
}
module.exports.create = $f81cb672b8cf47a6$var$create;

});
parcelRegister("6l62U", function(module, exports) {
"use strict";
var $49d964d899619bfa$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pos = module.exports.close = module.exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
/**
 * Pos action type enum
 * @remarks includes the action prefix and group
 *
 */ var $49d964d899619bfa$var$Action;
(function(Action) {
    Action["CLOSE"] = "APP::POS::CLOSE";
    Action["LOCATION_UPDATE"] = "APP::POS::LOCATION::UPDATE";
    Action["USER_UPDATE"] = "APP::POS::USER::UPDATE";
    Action["DEVICE_UPDATE"] = "APP::POS::DEVICE::UPDATE";
})($49d964d899619bfa$var$Action = module.exports.Action || (module.exports.Action = {}));
function $49d964d899619bfa$var$close() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Pos,
        type: $49d964d899619bfa$var$Action.CLOSE
    });
}
module.exports.close = $49d964d899619bfa$var$close;
var $49d964d899619bfa$var$Pos = /** @class */ function(_super) {
    $49d964d899619bfa$var$__extends(Pos, _super);
    function Pos(app) {
        return _super.call(this, app, $f8QDr.Group.Pos, $f8QDr.Group.Pos) || this;
    }
    Pos.prototype.dispatch = function(action) {
        switch(action){
            case $49d964d899619bfa$var$Action.CLOSE:
                this.app.dispatch($49d964d899619bfa$var$close());
                break;
        }
        return this;
    };
    return Pos;
}($cfM0i.ActionSet);
module.exports.Pos = $49d964d899619bfa$var$Pos;

});


parcelRegister("jv6D2", function(module, exports) {
"use strict";
var $e3260ddc6565a4ce$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e3260ddc6565a4ce$var$__assign = module.exports && module.exports.__assign || function() {
    $e3260ddc6565a4ce$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e3260ddc6565a4ce$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.MarketingExternalActivityTopBar = module.exports.update = module.exports.clickActionButton = module.exports.MarketingActivityStatusBadgeType = module.exports.Action = void 0;

var $9AxfX = parcelRequire("9AxfX");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $9AxfX.Action;
    }
});

var $kI6MI = parcelRequire("kI6MI");

var $i9R0Z = parcelRequire("i9R0Z");

var $jrseT = parcelRequire("jrseT");

var $i8k4a = parcelRequire("i8k4a");

var $hrrN9 = parcelRequire("hrrN9");
var $e3260ddc6565a4ce$var$MarketingActivityStatusBadgeType;
(function(MarketingActivityStatusBadgeType) {
    MarketingActivityStatusBadgeType["Default"] = "DEFAULT";
    MarketingActivityStatusBadgeType["Success"] = "SUCCESS";
    MarketingActivityStatusBadgeType["Attention"] = "ATTENTION";
    MarketingActivityStatusBadgeType["Warning"] = "WARNING";
    MarketingActivityStatusBadgeType["Info"] = "INFO";
})($e3260ddc6565a4ce$var$MarketingActivityStatusBadgeType = module.exports.MarketingActivityStatusBadgeType || (module.exports.MarketingActivityStatusBadgeType = {}));
var $e3260ddc6565a4ce$var$MARKETING_ACTIVITY_TOPBAR_BUTTON_PROPS = {
    group: $hrrN9.Group.MarketingExternalActivityTopBar,
    subgroups: [
        'Buttons'
    ]
};
function $e3260ddc6565a4ce$var$clickActionButton(id, payload) {
    var type = $hrrN9.ComponentType.Button;
    var component = $e3260ddc6565a4ce$var$__assign({
        id: id,
        type: type
    }, $e3260ddc6565a4ce$var$MARKETING_ACTIVITY_TOPBAR_BUTTON_PROPS);
    return $kI6MI.clickButton($hrrN9.Group.MarketingExternalActivityTopBar, component, payload);
}
module.exports.clickActionButton = $e3260ddc6565a4ce$var$clickActionButton;
function $e3260ddc6565a4ce$var$update(payload) {
    return $jrseT.actionWrapper({
        payload: payload,
        group: $hrrN9.Group.MarketingExternalActivityTopBar,
        type: $9AxfX.Action.UPDATE
    });
}
module.exports.update = $e3260ddc6565a4ce$var$update;
var $e3260ddc6565a4ce$var$MarketingExternalActivityTopBar = /** @class */ function(_super) {
    $e3260ddc6565a4ce$var$__extends(MarketingExternalActivityTopBar, _super);
    function MarketingExternalActivityTopBar(app, options) {
        var _this = _super.call(this, app, $hrrN9.Group.MarketingExternalActivityTopBar, $hrrN9.Group.MarketingExternalActivityTopBar) || this;
        // Trigger 'update' on creation
        _this.set(options);
        return _this;
    }
    Object.defineProperty(MarketingExternalActivityTopBar.prototype, "buttons", {
        get: function() {
            if (!this.primary && !this.secondary) return undefined;
            return {
                primary: this.primary,
                secondary: this.secondary
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MarketingExternalActivityTopBar.prototype, "buttonsOptions", {
        get: function() {
            if (!this.primaryOptions && !this.secondaryOptions) return undefined;
            return {
                primary: this.primaryOptions,
                secondary: this.secondaryOptions
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MarketingExternalActivityTopBar.prototype, "options", {
        get: function() {
            return {
                title: this.title,
                status: this.status,
                saving: this.saving,
                saved: this.saved,
                buttons: this.buttonsOptions
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MarketingExternalActivityTopBar.prototype, "payload", {
        get: function() {
            return $e3260ddc6565a4ce$var$__assign($e3260ddc6565a4ce$var$__assign({}, this.options), {
                buttons: this.buttons,
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    MarketingExternalActivityTopBar.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $jrseT.getMergedProps(this.options, options);
        var title = mergedOptions.title, buttons = mergedOptions.buttons, saved = mergedOptions.saved, saving = mergedOptions.saving, status = mergedOptions.status;
        this.title = title;
        this.saving = saving;
        this.saved = saved;
        this.status = status;
        this.setPrimaryButton(buttons ? buttons.primary : undefined);
        this.setSecondaryButtons(buttons ? buttons.secondary : undefined);
        if (shouldUpdate) this.dispatch($9AxfX.Action.UPDATE);
        return this;
    };
    MarketingExternalActivityTopBar.prototype.dispatch = function(action) {
        switch(action){
            case $9AxfX.Action.UPDATE:
                this.app.dispatch($e3260ddc6565a4ce$var$update(this.payload));
                break;
        }
        return this;
    };
    MarketingExternalActivityTopBar.prototype.getButton = function(button, subgroups, updateCb) {
        return $i9R0Z.getSingleButton(this, button, subgroups, updateCb);
    };
    MarketingExternalActivityTopBar.prototype.updatePrimaryButton = function(newPayload) {
        if (!this.primary) return;
        if ($jrseT.updateActionFromPayload(this.primary, newPayload)) this.dispatch($9AxfX.Action.UPDATE);
    };
    MarketingExternalActivityTopBar.prototype.updateSecondaryButtons = function(newPayload) {
        if (!this.secondary) return;
        var buttonToUpdate = this.secondary.find(function(action) {
            return action.id === newPayload.id;
        });
        if (!buttonToUpdate) return;
        var updated = $jrseT.updateActionFromPayload(buttonToUpdate, newPayload);
        if (updated) this.dispatch($9AxfX.Action.UPDATE);
    };
    MarketingExternalActivityTopBar.prototype.setPrimaryButton = function(newOptions) {
        this.primaryOptions = this.getChildButton(newOptions, this.primaryOptions);
        this.primary = this.primaryOptions ? this.getButton(this.primaryOptions, $e3260ddc6565a4ce$var$MARKETING_ACTIVITY_TOPBAR_BUTTON_PROPS.subgroups, this.updatePrimaryButton) : undefined;
    };
    MarketingExternalActivityTopBar.prototype.setSecondaryButtons = function(newOptions) {
        var _this = this;
        var newButtons = newOptions || [];
        var currentButtons = this.secondaryOptions || [];
        this.secondaryOptions = this.getUpdatedChildActions(newButtons, currentButtons);
        this.secondary = this.secondaryOptions ? this.secondaryOptions.map(function(action) {
            return _this.getButton(action, $e3260ddc6565a4ce$var$MARKETING_ACTIVITY_TOPBAR_BUTTON_PROPS.subgroups, _this.updateSecondaryButtons);
        }) : undefined;
    };
    MarketingExternalActivityTopBar.prototype.updateSaving = function(saving) {
        this.saving = saving;
        this.dispatch($9AxfX.Action.UPDATE);
    };
    MarketingExternalActivityTopBar.prototype.updateSaved = function(saved) {
        this.saved = saved;
        this.dispatch($9AxfX.Action.UPDATE);
    };
    MarketingExternalActivityTopBar.prototype.updateStatus = function(newPayload) {
        this.status = newPayload;
        this.dispatch($9AxfX.Action.UPDATE);
    };
    MarketingExternalActivityTopBar.prototype.getChildButton = function(newAction, currentAction) {
        var newButtons = newAction ? [
            newAction
        ] : [];
        var currentButtons = currentAction ? [
            currentAction
        ] : [];
        var updatedButton = this.getUpdatedChildActions(newButtons, currentButtons);
        return updatedButton ? updatedButton[0] : undefined;
    };
    return MarketingExternalActivityTopBar;
}($i8k4a.ActionSetWithChildren);
module.exports.MarketingExternalActivityTopBar = $e3260ddc6565a4ce$var$MarketingExternalActivityTopBar;
function $e3260ddc6565a4ce$var$create(app, options) {
    return new $e3260ddc6565a4ce$var$MarketingExternalActivityTopBar(app, options);
}
module.exports.create = $e3260ddc6565a4ce$var$create;

});
parcelRegister("9AxfX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Action = void 0;
var $6fb145e2af686771$var$Action;
(function(Action) {
    Action["UPDATE"] = "APP::MARKETING_EXTERNAL_ACTIVITY_TOP_BAR::UPDATE";
    Action["BUTTON_CLICK"] = "APP::MARKETING_EXTERNAL_ACTIVITY_TOP_BAR::BUTTONS::BUTTON::CLICK";
    Action["BUTTON_UPDATE"] = "APP::MARKETING_EXTERNAL_ACTIVITY_TOP_BAR::BUTTONS::BUTTON::UPDATE";
})($6fb145e2af686771$var$Action = module.exports.Action || (module.exports.Action = {}));

});

parcelRegister("i9R0Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSingleButton = void 0;

var $2cTI8 = parcelRequire("2cTI8");
Object.defineProperty(module.exports, "getSingleButton", {
    enumerable: true,
    get: function() {
        return $2cTI8.getSingleButton;
    }
});

});

parcelRegister("i8k4a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unsubscribeActions = module.exports.ActionSetWithChildren = module.exports.ActionSet = void 0;

var $cfM0i = parcelRequire("cfM0i");
Object.defineProperty(module.exports, "ActionSet", {
    enumerable: true,
    get: function() {
        return $cfM0i.ActionSet;
    }
});
Object.defineProperty(module.exports, "ActionSetWithChildren", {
    enumerable: true,
    get: function() {
        return $cfM0i.ActionSetWithChildren;
    }
});
Object.defineProperty(module.exports, "unsubscribeActions", {
    enumerable: true,
    get: function() {
        return $cfM0i.unsubscribeActions;
    }
});

});


parcelRegister("cwMLc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fullPageLoad = module.exports.skeletonPageLoad = module.exports.Action = void 0;

var $aGzY9 = parcelRequire("aGzY9");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $aGzY9.Action;
    }
});
Object.defineProperty(module.exports, "skeletonPageLoad", {
    enumerable: true,
    get: function() {
        return $aGzY9.skeletonPageLoad;
    }
});
Object.defineProperty(module.exports, "fullPageLoad", {
    enumerable: true,
    get: function() {
        return $aGzY9.fullPageLoad;
    }
});

});
parcelRegister("aGzY9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fullPageLoad = module.exports.skeletonPageLoad = module.exports.Action = void 0;

var $f8QDr = parcelRequire("f8QDr");

var $ditiI = parcelRequire("ditiI");
var $7c79ba5f1d9ff33b$var$Action;
(function(Action) {
    Action["SKELETON_PAGE_LOAD"] = "APP::PERFORMANCE::SKELETON_PAGE_LOAD";
    Action["FULL_PAGE_LOAD"] = "APP::PERFORMANCE::FULL_PAGE_LOAD";
})($7c79ba5f1d9ff33b$var$Action = module.exports.Action || (module.exports.Action = {}));
function $7c79ba5f1d9ff33b$var$skeletonPageLoad() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Performance,
        type: $7c79ba5f1d9ff33b$var$Action.SKELETON_PAGE_LOAD
    });
}
module.exports.skeletonPageLoad = $7c79ba5f1d9ff33b$var$skeletonPageLoad;
function $7c79ba5f1d9ff33b$var$fullPageLoad() {
    return $ditiI.actionWrapper({
        group: $f8QDr.Group.Performance,
        type: $7c79ba5f1d9ff33b$var$Action.FULL_PAGE_LOAD
    });
}
module.exports.fullPageLoad = $7c79ba5f1d9ff33b$var$fullPageLoad;

});


parcelRegister("fnmJU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.unstable_Picker = module.exports.update = module.exports.select = module.exports.search = module.exports.open = module.exports.loadMore = module.exports.cancel = module.exports.ALL_RESOURCE_VERTICAL_ALIGNMENT = module.exports.ALL_MEDIA_KINDS = module.exports.ALL_BADGE_STATUSES = module.exports.ALL_BADGE_PROGRESSES = module.exports.Action = void 0;

var $etApS = parcelRequire("etApS");
Object.defineProperty(module.exports, "unstable_Picker", {
    enumerable: true,
    get: function() {
        return $etApS.unstable_Picker;
    }
});

var $etApS = parcelRequire("etApS");
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $etApS.Action;
    }
});
Object.defineProperty(module.exports, "ALL_BADGE_PROGRESSES", {
    enumerable: true,
    get: function() {
        return $etApS.ALL_BADGE_PROGRESSES;
    }
});
Object.defineProperty(module.exports, "ALL_BADGE_STATUSES", {
    enumerable: true,
    get: function() {
        return $etApS.ALL_BADGE_STATUSES;
    }
});
Object.defineProperty(module.exports, "ALL_MEDIA_KINDS", {
    enumerable: true,
    get: function() {
        return $etApS.ALL_MEDIA_KINDS;
    }
});
Object.defineProperty(module.exports, "ALL_RESOURCE_VERTICAL_ALIGNMENT", {
    enumerable: true,
    get: function() {
        return $etApS.ALL_RESOURCE_VERTICAL_ALIGNMENT;
    }
});
Object.defineProperty(module.exports, "cancel", {
    enumerable: true,
    get: function() {
        return $etApS.cancel;
    }
});
Object.defineProperty(module.exports, "loadMore", {
    enumerable: true,
    get: function() {
        return $etApS.loadMore;
    }
});
Object.defineProperty(module.exports, "open", {
    enumerable: true,
    get: function() {
        return $etApS.open;
    }
});
Object.defineProperty(module.exports, "search", {
    enumerable: true,
    get: function() {
        return $etApS.search;
    }
});
Object.defineProperty(module.exports, "select", {
    enumerable: true,
    get: function() {
        return $etApS.select;
    }
});
Object.defineProperty(module.exports, "update", {
    enumerable: true,
    get: function() {
        return $etApS.update;
    }
});
var $b31aa49405738965$var$create = function(app, options) {
    // eslint-disable-next-line @babel/new-cap
    return new $etApS.unstable_Picker(app, options);
};
module.exports.create = $b31aa49405738965$var$create;

});
parcelRegister("etApS", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unstable_Picker = exports.loadMore = exports.search = exports.update = exports.cancel = exports.open = exports.select = exports.ALL_RESOURCE_VERTICAL_ALIGNMENT = exports.ALL_MEDIA_KINDS = exports.ALL_BADGE_STATUSES = exports.ALL_BADGE_PROGRESSES = exports.Action = void 0;

var $ditiI = parcelRequire("ditiI");

var $cfM0i = parcelRequire("cfM0i");

var $f8QDr = parcelRequire("f8QDr");
var Action;
(function(Action) {
    Action["OPEN"] = "APP::PICKER::OPEN";
    Action["SELECT"] = "APP::PICKER::SELECT";
    Action["UPDATE"] = "APP::PICKER::UPDATE";
    Action["CANCEL"] = "APP::PICKER::CANCEL";
    Action["SEARCH"] = "APP::PICKER::SEARCH";
    Action["LOAD_MORE"] = "APP::PICKER::LOAD_MORE";
})(Action = exports.Action || (exports.Action = {}));
/**
 * To be used on validator as matchEnum(...). Make sure as new values are added to update
 * the items below
 *
 * Note: Intentionally not using an `enum type` directly as this would cause a dependency
 * of the same enum on the consumer API rather than just the string values.
 */ exports.ALL_BADGE_PROGRESSES = [
    'incomplete',
    'partiallyComplete',
    'complete'
];
exports.ALL_BADGE_STATUSES = [
    'success',
    'info',
    'attention',
    'critical',
    'warning',
    'new'
];
exports.ALL_MEDIA_KINDS = [
    'Avatar',
    'Thumbnail'
];
exports.ALL_RESOURCE_VERTICAL_ALIGNMENT = [
    'leading',
    'trailing',
    'center'
];
function select(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.unstable_Picker,
        type: Action.SELECT
    });
}
exports.select = select;
function open(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.unstable_Picker,
        type: Action.OPEN
    });
}
exports.open = open;
function cancel(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.unstable_Picker,
        type: Action.CANCEL
    });
}
exports.cancel = cancel;
function update(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.unstable_Picker,
        type: Action.UPDATE
    });
}
exports.update = update;
function search(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.unstable_Picker,
        type: Action.SEARCH
    });
}
exports.search = search;
function loadMore(payload) {
    return $ditiI.actionWrapper({
        payload: payload,
        group: $f8QDr.Group.unstable_Picker,
        type: Action.LOAD_MORE
    });
}
exports.loadMore = loadMore;
/**
 * @unstable This API may be updated without warning in the future
 */ var unstable_Picker = /** @class */ function(_super) {
    __extends(unstable_Picker, _super);
    function unstable_Picker(app, options) {
        var _this = _super.call(this, app, $f8QDr.Group.unstable_Picker, $f8QDr.Group.unstable_Picker) || this;
        _this.items = [];
        _this.selectedItems = [];
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(unstable_Picker.prototype, "payload", {
        get: function() {
            return __assign(__assign({}, this.options), {
                id: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(unstable_Picker.prototype, "options", {
        get: function() {
            return {
                items: this.items,
                maxSelectable: this.maxSelectable,
                selectedItems: this.selectedItems,
                title: this.title,
                loading: this.loading,
                searchQuery: this.searchQuery,
                searchQueryPlaceholder: this.searchQueryPlaceholder,
                primaryActionLabel: this.primaryActionLabel,
                secondaryActionLabel: this.secondaryActionLabel,
                emptySearchLabel: this.emptySearchLabel,
                canLoadMore: this.canLoadMore,
                loadingMore: this.loadingMore,
                verticalAlignment: this.verticalAlignment,
                allowEmptySelection: this.allowEmptySelection,
                resourceName: this.resourceName
            };
        },
        enumerable: false,
        configurable: true
    });
    unstable_Picker.prototype.set = function(options, shouldUpdate) {
        if (shouldUpdate === void 0) shouldUpdate = true;
        var mergedOptions = $ditiI.getMergedProps(this.options, options);
        var _a = mergedOptions.selectedItems, selectedItems = _a === void 0 ? [] : _a, _b = mergedOptions.maxSelectable, maxSelectable = _b === void 0 ? 0 : _b, _c = mergedOptions.items, items = _c === void 0 ? [] : _c, _d = mergedOptions.loading, loading = _d === void 0 ? false : _d, title = mergedOptions.title, searchQuery = mergedOptions.searchQuery, searchQueryPlaceholder = mergedOptions.searchQueryPlaceholder, primaryActionLabel = mergedOptions.primaryActionLabel, secondaryActionLabel = mergedOptions.secondaryActionLabel, emptySearchLabel = mergedOptions.emptySearchLabel, _e = mergedOptions.canLoadMore, canLoadMore = _e === void 0 ? false : _e, _f = mergedOptions.loadingMore, loadingMore = _f === void 0 ? false : _f, verticalAlignment = mergedOptions.verticalAlignment, allowEmptySelection = mergedOptions.allowEmptySelection, resourceName = mergedOptions.resourceName;
        this.title = title;
        this.items = items;
        this.selectedItems = selectedItems;
        this.maxSelectable = maxSelectable;
        this.loading = loading;
        this.searchQuery = searchQuery;
        this.searchQueryPlaceholder = searchQueryPlaceholder;
        this.primaryActionLabel = primaryActionLabel;
        this.secondaryActionLabel = secondaryActionLabel;
        this.emptySearchLabel = emptySearchLabel;
        this.canLoadMore = canLoadMore;
        this.loadingMore = loadingMore;
        this.verticalAlignment = verticalAlignment;
        this.allowEmptySelection = allowEmptySelection;
        this.resourceName = resourceName;
        if (shouldUpdate) this.update();
        return this;
    };
    unstable_Picker.prototype.dispatch = function(action, payload) {
        if (action === Action.OPEN) this.open();
        else if (action === Action.UPDATE) this.update();
        else if (action === Action.CANCEL) this.cancel();
        else if (action === Action.SELECT) {
            this.selectedItems = (payload === null || payload === void 0 ? void 0 : payload.selectedItems) || [];
            this.app.dispatch(select({
                id: this.id,
                selectedItems: this.selectedItems
            }));
        } else if (action === Action.SEARCH) {
            this.searchQuery = (payload === null || payload === void 0 ? void 0 : payload.searchQuery) || '';
            this.app.dispatch(search({
                id: this.id,
                searchQuery: this.searchQuery
            }));
        } else if (action === Action.LOAD_MORE) this.loadMore();
        return this;
    };
    unstable_Picker.prototype.update = function() {
        this.app.dispatch(update(this.payload));
    };
    unstable_Picker.prototype.open = function() {
        this.app.dispatch(open(this.payload));
    };
    unstable_Picker.prototype.cancel = function() {
        this.app.dispatch(cancel({
            id: this.id
        }));
    };
    unstable_Picker.prototype.loadMore = function() {
        this.app.dispatch(loadMore(this.payload));
    };
    return unstable_Picker;
}($cfM0i.ActionSet);
exports.unstable_Picker = unstable_Picker;

});


parcelRegister("gMmax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFromApp = module.exports.isPerformanceOrWebVitalsAction = module.exports.getPermissionKey = module.exports.isPermitted = module.exports.isAppMessage = module.exports.isAppBridgeAction = void 0;

var $7XU50 = parcelRequire("7XU50");
Object.defineProperty(module.exports, "isAppBridgeAction", {
    enumerable: true,
    get: function() {
        return $7XU50.isAppBridgeAction;
    }
});
Object.defineProperty(module.exports, "isAppMessage", {
    enumerable: true,
    get: function() {
        return $7XU50.isAppMessage;
    }
});
Object.defineProperty(module.exports, "isPermitted", {
    enumerable: true,
    get: function() {
        return $7XU50.isPermitted;
    }
});
Object.defineProperty(module.exports, "getPermissionKey", {
    enumerable: true,
    get: function() {
        return $7XU50.getPermissionKey;
    }
});
Object.defineProperty(module.exports, "isPerformanceOrWebVitalsAction", {
    enumerable: true,
    get: function() {
        return $7XU50.isPerformanceOrWebVitalsAction;
    }
});
/**
 * Predicate to determine if an action originated from an application.
 * @internal
 */ function $c37253518982aaab$var$isFromApp(action) {
    if (typeof action !== 'object' || typeof action.source !== 'object') return false;
    return typeof action.source.apiKey === 'string';
}
module.exports.isFromApp = $c37253518982aaab$var$isFromApp;

});




parcelRegister("4c77K", function(module, exports) {
"use strict";
var $30ddcf1239cc9499$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $30ddcf1239cc9499$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $30ddcf1239cc9499$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$30ddcf1239cc9499$var$__exportStar((parcelRequire("7MFZ8")), module.exports);

$30ddcf1239cc9499$var$__exportStar((parcelRequire("hsmxY")), module.exports);

});
parcelRegister("7MFZ8", function(module, exports) {
"use strict";
var $5aad957956ab005e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5aad957956ab005e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5aad957956ab005e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5aad957956ab005e$var$__createBinding(result, mod, k);
    }
    $5aad957956ab005e$var$__setModuleDefault(result, mod);
    return result;
};
var $5aad957956ab005e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5aad957956ab005e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5aad957956ab005e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAuthorizationCodePayload = void 0;

var $5aad957956ab005e$var$AuthCode = $5aad957956ab005e$var$__importStar((parcelRequire("jWnCY")));

var $1maiX = parcelRequire("1maiX");

var $5aad957956ab005e$var$uuid_1 = $5aad957956ab005e$var$__importDefault((parcelRequire("7OmL2")));
function $5aad957956ab005e$var$getAuthorizationCodePayload(app) {
    return $5aad957956ab005e$var$__awaiter(this, void 0, void 0, function() {
        return $5aad957956ab005e$var$__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    var requestId = $5aad957956ab005e$var$uuid_1.default();
                    var unsubscribe = app.subscribe($5aad957956ab005e$var$AuthCode.Action.RESPOND, function(payload) {
                        switch(payload === null || payload === void 0 ? void 0 : payload.status){
                            case 'needsExchange':
                                resolve(payload);
                                break;
                            default:
                                reject($1maiX.fromAction('Failed to retrieve an authorization code', $1maiX.Action.FAILED_AUTHENTICATION));
                        }
                        unsubscribe();
                    }, requestId);
                    app.dispatch($5aad957956ab005e$var$AuthCode.request(requestId));
                })
            ];
        });
    });
}
module.exports.getAuthorizationCodePayload = $5aad957956ab005e$var$getAuthorizationCodePayload;

});
parcelRegister("7OmL2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateUuid = void 0;

var $a4rFw = parcelRequire("a4rFw");
Object.defineProperty(module.exports, "generateUuid", {
    enumerable: true,
    get: function() {
        return $a4rFw.generateUuid;
    }
});
module.exports.default = $a4rFw.generateUuid;

});


parcelRegister("hsmxY", function(module, exports) {
"use strict";
var $cb568a8dc1c11631$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cb568a8dc1c11631$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.userAuthorizedFetch = void 0;

var $7MFZ8 = parcelRequire("7MFZ8");
var $cb568a8dc1c11631$var$DEFAULT_CALLBACK_URI = 'auth/shopify/callback';
function $cb568a8dc1c11631$var$needsAuthorizationCode(response) {
    var headerValue = response.headers.get('X-Shopify-API-Request-Failure-Unauthorized');
    if (headerValue) return headerValue.toLowerCase() === 'true';
    return false;
}
function $cb568a8dc1c11631$var$userAuthorizedFetch(_a) {
    var _this = this;
    var app = _a.app, _b = _a.callbackUri, callbackUri = _b === void 0 ? $cb568a8dc1c11631$var$DEFAULT_CALLBACK_URI : _b, _c = _a.isAuthorizationCodeRequired, isAuthorizationCodeRequired = _c === void 0 ? $cb568a8dc1c11631$var$needsAuthorizationCode : _c, fetchOperation = _a.fetchOperation;
    return function(uri, options) {
        return $cb568a8dc1c11631$var$__awaiter(_this, void 0, void 0, function() {
            var response, _a, code, hmac, shop, timestamp, formattedCallbackUri, callbackResponse;
            return $cb568a8dc1c11631$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetchOperation(uri, options)
                        ];
                    case 1:
                        response = _b.sent();
                        if (!isAuthorizationCodeRequired(response)) return [
                            2 /*return*/ ,
                            response
                        ];
                        return [
                            4 /*yield*/ ,
                            $7MFZ8.getAuthorizationCodePayload(app)
                        ];
                    case 2:
                        _a = _b.sent(), code = _a.code, hmac = _a.hmac, shop = _a.shop, timestamp = _a.timestamp;
                        formattedCallbackUri = encodeURI("https://" + window.location.hostname + "/" + callbackUri + "?code=" + code + "&hmac=" + hmac + "&shop=" + shop + "&timestamp=" + timestamp);
                        return [
                            4 /*yield*/ ,
                            fetchOperation(formattedCallbackUri, {})
                        ];
                    case 3:
                        callbackResponse = _b.sent();
                        if (!callbackResponse.ok) throw new Error('Failed to authorize request.');
                        return [
                            2 /*return*/ ,
                            fetchOperation(uri, options)
                        ];
                }
            });
        });
    };
}
module.exports.userAuthorizedFetch = $cb568a8dc1c11631$var$userAuthorizedFetch;

});


// Copilot 0.1
// COMPONENTS
// Funcions preparades per importar
const $acadbbff5345f996$export$9203d81459545c2d = `
<span class="Polaris-Spinner Polaris-Spinner--sizeLarge">
	<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
		<path d="M15.542 1.487A21.507 21.507 0 00.5 22c0 11.874 9.626 21.5 21.5 21.5 9.847 0 18.364-6.675 20.809-16.072a1.5 1.5 0 00-2.904-.756C37.803 34.755 30.473 40.5 22 40.5 11.783 40.5 3.5 32.217 3.5 22c0-8.137 5.3-15.247 12.942-17.65a1.5 1.5 0 10-.9-2.863z"></path>
	</svg>
</span>
<span role="status">
	<span class="Polaris-Text--root Polaris-Text--visuallyHidden">Spinner example</span>
</span>`;
const $acadbbff5345f996$export$67a87d37f803e18a = `
<span class="Polaris-Spinner Polaris-Spinner--sizeSmall">
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.506-8.329 1.25 1.25 0 10-.75-2.385z">
    </path>
  </svg>
</span>
<span role="status">
  <span class="Polaris-Text--root Polaris-Text--visuallyHidden">Small spinner example</span>
</span>`;
const $acadbbff5345f996$export$753dee7e45dd587a = `
<div class="Polaris-BlockStack" style="--pc-block-stack-inline-align:center;--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)">
  <div class="Polaris-Box" style="--pc-box-max-width:var(--pc-skeleton-page-max-width);--pc-box-padding-block-start-xs:var(--p-space-0);--pc-box-padding-block-end-xs:var(--p-space-0);--pc-box-padding-inline-start-sm:var(--p-space-600);--pc-box-padding-inline-end-sm:var(--p-space-600);--pc-box-width:100%" role="status" aria-label="Page loading">
    <div class="Polaris-BlockStack" style="--pc-block-stack-order:column">
      <div class="Polaris-Box" style="--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-start-md:var(--p-space-500);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-block-end-md:var(--p-space-500);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-start-sm:var(--p-space-0);--pc-box-padding-inline-end-xs:var(--p-space-400);--pc-box-padding-inline-end-sm:var(--p-space-0);--pc-box-width:100%">
        <div class="Polaris-InlineStack" style="--pc-inline-stack-align:space-between;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row">
          <div class="Polaris-InlineStack" style="--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row">
            <div class="Polaris-Box" style="--pc-box-padding-block-start-xs:var(--p-space-100);--pc-box-padding-block-end-xs:var(--p-space-100)">
              <div class="Polaris-SkeletonPage__SkeletonTitle">
                <div class="Polaris-Box" style="--pc-box-background:var(--p-color-bg-fill-tertiary);--pc-box-border-radius:var(--p-border-radius-100);--pc-box-min-height:28px;--pc-box-min-width:120px">                
                </div>
              </div>
            </div>
          </div>
          <div class="Polaris-Box" id="SkeletonPage-PrimaryAction" style="--pc-box-background:var(--p-color-bg-fill-tertiary);--pc-box-border-radius:var(--p-border-radius-100);--pc-box-min-height:2.25rem;--pc-box-min-width:6.25rem">          
          </div>
        </div>
      </div>
      <div class="Polaris-Box" style="--pc-box-padding-block-end-xs:var(--p-space-200);--pc-box-width:100%">
        <div class="Polaris-Layout">
          <div class="Polaris-Layout__Section">
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                </div>
              </div>
            </div>
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-TextContainer">
                  <div class="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeSmall">
                  </div>
                  <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-TextContainer">
                  <div class="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeSmall">
                  </div>
                  <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="Polaris-Layout__Section Polaris-Layout__Section--oneThird">
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding">
                <div class="Polaris-TextContainer">
                  <div class="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeSmall">
                  </div>
                  <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                </div>
              </div>
            </div>
            <div class="Polaris-LegacyCard Polaris-LegacyCard--subdued">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding">
                <div class="Polaris-TextContainer">
                  <div class="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeSmall">
                  </div>
                  <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`;
const $acadbbff5345f996$var$backButtonComponent = function(previousPage = 'dashboard') {
    return `
<button class="Polaris-FullscreenBar__BackAction" page-link="` + previousPage + `">
  <span class="Polaris-Icon">
	<svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
	  <path d="M9.75 3c-1.243 0-2.25 1.007-2.25 2.25 0 .414.336.75.75.75s.75-.336.75-.75.336-.75.75-.75h3.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.414 0-.75-.336-.75-.75s-.336-.75-.75-.75-.75.336-.75.75c0 1.243 1.007 2.25 2.25 2.25h3.5c1.519 0 2.75-1.231 2.75-2.75v-8.5c0-1.519-1.231-2.75-2.75-2.75h-3.5Z">
	  </path>
	  <path d="M12.25 10.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-5.69l.97-.97c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-2.25 2.25c-.141.14-.22.331-.22.53s.079.39.22.53l2.25 2.25c.293.293.767.293 1.06 0 .293-.293.293-.767 0-1.06l-.97-.97h5.69Z">
	  </path>
	</svg>
  </span>
  <span class="Polaris-Text--root Polaris-Text--bodyLg">Back</span>
</button>`;
};
const $acadbbff5345f996$export$4cfdd1f4e61f585d = function(backButton = false) {
    var copilotHeader = `
<div style="display:flex;flex-grow:1;justify-content:space-between;align-items:center;padding-left:1rem;padding-right:1rem">
  <span class="Polaris-Icon">
    <img class="Polaris-Icon__Img" src="./frontend/assets/images/logo.png" alt="" aria-hidden="true">
  </span>
  <div style="margin-left:1rem;flex-grow:1">		  
	<p class="Polaris-Text--root Polaris-Text--headingLg">Acumen Shift <span class="Polaris-Text--bodyXs">v1.0.1</span></p>
  </div>      
</div>`;
    if (backButton) copilotHeader = $acadbbff5345f996$var$backButtonComponent() + copilotHeader;
    return `<div class="Polaris-FullscreenBar">` + copilotHeader + `</div>`;
};
const $acadbbff5345f996$export$f5695fbbba4e5525 = function(indicator) {
    var no_data = false;
    if (indicator.value == "-" || indicator.value <= 0) no_data = true;
    var indicator_html = `
<div class="Polaris-Grid-Cell 
				  Polaris-Grid-Cell--cell_3ColumnXs 
				  Polaris-Grid-Cell--cell_2ColumnSm 
				  Polaris-Grid-Cell--cell_2ColumnMd 
				  Polaris-Grid-Cell--cell_3ColumnLg 
				  Polaris-Grid-Cell--cell_3ColumnXl">
	<div class="Polaris-LegacyCard">
	  <div class="Polaris-LegacyCard__Header Polaris-LegacyCard__FirstSectionPadding">
		<h2 class="Polaris-Text--root Polaris-Text--headingSm">` + indicator.title + `</h2>
	  </div>
	  <div class="Polaris-LegacyCard__Section">
		<p class="Polaris-Text--root Polaris-Text--center Polaris-Text--headingLg">`;
    if (no_data) indicator_html += `<span class="Polaris-Text--bodySm">Not enough data</span>`;
    else indicator_html += `<span class="Polaris-Text--heading3xl">` + indicator.value + `</span>` + indicator.units;
    indicator_html += `
		</p>
	  </div>
	  <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__LastSectionPadding">
		<p class="Polaris-Text--root Polaris-Text--bodyXs">` + indicator.desc + `</p>
	  </div>
</div>
</div>
	`;
    return indicator_html;
};
const $acadbbff5345f996$export$a6cb52a96ce3e2 = `
<br><br/>
<hr class="Polaris-Divider" style="border-block-start:var(--p-border-width-025) solid var(--p-color-border)">
<div class="Polaris-InlineGrid" style="--pc-inline-grid-grid-template-columns-xs:1fr auto">
<div class="Polaris-FooterHelp" style="--pc-footer-help-align:start">
    <p class="Polaris-Text--root Polaris-Text--bodyXs">
    <a class="Polaris-Link" data-polaris-unstyled="true" page-link="legal">Privacy Policy</a>
  </p>
 </div>
<div class="Polaris-FooterHelp" style="--pc-footer-help-align:end">
  <p class="Polaris-Text--root Polaris-Text--bodyXs">\xa9 Acumen Shift 1.0 2024<!-- --></p>
</div>
`;
const $acadbbff5345f996$export$6293e6144ca02c8d = `
<div class="Polaris-Labelled--hidden">
  <div class="Polaris-Labelled__LabelWrapper">
    <div class="Polaris-Label">
      <label id=":Rq6:Label" for=":Rq6:" class="Polaris-Label__Text">
        <span class="Polaris-Text--root Polaris-Text--bodyMd">Sort by</span>
      </label>
    </div>
  </div>
  <div class="Polaris-Select">
    <select id="select-input" class="Polaris-Select__Input" aria-invalid="false">
      <option value="1">Today</option>
      <option value="2">Yesterday</option>
      <option value="3">Last 7 days</option>
      <option value="4">Last 30 days</option>
    </select>
    <div class="Polaris-Select__Content" aria-hidden="true">
      <div class="Polaris-Box" style="--pc-box-padding-inline-end-xs:var(--p-space-100)">
        <span class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--block Polaris-Text--subdued Polaris-Text--truncate">Sort by</span>
      </div>
      <span id="selected-option" class="Polaris-Select__SelectedOption">Today</span>
      <span class="Polaris-Select__Icon">
        <span class="Polaris-Icon">
          <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
            <path d="M10.884 4.323a1.25 1.25 0 0 0-1.768 0l-2.646 2.647a.75.75 0 0 0 1.06 1.06l2.47-2.47 2.47 2.47a.75.75 0 1 0 1.06-1.06l-2.646-2.647Z">
            </path>
            <path d="m13.53 13.03-2.646 2.647a1.25 1.25 0 0 1-1.768 0l-2.646-2.647a.75.75 0 0 1 1.06-1.06l2.47 2.47 2.47-2.47a.75.75 0 0 1 1.06 1.06Z">
            </path>
          </svg>
        </span>
      </span>
    </div>
    <div class="Polaris-Select__Backdrop">
    </div>
  </div>
</div>
`;
const $acadbbff5345f996$export$21a308e09fbaaed4 = `
<div class="Polaris-Banner Polaris-Banner--withinPage" tabindex="0" role="status" aria-live="polite" id="initialBanner" style="margin-bottom:30px;">
  <div class="Polaris-Box" style="--pc-box-border-radius:var(--p-border-radius-300);--pc-box-padding-block-start-xs:var(--p-space-300);--pc-box-padding-block-end-xs:var(--p-space-300);--pc-box-padding-inline-start-xs:var(--p-space-300);--pc-box-padding-inline-end-xs:var(--p-space-300);--pc-box-width:100%">
    <div class="Polaris-InlineStack" style="--pc-inline-stack-align:space-between;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-flex-direction-xs:row">
      <div class="Polaris-Box" style="--pc-box-width:100%">
        <div class="Polaris-InlineStack" style="--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row">
          <div>
            <div class="Polaris-Box" style="--pc-box-background:var(--p-color-bg-fill-info);--pc-box-border-radius:var(--p-border-radius-200);--pc-box-padding-block-start-xs:var(--p-space-100);--pc-box-padding-block-end-xs:var(--p-space-100);--pc-box-padding-inline-start-xs:var(--p-space-100);--pc-box-padding-inline-end-xs:var(--p-space-100)">
              <span class="Polaris-Banner--textInfoOnBgFill">
                <span class="Polaris-Icon">
                  <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                    <path d="M10 14a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-.75.75Z">
                    </path>
                    <path d="M9 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z">
                    </path>
                    <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                    </path>
                  </svg>
                </span>
              </span>
            </div>
          </div>
          <div class="Polaris-Box" style="--pc-box-width:100%">
            <div class="Polaris-BlockStack" style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)">
              <div>
                <span class="Polaris-Text--root Polaris-Text--bodyMd">
                  <p><b>Please note:</b> In the first few days, you may not see relevant data yet.  We recommend waiting at least 7 days for our systems to display accurate information. Please contact us if you have any questions at <button type="button" class="Polaris-Link Polaris-Link--monochrome" external-link="https://acumenshift.com/contact-en/">https://acumenshift.com/contact-en</button>.
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Polaris-Banner__DismissIcon">
      <button class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly" aria-label="Dismiss notification" type="button" dismiss="initialBanner">
        <span class="Polaris-Button__Icon">
          <span class="Polaris-Banner__icon--secondary">
            <span class="Polaris-Icon">
              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                <path d="M13.97 15.03a.75.75 0 1 0 1.06-1.06l-3.97-3.97 3.97-3.97a.75.75 0 0 0-1.06-1.06l-3.97 3.97-3.97-3.97a.75.75 0 0 0-1.06 1.06l3.97 3.97-3.97 3.97a.75.75 0 1 0 1.06 1.06l3.97-3.97 3.97 3.97Z">
                </path>
              </svg>
            </span>
          </span>
        </span>
      </button>
    </div>
  </div>
</div>
</div>
`;
const $acadbbff5345f996$export$5331ed028a5d769e = `
<div class="Polaris-LegacyCard" style="flex: 1;margin-top:5%;">
    <div class="Polaris-MediaCard">
        <div class="Polaris-MediaCard__MediaContainer">
            <div class="Polaris-VideoThumbnail__ThumbnailContainer">
                <div class="Polaris-VideoThumbnail__Thumbnail" style="background-color:#eef5fe;background-size: auto 100%;background-repeat: no-repeat;background-position: center;padding-bottom:10%;background-image:url(./frontend/assets/images/1970a14d-edce-4545-acf2-f45bd63bd1ed.png)">
                </div>
            </div>
        </div>
        <div class="Polaris-MediaCard__InfoContainer">
            <div class="Polaris-Box" style="--pc-box-padding-block-start-xs:var(--p-space-500);--pc-box-padding-block-end-xs:var(--p-space-500);--pc-box-padding-inline-start-xs:var(--p-space-500);--pc-box-padding-inline-end-xs:var(--p-space-500)">
                <div class="Polaris-BlockStack" style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)">
                    <div class="Polaris-InlineStack" style="--pc-inline-stack-align:space-between;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row">
                        <div>
                            <h2 class="Polaris-Text--root Polaris-Text--headingSm">
                                Track for free your store's key performances and get alerts in real-time, with our mobile app!
                            </h2>
                        </div>
                    </div>
                    <p class="Polaris-Text--root Polaris-Text--bodyMd">
                        Get instant alerts on unexpected performance changes and receive regular reports
                        to optimize your store.
                    </p>
                    <p class="Polaris-Text--root Polaris-Text--bodyMd">
                        Free, available on iOS & Android and easy to use. Quick 2-step
                        onboarding: install the Shopify extension, download our mobile app, and start improving
                        your store\u{2019}s performance today!
                    </p>
                    <div class="Polaris-MediaCard__ActionContainer">
                        <div class="Polaris-ButtonGroup" style="justify-content: flex-end">
                            <div class="Polaris-ButtonGroup__Item">
                                <button class="Polaris-Link Polaris-Link--monochrome" external-link="https://play.google.com/store/apps/details?id=com.acumenshift.app"><img width="100%;" src="./frontend/assets/images/google_play_badge.png"></button>
                            </div>
                            <div class="Polaris-ButtonGroup__Item">
                                <button class="Polaris-Link Polaris-Link--monochrome" external-link="https://apps.apple.com/es/app/acumen-shift/id6744528204"><img width="100%;" src="./frontend/assets/images/appstore_badge.svg"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;


const $06aef7bae2699b9e$export$f5f2b7216332d86e = (0, $acadbbff5345f996$export$4cfdd1f4e61f585d)() + `
<div class="Polaris-Page Polaris-Page--fullWidth">
	<div class="Polaris-BlockStack" style="--pc-block-stack-inline-align:center;--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)">
	<div class="Polaris-Box" style="--pc-box-max-width:var(--pc-skeleton-page-max-width);--pc-box-padding-block-start-xs:var(--p-space-0);--pc-box-padding-block-end-xs:var(--p-space-0);--pc-box-padding-inline-start-sm:var(--p-space-600);--pc-box-padding-inline-end-sm:var(--p-space-600);--pc-box-width:100%;text-align:right;padding-top:15px;" role="status" aria-label="Page loading">	
		` + (0, $acadbbff5345f996$export$67a87d37f803e18a) + `			
	</div>
	</div>
		` + (0, $acadbbff5345f996$export$753dee7e45dd587a) + `
</div>`;
const $06aef7bae2699b9e$export$6d778bf328f87a72 = function(data) {
    return (0, $acadbbff5345f996$export$4cfdd1f4e61f585d)() + `
<div style="padding:1rem">
<div class="Polaris-Page Polaris-Page--narrowWidth">			
	<div class="">
		<div class="Polaris-ShadowBevel" style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: &quot;&quot;; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);">
			<div class="Polaris-Box" style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)">
				<div class="Polaris-SettingAction">
					<div class="Polaris-SettingAction__Setting">
						<div class="Polaris-InlineStack" style="--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row">
							<div class="Polaris-BlockStack" style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-100)">
								<h2 class="Polaris-Text--root Polaris-Text--headingSm">										
									No store connected
								</h2>
								<span class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued">
									Description
								</span>									
							</div>
						</div>
					</div>
					<div class="Polaris-SettingAction__Action">
						<button class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter" type="button" external-link="` + data.redirect_url + `">
							<span class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium">
								Connect
							</span>
						</button>
					</div>
				</div>
				<div class="Polaris-Box" style="--pc-box-padding-block-start-xs: var(--p-space-400);">
					<span class="Polaris-Text--root Polaris-Text--bodyMd">
						<p>
							By clicking <strong>Connect</strong>, you agree to accept COPILOT <a class="Polaris-Link" data-polaris-unstyled="true" page-link="legal" >terms and conditions</a>.
						</p>
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
</div>`;
};
const $06aef7bae2699b9e$export$6d7842504d454b13 = (0, $acadbbff5345f996$export$4cfdd1f4e61f585d)(true) + `  
  <div style="padding:1rem">
    <div class="Polaris-LegacyStack Polaris-LegacyStack--vertical">
		<div class="Polaris-LegacyStack__Item">			
			<div class="Polaris-LegacyStack__Item">
				<h3 class="Polaris-Text--root Polaris-Text--headingXl">
					Terms & Policies
				</h3>
			</div>
		</div>
		<br/>
		<div class="Polaris-ShadowBevel" style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: &quot;&quot;; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);">
			<div class="Polaris-Box" style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)">				
				<div class="Polaris-LegacyStack__Item">	
					<p class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--caution">				
						This Terms & Policies were last modified on 20 / December / 2024.
					</p>
					<br/>
					<hr class="Polaris-Divider" style="border-block-start:var(--p-border-width-025) solid var(--p-color-border-secondary)">					
					<br/>
					<p class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--bold">SaaS License Agreement</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">This document constitutes a Software License Agreement (hereinafter referred to as the &ldquo;Agreement&rdquo;) granted by Beetrick Technologies S.L., whose registered office is located at 379th Muntaner Street 08021 Barcelona, registered under the NIF number </span><span>B67414102</span><span class="c0">&nbsp;in the Barcelona Registre Mercantil, (hereinafter referred to as &quot; BEETRICK&quot; or the &quot;PROVIDER&quot;) to any natural or legal person wishing to use the Software (hereinafter referred to as the &ldquo;CLIENT&rdquo; or &ldquo;You&rdquo;), collectively referred to as &ldquo;the Parties&rdquo; or individually as &ldquo;Party&rdquo;.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT is informed that the use of the Software is conditional upon acceptance of this Software License Agreement which contains all necessary and useful information to enable him/her to commit in full knowledge of the facts. Accordingly, the mere use of the Software constitutes acceptance by the CLIENT of the entirety of the terms and conditions of this Agreement.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">PREAMBLE</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">BEETRICK is a software developer that develops proprietary solutions whose licenses are marketed to its customers in the form of Software as a Service (hereinafter &quot;SaaS&quot;), which refers to the way in which the functionalities of a software solution are made available remotely, using Internet technologies and accessible via the Internet network. BEETRICK has developed Acumen Shift, a software enabling the Client to analyze and manage its e-commerce data, calculate and help monitor Key Performance Indicators (hereinafter the &quot;Software&quot;).</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">HAVING REGARD TO THE AFORESAID, IT IS AGREED AS FOLLOWS:</h6>
                    <p class="c1 c2"><span class="c3"></p>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 1 &ndash; DEFINITIONS</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&quot;Authorized Use&quot;: refers to the authorized use of the License by the CLIENT as defined in section 6 of the Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&ldquo;Connectors&rdquo; (or &ldquo;Data Connectors&rdquo;): refers to connector, like application programming interface, that enable to source data, such as online advertising platform, emailing software, web analytics service, which CLIENT might use in order to compute its marketing data. For example, Shopify, Google Analytics, Prestashop, Facebook Ads, etc. The list of available Connectors is accessible at https://www.acumenshift.com/connectors</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&quot;Data&quot;: refers to all information created, acquired, aggregated, or archived by or for the CLIENT, including personal data processed via the Software, as well as the results of processing carried out on the basis of such data via the said Software. The Data also refers to the data communicated by the CLIENT relating to its activities, know-how, etc. These data are confidential and are the exclusive property of the CLIENT for the data concerning him.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&quot;License&quot;: refers to the license as described in section 5 of the Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&quot;Object Code&quot;: refers to the series of machine-readable instructions (executable program) that are intended to be directly executed by a computer after appropriate processing and linking but without the compilation or assembly steps.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&ldquo;Support Assistance&rdquo;: refers to the support provided by the PROVIDER team with commercially reasonable efforts. This technical assistance is provided through Email, Intercom or Slack depending on the Pricing plan selected</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&quot;Software&quot; means the Software described in the Preamble of this Agreement, including all new versions, updates and modifications that may be developed after the date of signing the Agreement. By new versions and updates, we mean any improvements or evolutions of the existing functionalities of the Software, any corrections made to the Software. Software is accessible through a dashboard.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&quot;Source Code&quot;: includes for the Software (i) a complete presentation of operations and instructions, expressed in an advanced language that is understandable to a computer professional, (ii) the procedures and methods used to achieve this result and (iii) all the technical documentation attached to the Software.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&ldquo;Stores&rdquo;: refer to a Shopify or Prestashop store as defined by a unique store url (Note: 1 brand can have multiples stores for multiple countries served)</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&ldquo;Subscription Process&rdquo;: refers to the online process enable the CLIENT to subscribe to the SaaS.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&ldquo;Visit&rdquo;: refers to monthly sessions calculated by Google Analytics and showcased in Acumen Shift by &ldquo;Visits&rdquo; KPI under Key Indicators section.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 2 - CONTRACTUAL DOCUMENTS</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The rights and obligations of the Parties relating to the subject matter hereof shall be governed by the provisions of the Agreement, which shall include the body of this Agreement, as well as the schedules hereafter listed. &nbsp;The body of the Agreement should prevail over the others. Any modification of the Agreement shall be the subject of a written amendment agreed by mutual agreement between the Parties.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Agreement expresses the entire agreement of the Parties as to its purpose. It replaces any previous agreements, declaration, negotiation, commitment, communication, oral or written, or any general conditions of the CLIENT or the PROVIDER, regardless of the time and/or medium of their communication.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 3 &ndash; PURPOSE</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The purpose of the Agreement is to specify the terms and conditions under which the PROVIDER makes available to the CLIENT a License to use the Software.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 4 &ndash; DURATION</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Agreement takes effect upon the acceptation date of the terms and conditions provided herein for a term of 1 (one) month or 12 (twelve) months according to the choice made by the CLIENT during the Subscription Process, from the date of expiration of the Evaluation Period when applicable (&ldquo;Initial Subscription Period&rdquo;).</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">At the end of the term, the Agreement may be tacitly renewed for successive periods of 12 (twelve) months (&ldquo;Renewal Subscription Period&rdquo;), unless one of the Parties terminates the Agreement by email sent to the other Party at least 15 (fifteen) days before the end of the term, for the 1 month Agreement, or three (3) months before the term of the 1 (one) year Agreement or each renewal deadline.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">If the CLIENT, subscribed to a free trial, the Agreement shall take effect upon acceptation of the free trial by following the terms of Article 5.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 5 &ndash; FREE TRIAL</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">When the CLIENT subscribes for a free trial (&quot;Trial Account&quot;), the PROVIDER will make the Software available to the CLIENT on a trial basis free of charge for seven (7) days (the &ldquo;Evaluation Period&rdquo;) from the effective date of this subscription. If, at the end of the Evaluation Period, the CLIENT does not sign up for a paid subscription of the Services, the Agreement will automatically terminate unless BEETRICK agrees, in its sole discretion, to extend the Evaluation Period. Additional terms and conditions may appear on the registration website for a Trial Account and any such additional terms and conditions are incorporated into this Agreement by reference and are legally binding.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">ALL TRIAL ACCOUNTS ARE PROVIDED &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo; WITHOUT ANY WARRANTY OF ANY KIND. TRIAL ACCOUNTS MAY BE SUSPENDED, TERMINATED, OR DISCONTINUED AT ANY TIME AND FOR ANY REASON (OR NO REASON). THE PROVIDER DISCLAIMS ALL OBLIGATION AND LIABILITY UNDER THE AGREEMENT (INCLUDING LIABILITY OTHERWISE PROVIDED FOR UNDER ARTICLE 11 (LIMITATION &ndash; INSURANCE) FOR ANY HARM OR DAMAGE ARISING OUT OF OR IN CONNECTION WITH A TRIAL ACCOUNT, AND ANY CUSTOMIZATIONS MADE TO A TRIAL ACCOUNT BY OR FOR SUBSCRIBER, MAY BE PERMANENTLY LOST IF THE TRIAL ACCOUNT IS SUSPENDED, TERMINATED, OR DISCONTINUED.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 6 - USER LICENSE</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In exchange for payment of the license fees or, in regard to the Trial Account, upon acceptation by the CLIENT of this Agreement, the PROVIDER grants the CLIENT the non-exclusive and non-transferable right to use the Software, during the term of this Agreement. To this end, the PROVIDER provides the CLIENT with a license to use the Software, in SaaS mode, 24 hours a day, 7 days a week, subject to interruptions for maintenance reasons planned outside the CLIENT&#39;s usual working hours or interruptions due to a failure external to the PROVIDER, for the duration of the Agreement in return for the payment of the financial conditions as determined in Appendix 1. The Software remains on the PROVIDER&rsquo;s infrastructure. Thus, the latter does not, under any circumstances, give a copy of the Software, in any form or on any medium whatsoever, to the CLIENT. &nbsp;Appendix 1 describes the price evolution. Thus, the PROVIDER will apply the price corresponding to the chosen option during the Subscription Process.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In this respect, the CLIENT agrees to:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- use the solution only for the strict needs of its activity. The CLIENT shall take the necessary measures to ensure that users comply with the Authorized Use;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- not to modify, transfer, or distribute the license and not to correct any Error by itself, to disassemble, compile, decompile, reverse engineer or translate the Software, to use any of the components of the Software and/or any of the elements relating to this license separately from the Software, or to assign or sublicense the Software;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- copy the license only for the purpose of loading, displaying, executing, storing.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 7 - OBLIGATIONS OF THE PARTIES</h6>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">7.1. OBLIGATIONS OF THE PROVIDER</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The PROVIDER agrees to:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- make the Software available according to the terms and conditions agreed between the Parties;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- report to the CLIENT all elements or events of which it has become aware and which could compromise the proper performance of the services covered by the Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- maintain the Software to ensure its proper functioning, without taking any commitment on any level of service.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">7.2. CLIENT COOPERATION</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT agrees to cooperate loyally and actively with the PROVIDER and in particular to provide or facilitate the consultation of all the elements or documents that will be necessary for the performance of its services under the Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT agrees to pay the corresponding monthly or annual royalties, Trial Account excluded, of the license in accordance with the provisions of Appendix 1.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 8 - ASSISTANCE</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The technical assistance is provided through email, or a different way depending on the Pricing plan selected. The technical assistance is not intended to replace the installation services (for example: module activation, configuration workshop, etc.), training or advice of users or the CLIENT, which could be the subject of separate services and agreements, under a separate implementation and training service contract from this Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Any Error noted by the CLIENT and which would affect the Software will be notified in writing to the PROVIDER.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 9 - INTELLECTUAL PROPERTY</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The PROVIDER is the owner of all intellectual property rights relating to the Software and the accompanying documentation as well as all their updates, old, current and future versions, and all developments carried out by the PROVIDER.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Under no circumstances shall these rights be transferred to the CLIENT as a result of this Agreement. The CLIENT shall refrain from infringing in any way whatsoever the PROVIDER&#39;s intellectual property rights over the Software.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT is expressly prohibited from using or using the Software in a manner that does not comply with this Agreement. In particular, it is prohibited to:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- any reproduction of the Software in any form and on any type of medium whatsoever, in particular by modification, merging or inclusion in another software and/or modification of the accompanying documentation;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- any reproduction other than a backup copy, it being specified that the backup copies are the PROVIDER&#39;s property;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- any modification of the Software;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- any representation of the Software on any type of medium whatsoever;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- any provision of the Software in whole or in part and by any means, rental, transfer, etc;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- any disclosure, marketing or use of the Software for the benefit of third parties as well as any training of third parties in the use of all or part of the Software;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- any decompilation of the Software, subject to applicable legal provisions;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- any modification or intervention in the Software, whatever its nature, including for the purpose of correcting errors likely to affect the functioning of the Software, insofar as the right to correct such errors is reserved solely to the PROVIDER.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In general, the PROVIDER guarantees the CLIENT the peaceful enjoyment of the rights granted to him by the PROVIDER under the Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The PROVIDER agrees to guarantee the CLIENT against any action or claim on the basis of counterfeiting tending to restrict or prohibit the use of the Software that the PROVIDER will be required to provide to the CLIENT under the Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The above provisions are subject to the following express conditions:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- that the CLIENT has notified the PROVIDER, within a reasonable time, of the action or claim or declaration that preceded the dispute;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- that the PROVIDER has been able to defend freely and at his own expense the defense of his own interests as well as those of the CLIENT, and that, to this end, the latter has loyally collaborated in the said defense by providing, in due time, all the elements, information and assistance reasonably necessary to carry out such defense.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In the event that the prohibition of use of all or part of the Software that the PROVIDER is required to provide to the CLIENT under the Agreement is imposed as a result of any action, in particular for infringement, or results from a transaction signed with the plaintiff in such action, the PROVIDER shall endeavor, at its option and at its expense, to replace the latter at the latest within a period of 3 (three) months in order to avoid any risk of infringement, unfair competition or parasitical acts.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT guarantees the PROVIDER (i) against any action for infringement relating to the elements placed at its disposal by the CLIENT (ii) that it has obtained from third parties all the necessary authorizations allowing the PROVIDER to use the elements provided by third parties, placed at the PROVIDER&#39;s disposal by the CLIENT. In this respect, the CLIENT shall bear all damages to which the PROVIDER may be condemned by a court decision that has become final and based on an action for infringement, an action for unfair competition and/or parasitic acts and/or a failure to obtain the authorizations required from third parties by the CLIENT, tending to restrict or prohibit the use of the elements of which the CLIENT and the author or subject to authorization required from third parties, made available to the PROVIDER.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">EXCEPT TO THE PREVISOUS PROVISONS IN RELATION TO INTELLECTUAL PROPERTY, THE SOFTWARE IS PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo; BASIS WITHOUT ANY REPRESENTATIONS, WARRANTIES, COVENANTS, OR CONDITIONS OF ANY KIND (EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE), INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, TITLE, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. FURTHER, EXCEPT FOR THE SUPPORT ASSISTANCE, THE PROVIDER DOES NOT REPRESENT OR WARRANT THAT (A) THE ACCESS TO OR USE OF THE SOFTWARE WILL BE SECURE, TIMELY, UNINTERRUPTED, ERROR-FREE, OR OPERATE IN COMBINATION WITH ANY OTHER HARDWARE, SOFTWARE, SYSTEM, OR DATA, (B) ERRORS OR DEFECTS WILL BE CORRECTED, PATCHES OR WORKAROUNDS WILL BE PROVIDED, OR THE PROVIDER WILL DETECT ANY BUG IN THE SOFTWARE, (C) THE SOFTWARE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR (D) THIRD-PARTY DISRUPTIONS OR SECURITY BREACHES OF THE SOFTWARE WILL BE PREVENTED.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 10 &ndash; TERMINATION</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In the event of non-performance by a Party of any of its obligations under the Agreement, the other Party may terminate the Agreement, if it deems it appropriate, in its own rights &nbsp;by sending a registered letter with acknowledgement of receipt. Such termination may only take place after a formal notice has remained unsuccessful within a period of 10 (ten) working days, in regard to the 1 (one) month term, and 30 (thirty) days, in regard to the 12 (twelve) months term, without prejudice to any damages that may be awarded as a result of the aforementioned breaches.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Each Party is also entitled to terminate the Agreement, without incurring any liability to the other Party, by simple written notice to the latter&#39;s address, in the following cases:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- opening of insolvency proceedings or judicial liquidation or any judicial decision having equivalent effect and, in the cases provided for by law, after silence or refusal to opt for the continuation of the Agreement by the administrator or judicial liquidator;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- termination of activities for any reason whatsoever.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In the event of failure by the CLIENT to pay an amount due to the PROVIDER under the Agreement, the PROVIDER may terminate the Agreement by operation of law without any other formality than by sending a registered letter with acknowledgement of receipt.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Notwithstanding the termination or expiration of the Agreement, it is understood that the provisions of the Articles &quot;Liability&quot;, &quot;Intellectual Property&quot;, &quot;Non-solicitation of Personnel&quot; and &quot;Confidentiality&quot; shall survive such termination or expiration, for any reason whatsoever.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 11 - LIABILITY</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT is responsible for ensuring that the Software meets its needs. The CLIENT acknowledges that it has received from the PROVIDER all the necessary information enabling to assess the suitability of the Software for its needs.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT has decided to sign the Agreement after having read the software solutions proposed by the PROVIDER and verified their accounting according to its other equipment (hardware, software, configuration, etc.) and its needs. Thus, the PROVIDER may under no circumstances be held liable for direct or indirect damage of any kind suffered by the CLIENT due to the impossibility of using the software solutions, especially in case of interconnection problems with the Connectors, or inadequacy to its needs. Likewise, the PROVIDER should bear no responsibility incurred by the accuracy of the Data provided by the CLIENT, a latency of Data update (&ldquo;Data Refresh Hour&rdquo;) or incorrectness.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT acknowledges that the information provided within the use of the Software are of general range and that they are meant to be used to help the CLIENT manage marketing metrics. Such information can under no circumstances replace a marketing analysis, therefore, the CLIENT is solely liable to assess whether the content available through the Software is suitable for its needs.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The PROVIDER&#39;s role is to provide a Software License, the use of which is left to the discretion and responsibility of the CLIENT. a result, the PROVIDER is not liable for damages such as financial, commercial, customer loss, any commercial disturbance, loss of profit, loss of brand image, loss of data, files or software suffered by the CLIENT, increase in charges, cost of services necessary to implement or correct the data or results obtained, which could result from the non-performance of the Agreement, which damages are deemed to have the nature of indirect damages.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">IN NO EVENT SHALL THE AGGREGATE LIABILITY OF EACH PARTY ARISING OUT OF OR RELATED TO THIS AGREEMENT EXCEED THE TOTAL AMOUNT PAID BY CLIENT HEREUNDER FOR THE SERVICES GIVING RISE TO THE LIABILITY IN THE TWELVE MONTHS PRECEDING THE FIRST INCIDENT OUT OF WHICH THE LIABILITY AROSE. THE FOREGOING LIMITATION WILL APPLY WHETHER AN ACTION IS IN CONTRACT OR TORT AND REGARDLESS OF THE THEORY OF LIABILITY, BUT WILL NOT LIMIT CLIENT&rsquo;S AND ITS AFFILIATES&rsquo; PAYMENT OBLIGATIONS UNDER ARTICLE 16 BELOW.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">IN NO EVENT WILL EITHER PARTY OR ITS AFFILIATES HAVE ANY LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT FOR ANY LOST PROFITS, REVENUES, GOODWILL, OR INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, COVER, BUSINESS INTERRUPTION OR PUNITIVE DAMAGES, WHETHER AN ACTION IS IN CONTRACT OR TORT AND REGARDLESS OF THE THEORY OF LIABILITY, EVEN IF A PARTY OR ITS AFFILIATES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR IF A PARTY&rsquo;S OR ITS AFFILIATES&rsquo; REMEDY OTHERWISE FAILS OF ITS ESSENTIAL PURPOSE. THE FOREGOING DISCLAIMER WILL NOT APPLY TO THE EXTENT PROHIBITED BY LAW.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 12 - DATA PROTECTION</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT&#39;s Data and databases, whether or not containing personal data, to which the PROVIDER may have access in the performance of the Agreement, are the exclusive property of the CLIENT. These Data and databases are strictly confidential in accordance with the terms of the article &quot;Confidentiality&quot;.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The PROVIDER shall refrain from infringing the CLIENT&#39;s property rights relating to the aforementioned Data and databases and, in this respect, shall refrain from communicating them to third parties, from reproducing them, from carrying out extractions (unless these operations are part of the services covered by the Agreement or following an express and prior request by the CLIENT), or from infringing the security of the processing of these Data.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In general, the PROVIDER shall maintain and comply with adequate technical security measures to protect the CLIENT&#39;s Data, to which the PROVIDER may have access in the performance of the Agreement, against any accidental or unlawful destruction or accidental loss, damage, alterations, disclosure or unauthorized access, in particular when the processing involves the transmission of data or databases over a network, and against any other form of unlawful processing.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">To the extent PROVIDER processes any CLIENT Personal Data (as defined in Appendix 2) contained in CLIENT Data on behalf of CLIENT, the terms of the Data Processing Addendum which are incorporated in Appendix 2 by reference, will apply and the parties agree to comply with such terms.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 13 - FORCE MAJEURE</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Parties shall not be held liable for any breach of any of their obligations under the Agreement resulting from the occurrence of an event of force majeure, as defined by the case law of the Spanish courts. In this case, the obligations of the Parties shall be suspended from the notification of this exonerating cause by one of the Parties to the other Party until its termination.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">To the extent that such circumstances continue for a period of more than 1 (one) month, the Parties agree to enter into discussions with a view to amending the terms of their respective commitments.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">If no agreement or alternative is possible, these commitments may then be terminated by the Party whose obligations are not affected by the event of force majeure, without damages, by simple written notification by registered letter with acknowledgement of receipt, without compensation or notice.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 14 &ndash; CONFIDENTIALITY</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Each of the Parties acknowledges that they will communicate to each other (and to their officers, employees, consultants and subcontractors who may have a direct need to know such information) (together the &quot;Authorized Persons&quot;) certain technical, commercial, financial or other information relating to their respective activities, as well as the Agreement and all its Annexes and amendments, whether such information has been delivered in writing, orally or by any other means (the &quot;Confidential Information&quot;) under the Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In order to protect the confidentiality of the Confidential Information, each Party agrees, under the terms of the Agreement, to:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- maintain the Confidential Information in absolute confidentiality and not to disclose it to any third party to the Agreement (other than Authorized Persons), subject to the prior written consent of the Party that owns the Confidential Information concerned;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- use the Confidential Information only in the context of the Agreement, and therefore to refrain from any other use, directly or indirectly, in any form whatsoever, either for itself or on behalf of any third party;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- ensure that Authorized Persons to whom all or part of the Confidential Information has been communicated, are informed by that Party of the obligations under the Agreement relating to such Confidential Information;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- return, at the request of either Party, any Confidential Information in its possession, and destroy any copies of any Confidential Information in its possession (however, this obligation does not extend to documents or reports prepared on the basis of the Confidential Information or incorporating certain Confidential Information, provided that such documents and reports remain confidential under the conditions stipulated in the above paragraphs).</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Provided that the obligations referred to in the above paragraphs shall not apply to Confidential Information provided by a Party which:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- have fallen into the public domain at the time of their communication or subsequent to their communication, provided, in the latter case, that such communication is not the result of a breach of confidentiality by the Party having had knowledge of the Confidential Information concerned;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- were known by the other Party in a legitimate and peaceful manner, prior to the date on which such Confidential Information was communicated to it;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- shall be provided by the other Party pursuant to any applicable law or regulation or at the request of any supervisory or regulatory body, administration or courts;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- are legitimately obtained by the Receiving Party from a third part which, by making such disclosure, does not breach any obligation of confidentiality;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- are developed autonomously by the Receiving Party;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- are disclosed by the disclosing Party to a third party without any obligation of confidentiality;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">This obligation of confidentiality applies for the entire duration of the Agreement and for a period of two (2) years upon expiry or termination of the Agreement, for any reason whatsoever.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Provider will respond with data requests within 72 hours and you may ask for data to be permanently deleted, with written confirmation after it is completed.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 15 - PRICES</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT shall pay the amounts stated in the contract as the agreed-upon price for the services provided. These amounts are monthly or annual fees for licenses, depending on various conditions, such as the number of visits, orders, the level of data accuracy and specific features the CLIENT wishes to have.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Any amount unpaid on the due date shall bear interest for late payment, subject to prior formal notice to pay, sent by registered letter with acknowledgement of receipt, which shall remain without effect for a period of 5 (five) working days following its receipt, at the rate of 3 (three) times the legal interest rate in force on the due date.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">More generally, any supply or service not expressly defined in the Agreement will be invoiced under the terms of the amendment governing it.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In general, the CLIENT shall not reimburse any expenses incurred by the PROVIDER under the Agreement without his express prior written consent.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The PROVIDER remains free to change the agreed-upon price, as well as the structure and modalities of its pricing if and only if the PROVIDER informs the CLIENT 60 (sixty) days prior to the Renewal Subscription Period. Such change cannot occur during the ongoing subscription period.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">When using the online payment service, the PROVIDER may use the services of the company Stripe. To this end, the CLIENT authorizes the PROVIDER to transmit personal data to its partner, like CLIENT details (Name, registration date), and any other documents or information relating to our regulatory obligations in the fight against money laundering and terrorist financing. Stripe&#39;s general terms and conditions and privacy policy are available at: . Stripe Ltd. is authorized by the Financial Conduct Authority (FCA) as a payment institution in accordance with the Payment Services Regulations 2009. FCA reference is FRN 580343.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 16 - NON-SOLICITATION</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The CLIENT expressly refrains from soliciting, with a view to hiring or subcontracting, any employee of the PROVIDER, for the entire duration of the Agreement and the 12 (twelve) months following its termination, regardless of the cause. This prohibition also applies during the 12 (twelve) months following the end date of an employee&#39;s employment contract, regardless of the cause. In the event of an infringement of this prohibition, following a poaching and/or an offer made, the defaulting Party shall be required to pay the other Party, as a penalty clause, a lump-sum indemnity equal to 12 (twelve) times the last gross monthly salary of the requested person, plus the costs incurred in recruiting a replacement.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">ARTICLE 17 - GENERAL PROVISIONS</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Transfer. No change in the legal form of either Party and/or in the capital structure of either Party, including change in corporate form, merger, takeover or change of control, may affect the performance of the Agreement.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">No waiver. The absence of sanction by one of the parties of a breach of a provision of this Agreement or failure to comply with the time of performance of an obligation to perform does not mean that it waives its right to sanction any prior or subsequent breach of the same or any other provision.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Notifications. All notices required to be given to either Party under this Agreement shall be in writing and delivered by hand during normal business hours or by registered mail with return receipt during normal business hours to the respective addresses indicated on the cover page of this document, which the Parties shall choose for the delivery or sending of notices, communications or legal proceedings arising under this Agreement. The Parties shall have the right to replace such address with another physical address, which shall take effect 30 (thirty) days after the other Party has been given written notice.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Applicable law and dispute resolution. This Agreement is subject to French law and the competent courts of Paris. Before any litigation is taken, the Parties shall seek, in good faith, to settle amicably their disputes relating to the validity, performance and interpretation of the Agreement. The Parties shall meet to discuss their points of view and make any relevant findings to enable them to find a solution to the conflict between them. The Parties shall endeavor to reach an amicable agreement within thirty (30) days of notification by one of them of the need for an amicable agreement by registered letter with acknowledgement of receipt.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">APPENDIX 1: FINANCIAL CONDITIONS OF THE SERVICE</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Base Price:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Pending</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Additional Information:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">All plans are billed monthly based on usage, with no commitment and the flexibility to adjust as needs evolve.</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">For more detailed information or to estimate specific pricing, contact our sales team for a personalized quote, especially for the Corporate plans with fixed pricing options.</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Note: All prices are exclusive of applicable taxes. Payment terms are net 30 days from the invoice date unless otherwise specified in the agreement. Any changes to this pricing structure will be communicated to the Client with reasonable advance notice.</p>
                    <br/>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">APPENDIX 2: DATA PROTECTION AND SECURITY MEASURES</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Ownership and Confidentiality of Client Data: All Client data and databases, including any containing personal data, to which the Provider gains access during the execution of the Agreement, shall remain the sole and exclusive property of the Client. This data and databases shall be considered confidential under the terms of the &quot;Confidentiality&quot; article in the Agreement.</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Restrictions on Provider&#39;s Use of Data: The Provider will not infringe upon the Client&#39;s proprietary rights regarding the aforementioned data and databases. Specifically, the Provider will not disclose this data to third parties, reproduce it, extract it (unless these activities are part of the services covered by the Agreement or are done following an express prior request from the Client), or breach the security measures in place for processing this data.</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Technical Security Measures: The Provider will maintain and adhere to adequate technical security measures to safeguard the Client&#39;s data from accidental or unlawful destruction, loss, alteration, unauthorized disclosure or access, and any other form of unlawful processing. These security measures apply especially during the transmission of data over a network.</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Data Processing Addendum: If the Provider processes any Client Personal Data contained within the Client&#39;s Data on behalf of the Client, the terms of the Data Processing Addendum, which is incorporated into this Appendix by reference, will apply. Both parties agree to comply with these terms.</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Please note that &quot;Client Personal Data&quot; will be defined in the Data Processing Addendum.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">All data handling procedures will adhere to applicable local and international data protection laws and regulations, to ensure the maximum possible protection of the Client&#39;s data</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&zwj;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--bold">Data Processing Agreement</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In the context of their contractual relations, the Parties undertake to comply with the regulations in force applicable to the processing of personal data and, in particular, Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 applicable as from 25 May 2018 (hereinafter referred to as the &quot;GDPR&quot;), as well as Law No 78-17 of 6 January 1978 on data processing, files and freedoms (hereinafter referred to as the amended &quot;Data Protection Act&quot;). The purpose of this Annex is to define the conditions under which the processor undertakes to carry out on behalf of the controller the processing operations of personal data defined below.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">I. Definitions of the terms</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">For the purposes of this Agreement, the following terms shall have the following meaning:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&bull; &quot;Personal Data&quot; means any information relating to an identified or identifiable natural person; an &quot;identifiable natural person&quot; is defined as a natural person who can be identified, directly or indirectly, in particular by reference to an identification number or to one or more elements unique to him/her. In order to determine whether a person is identifiable, all means of identification available or accessible to the Data Controller or any other person must be considered.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&bull; &quot;Data Subject&quot; refers to a natural person whose Personal Data are processed.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&bull; &quot;Data Controller&quot; means the CLIENT, who determines the purposes and means of the Personal Data Processing.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&bull; &quot;Data Processor&quot; refers to the PROVIDER who processes Personal Data under the authority, on instructions and on behalf of the Data Controller.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&bull; &quot;Processing&quot; means any operation or set of operations involving Personal Data by the Data Processor on behalf of the Data Controller, regardless of the process used, and in particular the collection, recording, organization, structuring, storage, adaptation or modification, extraction, consultation, use, communication by transmission, dissemination or any other form of making available, reconciliation or interconnection, as well as limitation, deletion or destruction.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&bull; &quot;Personal Data Breach&quot; means a security breach resulting in the accidental or unlawful destruction, loss, alteration, unauthorized disclosure of, or unauthorized access to, Personal Data transmitted, stored or otherwise processed.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">II. Obligations of the Data Controller</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Data Controller acknowledges and guarantees:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- that the Processing is carried out in accordance with the provisions of the GDPR and the Data Protection Act, in particular, that the Data Subject has been informed of the purpose of the Processing, his rights, the recipients of the Personal Data and the policy on the protection of privacy and personal data;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- only in the event that the Data Controller processes &quot;sensitive&quot; data as defined in Article 9 of the GDPR (i.e. the Processing of personal data revealing racial or ethnic origin, political opinions, religious or philosophical beliefs or trade union membership, as well as the Processing of genetic data, biometric data for the purpose of uniquely identifying a natural person, data concerning health or data concerning the sex life or sexual orientation of a natural person), the Data Controller has collected them and requires the Data Processor to carry out their Processing, in full compliance with the provisions of the said Article 9;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- that it will respond as soon as possible to any Data Protection Authority requests for information, if any;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- that it will respond, as soon as possible, to requests from any Data Subject by the Processing, to communicate information on its Personal Data and that it will give appropriate instructions to the Data Processor, in due course.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- The Data Controller also undertakes to:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">o document in writing any instructions concerning the Processing of Personal Data by the Data Processor;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">o ensure, in advance and throughout the duration of the Processing, that the Data Processor complies with the obligations provided for in the European Data Protection Regulation;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">o supervise the Processing, including carrying out audits and inspections of the Data Processor.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">III. Obligations of the Data Processor</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Data Processor undertakes to:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- process the data only for the purposes indicated by the Data Controller;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- if the Data Processor considers that an investigation constitutes a violation of the European Data Protection Regulation or any other provision of Union law or of the law of the Member States relating to data protection, it shall immediately inform the Data Controller. In addition, if the Data Processor is required to transfer data to a third country or international organization, under the law of the Union or the law of the Member State to which it is subject, it must inform the Data Controller of this legal obligation before the Processing, unless the law concerned prohibits such information for important reasons of public interest;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- guarantee the confidentiality of the personal data processed under this Agreement;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- ensure that the persons authorized to process personal data under this Agreement:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- undertake to respect confidentiality or are subject to an appropriate legal obligation of confidentiality;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- receive the necessary training in the protection of personal data;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- consider, with regard to its tools, products, applications or services, the principles of privacy by design and data protection by default;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- inform its employees of their responsibility regarding the protection of Personal Data, in particular as regards the confidentiality of such data;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- in the event of a possible legal, administrative or judicial prohibition that could prevent it from carrying out the Processing, the Data Processor shall inform the Data Controller and may then terminate the Agreement, without the Data Controller being able to hold the Data Processor liable or claim damages from him;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- cooperate with the CNIL in the event of a request for information from the latter and that it will comply with any recommendation of the CNIL relating to the Processing.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">1. Subcontracting</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Data Processor may use another subcontractor (hereinafter, the &quot;Subprocessor&quot;) to carry out specific Processing activities. In this case, he/she shall inform the Data Controller in advance and in writing of any planned change concerning the addition or replacement of other Subprocessors. This information must clearly indicate the subcontracted Processing Activities, the identity and contact details of the Subprocessor and the dates of the subcontract. The Data Controller has a minimum period of one (1) month from the date of receipt of this information to present his objections. This subcontracting may only be carried out if the Data Controller has not raised any objection within the agreed period.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Subprocessor is required to comply with the obligations of this Agreement on behalf of and in accordance with the instructions of the Data Controller. It is the initial Data Processor&#39;s responsibility to ensure that the Subprocessor provides the same sufficient guarantees as to the implementation of appropriate technical and organizational measures so that the Processing operation complies with the requirements of the European Data Protection Regulation. If the subsequent processor does not fulfill its data protection obligations, the initial Data Processor remains fully liable to the Data Controller for the performance by the subsequent processor of its obligations.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Acumen Shift is committed to transparency in its use of subcontractors and the services they provide. </p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&zwj;</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Data Processor (Acumen Shift) remains fully liable to the Data Controller for the performance of the Subprocessor&#39;s obligations. We conduct regular reviews and audits to ensure our subcontractors&rsquo; adherence to these obligations.</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&zwj;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Should more detailed information about the roles, locations, or specific data security and privacy practices of these subcontractors be required, we are ready to provide this upon request.</p>
                    <br/>
                    <br/>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">2. Right of data subjects to be informed</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">It is the responsibility of the Data Controller to provide the information to the Data Subjects on the Processing operations at the time of data collection.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">3. Exercise of data subject&rsquo;s rights</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Data Controller grants requests to exercise the rights of the Data Subjects (right of access, rectification, deletion and opposition, right to limit the Processing, right to data portability, right not to be the subject of an automated individual decision, including profiling) and will give appropriate instructions to the Data Processor in due course. As far as possible, the Data Processor shall assist the Data Controller in fulfilling his obligation to comply with requests to exercise the rights of the Data Subjects.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">4. Notification of Personal Data Breaches</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Data Processor shall notify the Data Controller of any breach of personal data as soon as possible and, at the latest, 72 hours after becoming aware of it. This notification shall be accompanied by all relevant documentation in order to enable the Data Controller, if necessary, to notify this Violation to the competent supervisory authority.The Data Processor must take all necessary steps to identify the causes of such Personal Data Violation and take all measures that it deems necessary and reasonable to remedy the origin of such Violation when such remedy is under the control of the Data Processor.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">5. Security measures</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">The Data Processor must at all times have technical and organizational measures in place to prevent unauthorized access to the Personal Data and the use of the Personal Data for purposes other than those agreed for their transmission to the Data Processor. The Data Processor represents and warrants that the security measures taken are in no event less than those required by applicable law or those that a person performing the same activity as the Data Processor would reasonably have taken for the protection of Personal Data against unauthorized access or use.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In cases where the Data Processor has obtained the prior consent of the Data Controller for the transmission of Personal Data to a third party, the Data Processor must again take appropriate security measures to ensure the secure transmission of the Personal Data. &nbsp;The Data Processor must protect and maintain the Personal Data as confidential information. The confidentiality requirements required by each of the commercial documents and/or confidentiality agreements signed between the Data Controller and the Data Processor must apply to the Personal Data.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">VI. Termination and Data Deletion</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">In accordance with Article 28.f. of the General Data Protection Regulation (GDPR), the following terms are agreed upon regarding the termination of processing services and the handling of personal data:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Data Deletion upon Termination of Processing Services: Upon the termination of the processing services for any reason, Acumen Shift, acting as the Data Processor, commits to deleting all personal data processed on behalf of the Data Controller, subject to this Data Processing Agreement. This deletion will be executed as soon as reasonably possible, in a manner that ensures the complete erasure of all such personal data, in accordance with the Data Controller&#39;s instructions and the provisions of the GDPR.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Acumen Shift will confirm the completion of this data deletion process to the Data Controller in writing, ensuring that no personal data remains within Acumen Shift&#39; systems or any subprocessors&#39; systems, unless required by law.</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">&zwj;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--bold">Website Privacy Policy</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from thegrowthteam.co (the &ldquo;Site&rdquo;).</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">PERSONAL INFORMATION WE COLLECT</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site. We refer to this automatically-collected information as &ldquo;Device Information.&rdquo;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">We collect Device Information using the following technologies:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- &ldquo;Cookies&rdquo; are data files that are placed on your device or computer and often include an anonymous unique identifier. For more information about cookies, and how to disable cookies, visit http://www.allaboutcookies.org. &nbsp;</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- &ldquo;Log files&rdquo; track actions occurring on the Site, and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps. &nbsp;</p>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">- &ldquo;Web beacons,&rdquo; &ldquo;tags,&rdquo; and &ldquo;pixels&rdquo; are electronic files used to record information about how you browse the Site.</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Additionally when you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including your name, billing address, shipping address, payment information (including credit card numbers), email address, and phone number. &nbsp;We refer to this information as &ldquo;Order Information.&rdquo;</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">When we talk about &ldquo;Personal Information&rdquo; in this Privacy Policy, we are talking both about Device Information and Order Information.</p>
                    <br/>
                    <h6 class="Polaris-Text--root Polaris-Text--headingXs">CHANGES</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.</p>
                    <br/>
                        <h6 class="Polaris-Text--root Polaris-Text--headingXs">CONTACT US</h6>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at administration@acumenshift.com or by mail using the details provided below:</p>
                    <br/>
                    <p class="Polaris-Text--root Polaris-Text--bodySm">Carre Muntaner 379, 08021, Barcelona. SPAIN</p>
					<br/>
				</div>
			</div>
		</div>		
	</div>
  </div>`;
const $06aef7bae2699b9e$export$c8e6049b3c4afc5 = function(data) {
    var page = (0, $acadbbff5345f996$export$4cfdd1f4e61f585d)() + `
<div style="padding:1rem">
<div class="Polaris-Page Polaris-Page--fullWidth">`;
    if (data && data.created_at) {
        const d = new Date(data.created_at.replace(" ", "T"));
        const h = new Date();
        const diff = (h - d) / 86400000;
        if (diff <= 7) page += (0, $acadbbff5345f996$export$21a308e09fbaaed4);
    }
    page += `<div class="Polaris-LegacyStack__Item">
<div class="Polaris-InlineGrid" style="--pc-inline-grid-grid-template-columns-xs:1fr auto">	
	<div class="Polaris-LegacyStack__Item">
		<h3 class="Polaris-Text--root Polaris-Text--headingXl">
			Dashboard
		</h3>
	</div>` + (0, $acadbbff5345f996$export$6293e6144ca02c8d) + `
	</div>
</div>	
  <div class="Polaris-Page__Content">
    <div class="Polaris-Grid">`;
    if (data && data.hasOwnProperty("indicators")) data.indicators.forEach((i)=>{
        page += (0, $acadbbff5345f996$export$f5695fbbba4e5525)(i);
    });
    page += `
    </div>` + (0, $acadbbff5345f996$export$5331ed028a5d769e) + `
  </div>
</div>
</div>
` + (0, $acadbbff5345f996$export$a6cb52a96ce3e2) + `
</div>`;
    return page;
};
const $06aef7bae2699b9e$export$fb614e1a95434ae = (0, $acadbbff5345f996$export$4cfdd1f4e61f585d)() + `
<div style="padding:1rem">
   <div class="Polaris-Page__Content">
      <div class="Polaris-Grid">
         <div class="Polaris-Grid-Cell 
            Polaris-Grid-Cell--cell_1ColumnXs 
            Polaris-Grid-Cell--cell_1ColumnSm 
            Polaris-Grid-Cell--cell_2ColumnMd 
            Polaris-Grid-Cell--cell_4ColumnLg 
            Polaris-Grid-Cell--cell_4ColumnXl"></div>
         <div class="Polaris-Grid-Cell 
            Polaris-Grid-Cell--cell_4ColumnXs 
            Polaris-Grid-Cell--cell_4ColumnSm 
            Polaris-Grid-Cell--cell_2ColumnMd 
            Polaris-Grid-Cell--cell_4ColumnLg 
            Polaris-Grid-Cell--cell_4ColumnXl">
            <div class="Polaris-ShadowBevel" style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: &quot;&quot;; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);">
            <div class="Polaris-Box" style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)">
               <div class="Polaris-BlockStack" style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)">
                  <div class="Polaris-FormLayout__Item Polaris-FormLayout--grouped">
                     <div class="">
                        <div class="Polaris-Labelled__LabelWrapper">
                           <div class="Polaris-Label">
                              <label id=":R2q6:Label" for=":R2q6:" class="Polaris-Label__Text">
                              <span class="Polaris-Text--root Polaris-Text--bodyMd">Email</span>
                              </label>
                           </div>
                        </div>
                        <div class="Polaris-Connected">
                           <div class="Polaris-Connected__Item Polaris-Connected__Item--primary">
                              <div class="Polaris-TextField">
                                 <input id="email" autocomplete="email" class="Polaris-TextField__Input" type="text" aria-labelledby=":R2q6:Label" aria-invalid="false" data-1p-ignore="true" data-lpignore="true" data-form-type="other" value="">
                                 <div class="Polaris-TextField__Backdrop">
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="Polaris-FormLayout__Item Polaris-FormLayout--grouped">
                     <div class="">
                        <div class="Polaris-Labelled__LabelWrapper">
                           <div class="Polaris-Label">
                              <label id=":R4q6:Label" for=":R4q6:" class="Polaris-Label__Text">
                              <span class="Polaris-Text--root Polaris-Text--bodyMd">Password</span>
                              </label>
                           </div>
                        </div>
                        <div class="Polaris-Connected">
                           <div class="Polaris-Connected__Item Polaris-Connected__Item--primary">
                              <div class="Polaris-TextField">
                                 <input id="password" autocomplete="password" class="Polaris-TextField__Input" type="password" aria-labelledby=":R4q6:Label" aria-invalid="false" value="">
                                 <div class="Polaris-TextField__Backdrop">
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="Polaris-PageActions">
                  <div class="Polaris-LegacyStack Polaris-LegacyStack--spacingTight Polaris-LegacyStack--distributionEqualSpacing">
					 <div class="Polaris-LegacyStack__Item">
						<a class="Polaris-Link" data-polaris-unstyled="true" page-link="register"><span class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium Polaris-Text--subdued" style="text-decoration:underline;">Create an accout</span></a>                        
                     </div>
                     <div class="Polaris-LegacyStack__Item">
                        <button class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter" type="button" form-link="login">
                        <span class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium">Login</span>
                        </button>
                     </div>
                  </div>
               </div>
            </div>
            </div>
         </div>
         <div class="Polaris-Grid-Cell 
            Polaris-Grid-Cell--cell_1ColumnXs 
            Polaris-Grid-Cell--cell_1ColumnSm 
            Polaris-Grid-Cell--cell_2ColumnMd 
            Polaris-Grid-Cell--cell_4ColumnLg 
            Polaris-Grid-Cell--cell_4ColumnXl"></div>
      </div>
   </div>
   ` + (0, $acadbbff5345f996$export$a6cb52a96ce3e2) + `
</div>
`;
const $06aef7bae2699b9e$export$489edd6ea54d502e = (0, $acadbbff5345f996$export$4cfdd1f4e61f585d)(true) + `
<div style="padding:1rem">
   <div class="Polaris-Page__Content">
    <div class="Polaris-LegacyStack__Item">			
        <div class="Polaris-LegacyStack__Item">
            <h3 class="Polaris-Text--root Polaris-Text--headingXl">
                Create a new account
            </h3>
        </div>
    </div>
    <br/>
      <div class="Polaris-Grid">
         <div class="Polaris-Grid-Cell 
            Polaris-Grid-Cell--cell_1ColumnXs 
            Polaris-Grid-Cell--cell_1ColumnSm 
            Polaris-Grid-Cell--cell_2ColumnMd 
            Polaris-Grid-Cell--cell_4ColumnLg 
            Polaris-Grid-Cell--cell_4ColumnXl"></div>
         <div class="Polaris-Grid-Cell 
            Polaris-Grid-Cell--cell_4ColumnXs 
            Polaris-Grid-Cell--cell_4ColumnSm 
            Polaris-Grid-Cell--cell_2ColumnMd 
            Polaris-Grid-Cell--cell_4ColumnLg 
            Polaris-Grid-Cell--cell_4ColumnXl">
            <div class="Polaris-ShadowBevel" style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: &quot;&quot;; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);">
            <div class="Polaris-Box" style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)">
               <div class="Polaris-BlockStack" style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)">
                  <div class="Polaris-FormLayout__Item Polaris-FormLayout--grouped">
                     <div class="">                        
                        <div class="Polaris-Labelled__LabelWrapper">
                           <div class="Polaris-Label">
                              <label id=":R2q6:Label" for=":R2q6:" class="Polaris-Label__Text">
                              <span class="Polaris-Text--root Polaris-Text--bodyMd">Company name</span>
                              </label>
                           </div>
                        </div>
                        <div class="Polaris-Connected">
                           <div class="Polaris-Connected__Item Polaris-Connected__Item--primary">
                              <div class="Polaris-TextField">
                                 <input id="company" autocomplete="company" class="Polaris-TextField__Input" type="text" aria-labelledby=":R2q6:Label" aria-invalid="false" data-1p-ignore="true" data-lpignore="true" data-form-type="other" value="">
                                 <div class="Polaris-TextField__Backdrop">
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div id="companyError" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: this field is required.</span>
                        </div>
                     </div>
                  </div>
                  <div class="Polaris-FormLayout__Item Polaris-FormLayout--grouped">
                     <div class="">                        
                        <div class="Polaris-Labelled__LabelWrapper">
                           <div class="Polaris-Label">
                              <label id=":R2q6:Label" for=":R2q6:" class="Polaris-Label__Text">
                              <span class="Polaris-Text--root Polaris-Text--bodyMd">Phone</span>
                              </label>
                           </div>
                        </div>
                        <div class="Polaris-Connected">
                           <div class="Polaris-Connected__Item Polaris-Connected__Item--primary">
                              <div class="Polaris-TextField">
                                 <input id="phone" autocomplete="phone" class="Polaris-TextField__Input" type="text" aria-labelledby=":R2q6:Label" aria-invalid="false" data-1p-ignore="true" data-lpignore="true" data-form-type="other" value="">
                                 <div class="Polaris-TextField__Backdrop">
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div id="phoneError" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: this field is required.</span>
                        </div>
                     </div>
                  </div>
                  <div class="Polaris-FormLayout__Item Polaris-FormLayout--grouped">
                     <div class="">                        
                        <div class="Polaris-Labelled__LabelWrapper">
                           <div class="Polaris-Label">
                              <label id=":R2q6:Label" for=":R2q6:" class="Polaris-Label__Text">
                              <span class="Polaris-Text--root Polaris-Text--bodyMd">Email</span>
                              </label>
                           </div>
                        </div>
                        <div class="Polaris-Connected">
                           <div class="Polaris-Connected__Item Polaris-Connected__Item--primary">
                              <div class="Polaris-TextField">
                                 <input id="email" autocomplete="email" class="Polaris-TextField__Input" type="text" aria-labelledby=":R2q6:Label" aria-invalid="false" data-1p-ignore="true" data-lpignore="true" data-form-type="other" value="">
                                 <div class="Polaris-TextField__Backdrop">
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div id="emailError" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: invalid email format.</span>
                        </div>
                     </div>
                  </div>
                  <div class="Polaris-FormLayout__Item Polaris-FormLayout--grouped">
                     <div class="">
                        <div class="Polaris-Labelled__LabelWrapper">
                           <div class="Polaris-Label">
                              <label id=":R4q6:Label" for=":R4q6:" class="Polaris-Label__Text">
                              <span class="Polaris-Text--root Polaris-Text--bodyMd">Password</span>
                              </label>
                           </div>
                        </div>
                        <div class="Polaris-Connected">
                           <div class="Polaris-Connected__Item Polaris-Connected__Item--primary">
                              <div class="Polaris-TextField">
                                 <input id="password" class="Polaris-TextField__Input" type="password" aria-labelledby=":R4q6:Label" aria-invalid="false" value="">
                                 <div class="Polaris-TextField__Backdrop">
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div id="passwordErrorLength" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: password must be at least 10 characters long.</span>
                        </div>
                        <div id="passwordErrorLower" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: password must contain a lower case letter.</span>
                        </div>
                        <div id="passwordErrorUpper" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: password must contain an upper case letter.</span>
                        </div>
                        <div id="passwordErrorNumber" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: password must contain a number.</span>
                        </div>
                        <div id="passwordErrorSymbol" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: password must contain a symbol (!@#$%^&*()_+-=[]{};':",|,.<>\/?).</span>
                        </div>                      
                     </div>
                  </div>
                  <div class="Polaris-FormLayout__Item Polaris-FormLayout--grouped">
                     <div class="">                        
                        <div class="Polaris-Labelled__LabelWrapper">
                           <div class="Polaris-Label">
                              <label id=":R4q6:Label" for=":R4q6:" class="Polaris-Label__Text">
                              <span class="Polaris-Text--root Polaris-Text--bodyMd">Confirm password</span>
                              </label>
                           </div>
                        </div>
                        <div class="Polaris-Connected">
                           <div class="Polaris-Connected__Item Polaris-Connected__Item--primary">
                              <div class="Polaris-TextField">
                                 <input id="confirm-password" class="Polaris-TextField__Input" type="password" aria-labelledby=":R4q6:Label" aria-invalid="false" value="">
                                 <div class="Polaris-TextField__Backdrop">
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div id="confirm-passwordError" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: passwords do not match.</span>
                        </div>
                     </div>
                  </div>
                  <div class="Polaris-FormLayout__Item Polaris-FormLayout--grouped">
                     <div class="">                        
                        <label class="Polaris-Choice Polaris-Checkbox__ChoiceLabel" for="legal">
                          <span class="Polaris-Choice__Control">
                            <span class="Polaris-Checkbox">
                              <input id="legal" type="checkbox" class="Polaris-Checkbox__Input" aria-invalid="false" role="checkbox" aria-checked="false" value="">
                              <span class="Polaris-Checkbox__Backdrop">
                              </span>
                              <span class="Polaris-Checkbox__Icon Polaris-Checkbox--animated">
                                <svg viewBox="0 0 16 16" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
                                  <path class="" d="M1.5,5.5L3.44655,8.22517C3.72862,8.62007,4.30578,8.64717,4.62362,8.28044L10.5,1.5" transform="translate(2 2.980376)" opacity="0" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" pathLength="1">
                                  </path>
                                </svg>
                              </span>
                            </span>
                          </span>
                          <span class="Polaris-Choice__Label">
                            <span class="Polaris-Text--root Polaris-Text--bodyMd">I agree to terms and conditions</span>
                          </span>
                        </label>
                        <div id="legalError" class="Polaris-InlineError">
                          <div class="Polaris-InlineError__Icon">
                            <span class="Polaris-Icon">
                              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                <path d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z">
                                </path>
                                <path d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z">
                                </path>
                                <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                                </path>
                              </svg>
                            </span>
                          </div>
                          <span class="Polaris-Text--root Polaris-Text--bodyMd">Error: this field is required.</span>
                        </div>
                     </div>
                  </div>
               </div>               
               <div class="Polaris-PageActions">
                  <div class="Polaris-LegacyStack Polaris-LegacyStack--spacingTight Polaris-LegacyStack--distributionEqualSpacing">
					 <div class="Polaris-LegacyStack__Item">
                        <span>&nbsp;</span>						                        
                     </div>
                     <div class="Polaris-LegacyStack__Item">
                        <button class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter" type="button" form-link="register">
                            <span class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium">Register</span>
                        </button>
                     </div>                     
                  </div>
               </div>               
            </div>
            </div>
            </div>
         </div>
         <div class="Polaris-Grid-Cell 
            Polaris-Grid-Cell--cell_1ColumnXs 
            Polaris-Grid-Cell--cell_1ColumnSm 
            Polaris-Grid-Cell--cell_2ColumnMd 
            Polaris-Grid-Cell--cell_4ColumnLg 
            Polaris-Grid-Cell--cell_4ColumnXl"></div>
      </div>
   </div>
      ` + (0, $acadbbff5345f996$export$a6cb52a96ce3e2) + `
</div>
`;


const $e97cba310f9fb1f8$export$5375cda95f0b0eb4 = function(response) {
    if (response == null) return 0, $06aef7bae2699b9e$export$f5f2b7216332d86e;
    var responseJSON = JSON.parse(response);
    if (responseJSON == null) return "<b>ERROR</b>";
    var view = responseJSON.view;
    var data = responseJSON.data;
    switch(view){
        case "oauth":
            window.parent.location.href = data.redirect_url;
            return 0, $06aef7bae2699b9e$export$f5f2b7216332d86e;
        case "login":
            //return connectStorePage(data);
            return 0, $06aef7bae2699b9e$export$fb614e1a95434ae;
        case "dashboard":
            return (0, $06aef7bae2699b9e$export$c8e6049b3c4afc5)(data);
        case "legal":
            return 0, $06aef7bae2699b9e$export$6d7842504d454b13;
        case "register":
            return 0, $06aef7bae2699b9e$export$489edd6ea54d502e;
        default:
            return 0, $06aef7bae2699b9e$export$f5f2b7216332d86e;
    }
};


var $100c5217902afe6f$exports = {};

$100c5217902afe6f$exports = (parcelRequire("bzBXX"));


var $6f0d7d2ff668f179$exports = {};
"use strict";
var $6f0d7d2ff668f179$var$__createBinding = $6f0d7d2ff668f179$exports && $6f0d7d2ff668f179$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6f0d7d2ff668f179$var$__exportStar = $6f0d7d2ff668f179$exports && $6f0d7d2ff668f179$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6f0d7d2ff668f179$var$__createBinding(exports1, m, p);
};
Object.defineProperty($6f0d7d2ff668f179$exports, "__esModule", {
    value: true
});

$6f0d7d2ff668f179$var$__exportStar((parcelRequire("5s8Tb")), $6f0d7d2ff668f179$exports);

$6f0d7d2ff668f179$var$__exportStar((parcelRequire("6dZZq")), $6f0d7d2ff668f179$exports);

$6f0d7d2ff668f179$var$__exportStar((parcelRequire("bJVCp")), $6f0d7d2ff668f179$exports);

$6f0d7d2ff668f179$var$__exportStar((parcelRequire("4c77K")), $6f0d7d2ff668f179$exports);


const $c02e0243b19c8ca7$var$content = document.getElementById("content");
const $c02e0243b19c8ca7$var$queryString = window.location.search;
const $c02e0243b19c8ca7$var$reloadInnerHtmlEvent = new CustomEvent('content-changed');
document.addEventListener("DOMContentLoaded", function() {
    $c02e0243b19c8ca7$var$view("dashboard");
//console.log(window['app-bridge']);
//var AppBridge = window.AppBridge;
//console.log(AppBridge);
});
function $c02e0243b19c8ca7$var$initializeAppBridge() {
    console.log("initialize");
    $c02e0243b19c8ca7$var$view("dashboard");
}
// Función que ejecuta la verificación cada 500ms
function $c02e0243b19c8ca7$var$checkAppBridgeLoaded() {
    console.log("initialize");
    if (typeof window['app-bridge'] !== 'undefined') $c02e0243b19c8ca7$var$initializeAppBridge(); // Llamar a la función cuando App Bridge esté disponible
    else // Si App Bridge no está cargado, intenta de nuevo después de 500ms
    setTimeout($c02e0243b19c8ca7$var$checkAppBridgeLoaded, 500);
}
// Comienza a verificar si App Bridge se ha cargado
//setTimeout(checkAppBridgeLoaded, 500);
document.addEventListener("click", function(e) {
    var element = e.target.closest('[page-link]');
    if (element) $c02e0243b19c8ca7$var$view(element.getAttribute("page-link"));
    else {
        element = e.target.closest('[external-link]');
        if (element) $c02e0243b19c8ca7$var$redirect(element.getAttribute("external-link"));
        else {
            element = e.target.closest('[form-link]');
            if (element) {
                if (element.getAttribute("form-link") == "login") {
                    var email = document.getElementById("email").value;
                    var password = document.getElementById("password").value;
                    $c02e0243b19c8ca7$var$makeAPIRequest($c02e0243b19c8ca7$var$queryString, {
                        "action": element.getAttribute("form-link"),
                        "email": email,
                        "password": password
                    }, function(response) {
                        $c02e0243b19c8ca7$var$content.innerHTML = (0, $e97cba310f9fb1f8$export$5375cda95f0b0eb4)(response);
                    });
                } else if (element.getAttribute("form-link") == "register") {
                    let error = false;
                    //************//
                    var company = document.getElementById("company");
                    if (company.value != undefined && company.value != "") {
                        company.parentElement.classList.remove('Polaris-TextField--error');
                        document.getElementById("companyError").style.display = 'none';
                    } else {
                        error = true;
                        company.parentElement.classList.add('Polaris-TextField--error');
                        document.getElementById("companyError").style.display = 'flex';
                    }
                    //************//
                    var phone = document.getElementById("phone");
                    if (phone.value != undefined && phone.value != "") {
                        phone.parentElement.classList.remove('Polaris-TextField--error');
                        document.getElementById("phoneError").style.display = 'none';
                    } else {
                        error = true;
                        phone.parentElement.classList.add('Polaris-TextField--error');
                        document.getElementById("phoneError").style.display = 'flex';
                    }
                    //************//
                    var email = document.getElementById("email");
                    var hasErrors = $c02e0243b19c8ca7$var$validateEmail(email.value);
                    if (hasErrors) {
                        email.parentElement.classList.add('Polaris-TextField--error');
                        error = true;
                    } else email.parentElement.classList.remove('Polaris-TextField--error');
                    //************//
                    var password = document.getElementById("password");
                    var hasErrors = $c02e0243b19c8ca7$var$passwordValidation(password.value);
                    if (hasErrors) {
                        error = true;
                        password.parentElement.classList.add('Polaris-TextField--error');
                    } else password.parentElement.classList.remove('Polaris-TextField--error');
                    //************//
                    var confirmPassword = document.getElementById("confirm-password");
                    if (confirmPassword.value != undefined && confirmPassword.value != "" && confirmPassword.value == password.value) {
                        confirmPassword.parentElement.classList.remove('Polaris-TextField--error');
                        document.getElementById("confirm-passwordError").style.display = 'none';
                    } else {
                        error = true;
                        confirmPassword.parentElement.classList.add('Polaris-TextField--error');
                        document.getElementById("confirm-passwordError").style.display = 'flex';
                    }
                    //************//
                    var legal = document.getElementById("legal");
                    if (legal.checked) {
                        legal.parentElement.classList.remove('Polaris-Checkbox--error');
                        document.getElementById("legalError").style.display = 'none';
                    } else {
                        error = true;
                        legal.parentElement.classList.add('Polaris-Checkbox--error');
                        document.getElementById("legalError").style.display = 'flex';
                    }
                    //************//
                    if (error == false) $c02e0243b19c8ca7$var$makeAPIRequest($c02e0243b19c8ca7$var$queryString, {
                        "action": element.getAttribute("form-link"),
                        "company": company.value,
                        "phone": phone.value,
                        "email": email.value,
                        "password": password.value,
                        "confirmPassword": confirmPassword.value,
                        "legal": legal.value
                    }, function(response) {
                        $c02e0243b19c8ca7$var$content.innerHTML = (0, $e97cba310f9fb1f8$export$5375cda95f0b0eb4)(response);
                    });
                } else console.log("error");
            } else {
                element = e.target.closest('[dismiss]');
                //console.log(element.getAttribute("dismiss"));
                if (element) document.getElementById(element.getAttribute("dismiss")).style.display = 'none';
            }
        }
    }
});
function $c02e0243b19c8ca7$var$validateEmail(value) {
    let hasErrors = false;
    // Función interna para mostrar/ocultar mensajes de error y añadir/quitar la clase de error
    function toggleError(isValid, errorElement) {
        errorElement.style.display = isValid ? 'none' : 'flex';
        if (!isValid) hasErrors = true;
    }
    // Check symbol
    toggleError($c02e0243b19c8ca7$var$containsEmail(value), document.getElementById("emailError"));
    return hasErrors;
}
function $c02e0243b19c8ca7$var$validateCompany(value) {
    let hasErrors = false;
    // Función interna para mostrar/ocultar mensajes de error y añadir/quitar la clase de error
    function toggleError(isValid, errorElement) {
        errorElement.style.display = isValid ? 'none' : 'flex';
        if (!isValid) hasErrors = true;
    }
    // Check symbol
    toggleError(value.length >= 1, document.getElementById("companyError"));
    return hasErrors;
}
function $c02e0243b19c8ca7$var$validatePhone(value) {
    let hasErrors = false;
    // Función interna para mostrar/ocultar mensajes de error y añadir/quitar la clase de error
    function toggleError(isValid, errorElement) {
        errorElement.style.display = isValid ? 'none' : 'flex';
        if (!isValid) hasErrors = true;
    }
    // Check symbol
    toggleError(value.length >= 1, document.getElementById("phoneError"));
    return hasErrors;
}
function $c02e0243b19c8ca7$var$view(name, filter = "1") {
    // LOADING	
    $c02e0243b19c8ca7$var$content.innerHTML = (0, $e97cba310f9fb1f8$export$5375cda95f0b0eb4)();
    var data = {
        "action": name,
        "filter": filter
    };
    // REQUEST
    $c02e0243b19c8ca7$var$makeAPIRequest($c02e0243b19c8ca7$var$queryString, data, function(response) {
        $c02e0243b19c8ca7$var$content.innerHTML = (0, $e97cba310f9fb1f8$export$5375cda95f0b0eb4)(response);
        $c02e0243b19c8ca7$var$content.dispatchEvent($c02e0243b19c8ca7$var$reloadInnerHtmlEvent);
        $c02e0243b19c8ca7$var$checkDashboardFilters(response);
    });
}
function $c02e0243b19c8ca7$var$checkDashboardFilters(response) {
    var responseJSON = JSON.parse(response);
    if (responseJSON != null) {
        if (responseJSON.data != undefined && responseJSON.data.filter != undefined) {
            const selectedOption = document.getElementById('select-input');
            selectedOption.value = responseJSON.data.filter;
            console.log(selectedOption.value);
            const option = selectedOption.querySelector('option[value="' + responseJSON.data.filter + '"]');
            document.getElementById('selected-option').innerText = option.text;
            document.getElementById('selected-option').setAttribute("data-value", option.value);
        }
    }
}
//TODO: hauria de mirar si la app està embedded o no
function $c02e0243b19c8ca7$var$redirect(url) {
    // escape iframe, 
    //window.parent.location.href = url;
    window.open(url, '_blank');
}
function $c02e0243b19c8ca7$var$makeAPIRequest(data, action, callback) {
    // Primer s'ha d'autenticar la session token utilitzant app bridge
    //const { createApp } = window.AppBridge;
    //console.log(createApp);
    //var AppBridge = window['app-bridge'];
    //var AppBridgeUtils = window['app-bridge-utils'];
    // GET host param
    var params = new URLSearchParams(data);
    var host = params.get("host");
    if (host) {
        var app = (0, (/*@__PURE__*/$parcel$interopDefault($100c5217902afe6f$exports)))({
            apiKey: '4402cea6f981f7afe1ea33ba55f804c5',
            host: host
        });
        $c02e0243b19c8ca7$var$shopifyGetSessionToken(app, data, action, callback);
    /*const sessionToken = await getSessionToken(app);
        var sessionToken = AppBridge.utilities.getSessionToken(app).then(token => {
            if(token) {
                // Request to ACUMEN API
                var xhr = new XMLHttpRequest();
                xhr.open("POST", "api.php", true);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.setRequestHeader("Authorization", "Bearer " + token);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        callback(xhr.responseText);
                    } else if (xhr.readyState === 4 && xhr.status !== 200) {
                        callback("error");
                    }
                };

                // Datos a enviar en la petición POST
                var payload = prepareData(data, action);
                xhr.send(payload);
            }
        });*/ }
/**/ //console.log(AppBridge.actions);
/*const AppBridge = window['app-bridge'];

    const app = AppBridge.createApp({
        apiKey:'xxxxxxx',
        host:'YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUvd2hhdGV2ZXIteW91ci1zdG9yZS1pcy1jYWxsZWQ='
    });

    var sessionToken = await AppBridge.utilities.getSessionToken(app);
    console.log(sessionToken);*/ }
async function $c02e0243b19c8ca7$var$shopifyGetSessionToken(app, data, action, callback) {
    try {
        const sessionToken = await (0, $6f0d7d2ff668f179$exports.getSessionToken)(app); // Esperamos que se resuelva la promesa
        console.log("Token de sesi\xf3n recibido:", sessionToken);
        // Aquí puedes hacer lo que necesites con el sessionToken
        // Por ejemplo, verificar si el token es válido
        if (sessionToken) // Realizar acciones adicionales con el sessionToken
        $c02e0243b19c8ca7$var$hacerAlgoConElToken(sessionToken, data, action, callback);
        else console.log("No se recibi\xf3 un token de sesi\xf3n v\xe1lido.");
    } catch (error) {
        console.error("Error al obtener el token de sesi\xf3n:", error);
    }
}
function $c02e0243b19c8ca7$var$hacerAlgoConElToken(token, data, action, callback) {
    // Request to ACUMEN API
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "api.php", true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("Authorization", "Bearer " + token);
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) callback(xhr.responseText);
        else if (xhr.readyState === 4 && xhr.status !== 200) callback("error");
    };
    // Datos a enviar en la petición POST
    var payload = $c02e0243b19c8ca7$var$prepareData(data, action);
    xhr.send(payload);
}
/*function shopifyGetSessionToken(element) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve("token123"); // Simulamos un token de autenticación
        }, 2000); // Demora 2 segundos para obtener el token
    });
}*/ //TODO: validate data
function $c02e0243b19c8ca7$var$prepareData(rawData, customData) {
    // Traiem ? i afegim action
    rawData = rawData.substring(1);
    Object.keys(customData).forEach((key)=>{
        rawData += "&" + key + "=" + customData[key];
    });
    console.log(rawData);
    return rawData;
}
document.addEventListener('change', function(event1) {
    // Verifica si el evento ocurrió en el select específico
    if (event1.target && event1.target.id === 'select-input') $c02e0243b19c8ca7$var$updateSelect(event1.target);
    else // validation remove error classes in register
    if (event1.target) {
        if (event1.target.type == "checkbox") event1.target.parentElement.classList.remove('Polaris-Checkbox--error');
        else if (event1.target.type == "password" || event1.target.type == "text") event1.target.parentElement.classList.remove('Polaris-TextField--error');
    }
});
function $c02e0243b19c8ca7$var$updateSelect(select) {
    const selectedOption = select.options[select.selectedIndex];
    document.getElementById('selected-option').innerText = selectedOption.text;
    document.getElementById('selected-option').setAttribute("data-value", selectedOption.value);
    $c02e0243b19c8ca7$var$view("dashboard", selectedOption.value);
}
$c02e0243b19c8ca7$var$content.addEventListener('content-changed', function() {
    var company = document.getElementById("company");
    if (company) company.addEventListener("input", function(e) {
        let hasErrors = $c02e0243b19c8ca7$var$validateCompany(event.target.value);
        // Añadir o quitar la clase de error en el contenedor
        if (hasErrors) company.parentElement.classList.add('Polaris-TextField--error');
        else company.parentElement.classList.remove('Polaris-TextField--error');
    });
    var phone = document.getElementById("phone");
    if (phone) phone.addEventListener("input", function(e) {
        let hasErrors = $c02e0243b19c8ca7$var$validatePhone(event.target.value);
        // Añadir o quitar la clase de error en el contenedor
        if (hasErrors) phone.parentElement.classList.add('Polaris-TextField--error');
        else phone.parentElement.classList.remove('Polaris-TextField--error');
    });
    var email = document.getElementById("email");
    if (email) email.addEventListener("input", function(e) {
        let hasErrors = $c02e0243b19c8ca7$var$validateEmail(event.target.value);
        // Añadir o quitar la clase de error en el contenedor
        if (hasErrors) email.parentElement.classList.add('Polaris-TextField--error');
        else email.parentElement.classList.remove('Polaris-TextField--error');
    });
    var password = document.getElementById("password");
    if (password) password.addEventListener("input", function(e) {
        let hasErrors = $c02e0243b19c8ca7$var$passwordValidation(event.target.value);
        // Añadir o quitar la clase de error en el contenedor
        if (hasErrors) password.parentElement.classList.add('Polaris-TextField--error');
        else password.parentElement.classList.remove('Polaris-TextField--error');
    });
    var confirmPassword = document.getElementById("confirm-password");
    if (confirmPassword) confirmPassword.addEventListener("input", function(e) {
        if (confirmPassword.value != undefined && confirmPassword.value != "" && password.value == confirmPassword.value) {
            confirmPassword.parentElement.classList.remove('Polaris-TextField--error');
            document.getElementById("confirm-passwordError").style.display = 'none';
        }
    });
    var legal = document.getElementById("legal");
    if (legal) legal.addEventListener("input", function(e) {
        if (legal.checked) {
            legal.parentElement.classList.remove('Polaris-TextField--error');
            document.getElementById("legalError").style.display = 'none';
        }
    });
});
function $c02e0243b19c8ca7$var$passwordValidation(value) {
    let hasErrors = false;
    // Función interna para mostrar/ocultar mensajes de error y añadir/quitar la clase de error
    function toggleError(isValid, errorElement) {
        errorElement.style.display = isValid ? 'none' : 'flex';
        if (!isValid) hasErrors = true;
    }
    // Check length
    toggleError(value.length >= 10, document.getElementById("passwordErrorLength"));
    // Check lower
    toggleError($c02e0243b19c8ca7$var$containsLowercase(value), document.getElementById("passwordErrorLower"));
    // Check upper
    toggleError($c02e0243b19c8ca7$var$containsUppercase(value), document.getElementById("passwordErrorUpper"));
    // Check number
    toggleError($c02e0243b19c8ca7$var$containsNumber(value), document.getElementById("passwordErrorNumber"));
    // Check symbol
    toggleError($c02e0243b19c8ca7$var$containsSymbol(value), document.getElementById("passwordErrorSymbol"));
    return hasErrors;
}
// Funciones de validación
function $c02e0243b19c8ca7$var$containsEmail(str) {
    return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(str);
}
function $c02e0243b19c8ca7$var$containsLowercase(str) {
    return /[a-z]/.test(str);
}
function $c02e0243b19c8ca7$var$containsUppercase(str) {
    return /[A-Z]/.test(str);
}
function $c02e0243b19c8ca7$var$containsNumber(str) {
    return /[0-9]/.test(str);
}
function $c02e0243b19c8ca7$var$containsSymbol(str) {
    return /[!@#$%^&*()_+\-=\[\]{};':",\\|,.<>\/?]/.test(str);
}


//# sourceMappingURL=index.072fad3e.js.map
